function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var joiBrowser_min = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t() ;
  }(self, () => {
    return e = {
      7629: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(9474),
              i = r(1687),
              o = r(8652),
              l = r(8160),
              c = r(3292),
              u = r(6354),
              f = r(8901),
              h = r(9708),
              m = r(6914),
              d = r(2294),
              p = r(6133),
              g = r(1152),
              y = r(8863),
              b = r(2036),
              v = {
          Base: class {
            constructor(e) {
              this.type = e, this.$_root = null, this._definition = {}, this._reset();
            }

            _reset() {
              this._ids = new d.Ids(), this._preferences = null, this._refs = new p.Manager(), this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map(), this.$_terms = {}, this.$_temp = {
                ruleset: null,
                whens: {}
              };
            }

            describe() {
              return s("function" == typeof h.describe, "Manifest functionality disabled"), h.describe(this);
            }

            allow() {
              for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

              return l.verifyFlat(t, "allow"), this._values(t, "_valids");
            }

            alter(e) {
              s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
              const t = this.clone();
              t.$_terms.alterations = t.$_terms.alterations || [];

              for (const r in e) {
                const n = e[r];
                s("function" == typeof n, "Alteration adjuster for", r, "must be a function"), t.$_terms.alterations.push({
                  target: r,
                  adjuster: n
                });
              }

              return t.$_temp.ruleset = !1, t;
            }

            artifact(e) {
              return s(void 0 !== e, "Artifact cannot be undefined"), s(!this._cache, "Cannot set an artifact with a rule cache"), this.$_setFlag("artifact", e);
            }

            cast(e) {
              return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
            }

            default(e, t) {
              return this._default("default", e, t);
            }

            description(e) {
              return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
            }

            empty(e) {
              const t = this.clone();
              return void 0 !== e && (e = t.$_compile(e, {
                override: !1
              })), t.$_setFlag("empty", e, {
                clone: !1
              });
            }

            error(e) {
              return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
            }

            example(e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return s(void 0 !== e, "Missing example"), l.assertOptions(t, ["override"]), this._inner("examples", e, {
                single: !0,
                override: t.override
              });
            }

            external(e, t) {
              return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
                method: e,
                description: t
              }, {
                single: !0
              });
            }

            failover(e, t) {
              return this._default("failover", e, t);
            }

            forbidden() {
              return this.presence("forbidden");
            }

            id(e) {
              return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
            }

            invalid() {
              for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

              return this._values(t, "_invalids");
            }

            label(e) {
              return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
            }

            meta(e) {
              return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
                single: !0
              });
            }

            note() {
              for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

              s(t.length, "Missing notes");

              for (const e of t) s(e && "string" == typeof e, "Notes must be non-empty strings");

              return this._inner("notes", t);
            }

            only() {
              let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
            }

            optional() {
              return this.presence("optional");
            }

            prefs(e) {
              s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
              const t = this.clone();
              return t._preferences = l.preferences(t._preferences, e), t;
            }

            presence(e) {
              return s(["optional", "required", "forbidden"].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
            }

            raw() {
              let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              return this.$_setFlag("result", e ? "raw" : void 0);
            }

            result(e) {
              return s(["raw", "strip"].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
            }

            required() {
              return this.presence("required");
            }

            strict(e) {
              const t = this.clone(),
                    r = void 0 !== e && !e;
              return t._preferences = l.preferences(t._preferences, {
                convert: r
              }), t;
            }

            strip() {
              let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              return this.$_setFlag("result", e ? "strip" : void 0);
            }

            tag() {
              for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

              s(t.length, "Missing tags");

              for (const e of t) s(e && "string" == typeof e, "Tags must be non-empty strings");

              return this._inner("tags", t);
            }

            unit(e) {
              return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
            }

            valid() {
              for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

              l.verifyFlat(t, "valid");
              const s = this.allow(...t);
              return s.$_setFlag("only", !!s._valids, {
                clone: !1
              }), s;
            }

            when(e, t) {
              const r = this.clone();
              r.$_terms.whens || (r.$_terms.whens = []);
              const n = c.when(r, e, t);

              if (!["any", "link"].includes(r.type)) {
                const e = n.is ? [n] : n.switch;

                for (const t of e) s(!t.then || "any" === t.then.type || t.then.type === r.type, "Cannot combine", r.type, "with", t.then && t.then.type), s(!t.otherwise || "any" === t.otherwise.type || t.otherwise.type === r.type, "Cannot combine", r.type, "with", t.otherwise && t.otherwise.type);
              }

              return r.$_terms.whens.push(n), r.$_mutateRebuild();
            }

            cache(e) {
              s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache"), s(void 0 === this._flags.artifact, "Cannot cache a rule with an artifact");
              const t = this.clone();
              return t._cache = e || o.provider.provision(), t.$_temp.ruleset = !1, t;
            }

            clone() {
              const e = Object.create(Object.getPrototypeOf(this));
              return this._assign(e);
            }

            concat(e) {
              s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
              let t = this.clone();

              if ("any" === this.type && "any" !== e.type) {
                const r = e.clone();

                for (const e of Object.keys(t)) "type" !== e && (r[e] = t[e]);

                t = r;
              }

              t._ids.concat(e._ids), t._refs.register(e, p.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);

              for (const r of e._singleRules.keys()) t._singleRules.has(r) && (t._rules = t._rules.filter(e => e.keep || e.name !== r), t._singleRules.delete(r));

              for (const r of e._rules) e._definition.rules[r.method].multi || t._singleRules.set(r.name, r), t._rules.push(r);

              if (t._flags.empty && e._flags.empty) {
                t._flags.empty = t._flags.empty.concat(e._flags.empty);
                const r = Object.assign({}, e._flags);
                delete r.empty, i(t._flags, r);
              } else if (e._flags.empty) {
                t._flags.empty = e._flags.empty;
                const r = Object.assign({}, e._flags);
                delete r.empty, i(t._flags, r);
              } else i(t._flags, e._flags);

              for (const r in e.$_terms) {
                const s = e.$_terms[r];
                s ? t.$_terms[r] ? t.$_terms[r] = t.$_terms[r].concat(s) : t.$_terms[r] = s.slice() : t.$_terms[r] || (t.$_terms[r] = s);
              }

              return this.$_root._tracer && this.$_root._tracer._combine(t, [this, e]), t.$_mutateRebuild();
            }

            extend(e) {
              return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
            }

            extract(e) {
              return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
            }

            fork(e, t) {
              s(!this._inRuleset(), "Cannot fork inside a ruleset");
              let r = this;

              for (let s of [].concat(e)) s = Array.isArray(s) ? s : s.split("."), r = r._ids.fork(s, t, r);

              return r.$_temp.ruleset = !1, r;
            }

            rule(e) {
              const t = this._definition;
              l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
              const r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
              s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
              const a = this.clone();

              for (let i = r; i < a._rules.length; ++i) {
                const r = a._rules[i],
                      o = n(r);

                for (const n in e) t.modifiers[n](o, e[n]), s(o.name === r.name, "Cannot change rule name");

                a._rules[i] = o, a._singleRules.get(o.name) === r && a._singleRules.set(o.name, o);
              }

              return a.$_temp.ruleset = !1, a.$_mutateRebuild();
            }

            get ruleset() {
              s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
              const e = this.clone();
              return e.$_temp.ruleset = e._rules.length, e;
            }

            get $() {
              return this.ruleset;
            }

            tailor(e) {
              e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
              let t = this;
              if (this.$_terms.alterations) for (const {
                target: r,
                adjuster: n
              } of this.$_terms.alterations) e.includes(r) && (t = n(t), s(l.isSchema(t), "Alteration adjuster for", r, "failed to return a schema object"));
              return t = t.$_modify({
                each: t => t.tailor(e),
                ref: !1
              }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
            }

            tracer() {
              return g.location ? g.location(this) : this;
            }

            validate(e, t) {
              return y.entry(e, this, t);
            }

            validateAsync(e, t) {
              return y.entryAsync(e, this, t);
            }

            $_addRule(e) {
              "string" == typeof e && (e = {
                name: e
              }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");

              for (const t in e) s("_" !== t[0], "Cannot set private rule properties");

              const t = Object.assign({}, e);
              t._resolve = [], t.method = t.method || t.name;
              const r = this._definition.rules[t.method],
                    n = t.args;
              s(r, "Unknown rule", t.method);
              const a = this.clone();

              if (n) {
                s(1 === Object.keys(n).length || Object.keys(n).length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);

                for (const e in n) {
                  let i = n[e];

                  if (r.argsByName) {
                    const o = r.argsByName.get(e);
                    if (o.ref && l.isResolvable(i)) t._resolve.push(e), a.$_mutateRegister(i);else if (o.normalize && (i = o.normalize(i), n[e] = i), o.assert) {
                      const t = l.validateArg(i, e, o);
                      s(!t, t, "or reference");
                    }
                  }

                  void 0 !== i ? n[e] = i : delete n[e];
                }
              }

              return r.multi || (a._ruleRemove(t.name, {
                clone: !1
              }), a._singleRules.set(t.name, t)), !1 === a.$_temp.ruleset && (a.$_temp.ruleset = null), r.priority ? a._rules.unshift(t) : a._rules.push(t), a;
            }

            $_compile(e, t) {
              return c.schema(this.$_root, e, t);
            }

            $_createError(e, t, r, s, n) {
              let a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
              const i = !1 !== a.flags ? this._flags : {},
                    o = a.messages ? m.merge(this._definition.messages, a.messages) : this._definition.messages;
              return new u.Report(e, t, r, i, o, s, n);
            }

            $_getFlag(e) {
              return this._flags[e];
            }

            $_getRule(e) {
              return this._singleRules.get(e);
            }

            $_mapLabels(e) {
              return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
            }

            $_match(e, t, r, s) {
              (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
              const n = !y.validate(e, this, t, r, s).errors;
              return t.restore(), n;
            }

            $_modify(e) {
              return l.assertOptions(e, ["each", "once", "ref", "schema"]), d.schema(this, e) || this;
            }

            $_mutateRebuild() {
              return s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset(), this.$_modify({
                each: (e, t) => {
                  let {
                    source: r,
                    name: s,
                    path: n,
                    key: a
                  } = t;
                  const i = this._definition[r][s] && this._definition[r][s].register;
                  !1 !== i && this.$_mutateRegister(e, {
                    family: i,
                    key: a
                  });
                }
              }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
            }

            $_mutateRegister(e) {
              let {
                family: t,
                key: r
              } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              this._refs.register(e, t), this._ids.register(e, {
                key: r
              });
            }

            $_property(e) {
              return this._definition.properties[e];
            }

            $_reach(e) {
              return this._ids.reach(e);
            }

            $_rootReferences() {
              return this._refs.roots();
            }

            $_setFlag(e, t) {
              let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
              const n = this._definition.flags[e] || {};
              if (a(t, n.default) && (t = void 0), a(t, this._flags[e])) return this;
              const i = !1 !== r.clone ? this.clone() : this;
              return void 0 !== t ? (i._flags[e] = t, i.$_mutateRegister(t)) : delete i._flags[e], "_" !== e[0] && (i.$_temp.ruleset = !1), i;
            }

            $_parent(e) {
              for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) r[s - 1] = arguments[s];

              return this[e][l.symbols.parent].call(this, ...r);
            }

            $_validate(e, t, r) {
              return y.validate(e, this, t, r);
            }

            _assign(e) {
              e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = n(this._singleRules, {
                shallow: !0
              }), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};

              for (const t in this.$_terms) e.$_terms[t] = this.$_terms[t] ? this.$_terms[t].slice() : null;

              e.$_super = {};

              for (const t in this.$_super) e.$_super[t] = this._super[t].bind(e);

              return e;
            }

            _bare() {
              const e = this.clone();

              e._reset();

              const t = e._definition.terms;

              for (const r in t) {
                const s = t[r];
                e.$_terms[r] = s.init;
              }

              return e.$_mutateRebuild();
            }

            _default(e, t) {
              let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = {
                [l.symbols.literal]: !0,
                literal: t
              }), this.$_setFlag(e, t);
            }

            _generate(e, t, r) {
              if (!this.$_terms.whens) return {
                schema: this
              };
              const s = [],
                    n = [];

              for (let a = 0; a < this.$_terms.whens.length; ++a) {
                const i = this.$_terms.whens[a];

                if (i.concat) {
                  s.push(i.concat), n.push("".concat(a, ".concat"));
                  continue;
                }

                const o = i.ref ? i.ref.resolve(e, t, r) : e,
                      l = i.is ? [i] : i.switch,
                      c = n.length;

                for (let c = 0; c < l.length; ++c) {
                  const {
                    is: u,
                    then: f,
                    otherwise: h
                  } = l[c],
                        m = "".concat(a).concat(i.switch ? "." + c : "");

                  if (u.$_match(o, t.nest(u, "".concat(m, ".is")), r)) {
                    if (f) {
                      const a = t.localize([...t.path, "".concat(m, ".then")], t.ancestors, t.schemas),
                            {
                        schema: i,
                        id: o
                      } = f._generate(e, a, r);

                      s.push(i), n.push("".concat(m, ".then").concat(o ? "(".concat(o, ")") : ""));
                      break;
                    }
                  } else if (h) {
                    const a = t.localize([...t.path, "".concat(m, ".otherwise")], t.ancestors, t.schemas),
                          {
                      schema: i,
                      id: o
                    } = h._generate(e, a, r);

                    s.push(i), n.push("".concat(m, ".otherwise").concat(o ? "(".concat(o, ")") : ""));
                    break;
                  }
                }

                if (i.break && n.length > c) break;
              }

              const a = n.join(", ");
              if (t.mainstay.tracer.debug(t, "rule", "when", a), !a) return {
                schema: this
              };
              if (!t.mainstay.tracer.active && this.$_temp.whens[a]) return {
                schema: this.$_temp.whens[a],
                id: a
              };
              let i = this;
              this._definition.generate && (i = this._definition.generate(this, e, t, r));

              for (const e of s) i = i.concat(e);

              return this.$_root._tracer && this.$_root._tracer._combine(i, [this, ...s]), this.$_temp.whens[a] = i, {
                schema: i,
                id: a
              };
            }

            _inner(e, t) {
              let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              s(!this._inRuleset(), "Cannot set ".concat(e, " inside a ruleset"));
              const n = this.clone();
              return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : n.$_terms[e].push(...t), n.$_temp.ruleset = !1, n;
            }

            _inRuleset() {
              return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
            }

            _ruleRemove(e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              if (!this._singleRules.has(e)) return this;
              const r = !1 !== t.clone ? this.clone() : this;

              r._singleRules.delete(e);

              const s = [];

              for (let t = 0; t < r._rules.length; ++t) {
                const n = r._rules[t];
                n.name !== e || n.keep ? s.push(n) : r._inRuleset() && t < r.$_temp.ruleset && --r.$_temp.ruleset;
              }

              return r._rules = s, r;
            }

            _values(e, t) {
              l.verifyFlat(e, t.slice(1, -1));
              const r = this.clone(),
                    n = e[0] === l.symbols.override;
              if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b() : n && (r[t] = e.length ? new b() : null, r.$_mutateRebuild()), !r[t]) return r;
              n && r[t].override();

              for (const n of e) {
                s(void 0 !== n, "Cannot call allow/valid/invalid with undefined"), s(n !== l.symbols.override, "Override must be the first value");
                const e = "_invalids" === t ? "_valids" : "_invalids";
                r[e] && (r[e].remove(n), r[e].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", n, "leaves schema rejecting all values due to previous valid rule"), r[e] = null)), r[t].add(n, r._refs);
              }

              return r;
            }

          }
        };
        v.Base.prototype[l.symbols.any] = {
          version: l.version,
          compile: c.compile,
          root: "$_root"
        }, v.Base.prototype.isImmutable = !0, v.Base.prototype.deny = v.Base.prototype.invalid, v.Base.prototype.disallow = v.Base.prototype.invalid, v.Base.prototype.equal = v.Base.prototype.valid, v.Base.prototype.exist = v.Base.prototype.required, v.Base.prototype.not = v.Base.prototype.invalid, v.Base.prototype.options = v.Base.prototype.prefs, v.Base.prototype.preferences = v.Base.prototype.prefs, e.exports = new v.Base();
      },
      8652: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(8160),
              i = {
          max: 1e3,
          supported: new Set(["undefined", "boolean", "number", "string"])
        };
        t.provider = {
          provision: e => new i.Cache(e)
        }, i.Cache = class {
          constructor() {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            a.assertOptions(e, ["max"]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || i.max, this._map = new Map(), this._list = new i.List();
          }

          get length() {
            return this._map.size;
          }

          set(e, t) {
            if (null !== e && !i.supported.has(typeof e)) return;

            let r = this._map.get(e);

            if (r) return r.value = t, void this._list.first(r);
            r = this._list.unshift({
              key: e,
              value: t
            }), this._map.set(e, r), this._compact();
          }

          get(e) {
            const t = this._map.get(e);

            if (t) return this._list.first(t), n(t.value);
          }

          _compact() {
            if (this._map.size > this._max) {
              const e = this._list.pop();

              this._map.delete(e.key);
            }
          }

        }, i.List = class {
          constructor() {
            this.tail = null, this.head = null;
          }

          unshift(e) {
            return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
          }

          first(e) {
            e !== this.head && (this._remove(e), this.unshift(e));
          }

          pop() {
            return this._remove(this.tail);
          }

          _remove(e) {
            const {
              next: t,
              prev: r
            } = e;
            return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
          }

        };
      },
      8160: (e, t, r) => {

        const s = r(375),
              n = r(7916),
              a = r(5934);
        let i, o;
        const l = {
          isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
        };
        t.version = a.version, t.defaults = {
          abortEarly: !0,
          allowUnknown: !1,
          artifacts: !1,
          cache: !0,
          context: null,
          convert: !0,
          dateFormat: "iso",
          errors: {
            escapeHtml: !1,
            label: "path",
            language: null,
            render: !0,
            stack: !1,
            wrap: {
              label: '"',
              array: "[]"
            }
          },
          externals: !0,
          messages: {},
          nonEnumerables: !1,
          noDefaults: !1,
          presence: "optional",
          skipFunctions: !1,
          stripUnknown: !1,
          warnings: !1
        }, t.symbols = {
          any: Symbol.for("@hapi/joi/schema"),
          arraySingle: Symbol("arraySingle"),
          deepDefault: Symbol("deepDefault"),
          errors: Symbol("errors"),
          literal: Symbol("literal"),
          override: Symbol("override"),
          parent: Symbol("parent"),
          prefs: Symbol("prefs"),
          ref: Symbol("ref"),
          template: Symbol("template"),
          values: Symbol("values")
        }, t.assertOptions = function (e, t) {
          let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "Options";
          s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
          const n = Object.keys(e).filter(e => !t.includes(e));
          s(0 === n.length, "".concat(r, " contain unknown keys: ").concat(n));
        }, t.checkPreferences = function (e) {
          o = o || r(3378);
          const t = o.preferences.validate(e);
          if (t.error) throw new n([t.error.details[0].message]);
        }, t.compare = function (e, t, r) {
          switch (r) {
            case "=":
              return e === t;

            case ">":
              return e > t;

            case "<":
              return e < t;

            case ">=":
              return e >= t;

            case "<=":
              return e <= t;
          }
        }, t.default = function (e, t) {
          return void 0 === e ? t : e;
        }, t.isIsoDate = function (e) {
          return l.isoDate.test(e);
        }, t.isNumber = function (e) {
          return "number" == typeof e && !isNaN(e);
        }, t.isResolvable = function (e) {
          return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
        }, t.isSchema = function (e) {
          let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          const n = e && e[t.symbols.any];
          return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
        }, t.isValues = function (e) {
          return e[t.symbols.values];
        }, t.limit = function (e) {
          return Number.isSafeInteger(e) && e >= 0;
        }, t.preferences = function (e, s) {
          i = i || r(6914), e = e || {}, s = s || {};
          const n = Object.assign({}, e, s);
          return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = i.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
        }, t.tryWithPath = function (e, t) {
          let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

          try {
            return e();
          } catch (e) {
            throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
          }
        }, t.validateArg = function (e, r, s) {
          let {
            assert: n,
            message: a
          } = s;

          if (t.isSchema(n)) {
            const t = n.validate(e);
            if (!t.error) return;
            return t.error.message;
          }

          if (!n(e)) return r ? "".concat(r, " ").concat(a) : a;
        }, t.verifyFlat = function (e, t) {
          for (const r of e) s(!Array.isArray(r), "Method no longer accepts array arguments:", t);
        };
      },
      3292: (e, t, r) => {

        const s = r(375),
              n = r(8160),
              a = r(6133),
              i = {};
        t.schema = function (e, t) {
          let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          n.assertOptions(r, ["appendPath", "override"]);

          try {
            return i.schema(e, t, r);
          } catch (e) {
            throw r.appendPath && void 0 !== e.path && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
          }
        }, i.schema = function (e, t, r) {
          s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));

          const a = function a(t) {
            for (var s = arguments.length, n = new Array(s > 1 ? s - 1 : 0), a = 1; a < s; a++) n[a - 1] = arguments[a];

            return !1 !== r.override ? t.valid(e.override, ...n) : t.valid(...n);
          };

          if (i.simple(t)) return a(e, t);
          if ("function" == typeof t) return e.custom(t);
          if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return a(e, t);
          if (n.isSchema(t)) return t;

          if (Array.isArray(t)) {
            for (const r of t) if (!i.simple(r)) return e.alternatives().try(...t);

            return a(e, ...t);
          }

          return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? a(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
        }, t.ref = function (e, t) {
          return a.isRef(e) ? e : a.create(e, t);
        }, t.compile = function (e, r) {
          let a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          n.assertOptions(a, ["legacy"]);
          const o = r && r[n.symbols.any];
          if (o) return s(a.legacy || o.version === n.version, "Cannot mix different versions of joi schemas:", o.version, n.version), r;
          if ("object" != typeof r || !a.legacy) return t.schema(e, r, {
            appendPath: !0
          });
          const l = i.walk(r);
          return l ? l.compile(l.root, r) : t.schema(e, r, {
            appendPath: !0
          });
        }, i.walk = function (e) {
          if ("object" != typeof e) return null;

          if (Array.isArray(e)) {
            for (const t of e) {
              const e = i.walk(t);
              if (e) return e;
            }

            return null;
          }

          const t = e[n.symbols.any];
          if (t) return {
            root: e[t.root],
            compile: t.compile
          };
          s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");

          for (const t in e) {
            const r = i.walk(e[t]);
            if (r) return r;
          }

          return null;
        }, i.simple = function (e) {
          return null === e || ["boolean", "string", "number"].includes(typeof e);
        }, t.when = function (e, r, o) {
          if (void 0 === o && (s(r && "object" == typeof r, "Missing options"), o = r, r = a.create(".")), Array.isArray(o) && (o = {
            switch: o
          }), n.assertOptions(o, ["is", "not", "then", "otherwise", "switch", "break"]), n.isSchema(r)) return s(void 0 === o.is, '"is" can not be used with a schema condition'), s(void 0 === o.not, '"not" can not be used with a schema condition'), s(void 0 === o.switch, '"switch" can not be used with a schema condition'), i.condition(e, {
            is: r,
            then: o.then,
            otherwise: o.otherwise,
            break: o.break
          });

          if (s(a.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === o.not || void 0 === o.is, 'Cannot combine "is" with "not"'), void 0 === o.switch) {
            let l = o;
            void 0 !== o.not && (l = {
              is: o.not,
              then: o.otherwise,
              otherwise: o.then,
              break: o.break
            });
            let c = void 0 !== l.is ? e.$_compile(l.is) : e.$_root.invalid(null, !1, 0, "").required();
            return s(void 0 !== l.then || void 0 !== l.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === l.break || void 0 === l.then || void 0 === l.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === o.is || a.isRef(o.is) || n.isSchema(o.is) || (c = c.required()), i.condition(e, {
              ref: t.ref(r),
              is: c,
              then: l.then,
              otherwise: l.otherwise,
              break: l.break
            });
          }

          s(Array.isArray(o.switch), '"switch" must be an array'), s(void 0 === o.is, 'Cannot combine "switch" with "is"'), s(void 0 === o.not, 'Cannot combine "switch" with "not"'), s(void 0 === o.then, 'Cannot combine "switch" with "then"');
          const l = {
            ref: t.ref(r),
            switch: [],
            break: o.break
          };

          for (let t = 0; t < o.switch.length; ++t) {
            const r = o.switch[t],
                  i = t === o.switch.length - 1;
            n.assertOptions(r, i ? ["is", "then", "otherwise"] : ["is", "then"]), s(void 0 !== r.is, 'Switch statement missing "is"'), s(void 0 !== r.then, 'Switch statement missing "then"');
            const c = {
              is: e.$_compile(r.is),
              then: e.$_compile(r.then)
            };

            if (a.isRef(r.is) || n.isSchema(r.is) || (c.is = c.is.required()), i) {
              s(void 0 === o.otherwise || void 0 === r.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');
              const t = void 0 !== o.otherwise ? o.otherwise : r.otherwise;
              void 0 !== t && (s(void 0 === l.break, "Cannot specify both otherwise and break"), c.otherwise = e.$_compile(t));
            }

            l.switch.push(c);
          }

          return l;
        }, i.condition = function (e, t) {
          for (const r of ["then", "otherwise"]) void 0 === t[r] ? delete t[r] : t[r] = e.$_compile(t[r]);

          return t;
        };
      },
      6354: (e, t, r) => {

        const s = r(5688),
              n = r(8160),
              a = r(3328);
        t.Report = class {
          constructor(e, r, s, n, a, i, o) {
            if (this.code = e, this.flags = n, this.messages = a, this.path = i.path, this.prefs = o, this.state = i, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
              const e = this.path[this.path.length - 1];
              "object" != typeof e && (this.local.key = e);
            }
          }

          _setTemplate(e) {
            if (this.template = e, !this.flags.label && 0 === this.path.length) {
              const e = this._template(this.template, "root");

              e && (this.local.label = e);
            }
          }

          toString() {
            if (this.message) return this.message;
            const e = this.code;
            if (!this.prefs.errors.render) return this.code;

            const t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);

            return void 0 === t ? "Error code \"".concat(e, "\" is not defined, your custom type is missing the correct messages definition") : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
              errors: this.prefs.errors,
              messages: [this.prefs.messages, this.messages]
            }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
          }

          _template(e, r) {
            return t.template(this.value, e, r || this.code, this.state, this.prefs);
          }

        }, t.path = function (e) {
          let t = "";

          for (const r of e) "object" != typeof r && ("string" == typeof r ? (t && (t += "."), t += r) : t += "[".concat(r, "]"));

          return t;
        }, t.template = function (e, t, r, s, i) {
          if (!t) return;
          if (a.isTemplate(t)) return "root" !== r ? t : null;
          let o = i.errors.language;

          if (n.isResolvable(o) && (o = o.resolve(e, s, i)), o && t[o]) {
            if (void 0 !== t[o][r]) return t[o][r];
            if (void 0 !== t[o]["*"]) return t[o]["*"];
          }

          return t[r] ? t[r] : t["*"];
        }, t.label = function (e, r, s, n) {
          if (e.label) return e.label;
          if (!s.errors.label) return "";
          let a = r.path;
          "key" === s.errors.label && r.path.length > 1 && (a = r.path.slice(-1));
          return t.path(a) || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
        }, t.process = function (e, r, s) {
          if (!e) return null;
          const {
            override: n,
            message: a,
            details: i
          } = t.details(e);
          if (n) return n;
          if (s.errors.stack) return new t.ValidationError(a, i, r);
          const o = Error.stackTraceLimit;
          Error.stackTraceLimit = 0;
          const l = new t.ValidationError(a, i, r);
          return Error.stackTraceLimit = o, l;
        }, t.details = function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = [];
          const s = [];

          for (const n of e) {
            if (n instanceof Error) {
              if (!1 !== t.override) return {
                override: n
              };
              const e = n.toString();
              r.push(e), s.push({
                message: e,
                type: "override",
                context: {
                  error: n
                }
              });
              continue;
            }

            const e = n.toString();
            r.push(e), s.push({
              message: e,
              path: n.path.filter(e => "object" != typeof e),
              type: n.code,
              context: n.local
            });
          }

          return r.length > 1 && (r = [...new Set(r)]), {
            message: r.join(". "),
            details: s
          };
        }, t.ValidationError = class extends Error {
          constructor(e, t, r) {
            super(e), this._original = r, this.details = t;
          }

          static isError(e) {
            return e instanceof t.ValidationError;
          }

        }, t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = s.error;
      },
      8901: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(8160),
              i = r(6914),
              o = {};
        t.type = function (e, t) {
          const r = Object.getPrototypeOf(e),
                l = n(r),
                c = e._assign(Object.create(l)),
                u = Object.assign({}, t);

          delete u.base, l._definition = u;
          const f = r._definition || {};
          u.messages = i.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
          const h = Object.assign({}, f.terms);
          if (u.terms) for (const e in u.terms) {
            const t = u.terms[e];
            s(void 0 === c.$_terms[e], "Invalid term override for", u.type, e), c.$_terms[e] = t.init, h[e] = t;
          }
          u.terms = h, u.args || (u.args = f.args), u.prepare = o.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
            method: u.coerce
          }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
            method: u.coerce.method,
            from: [].concat(u.coerce.from)
          })), u.coerce = o.coerce(u.coerce, f.coerce), u.validate = o.validate(u.validate, f.validate);
          const m = Object.assign({}, f.rules);
          if (u.rules) for (const e in u.rules) {
            const t = u.rules[e];
            s("object" == typeof t, "Invalid rule definition for", u.type, e);
            let r = t.method;

            if (void 0 === r && (r = function r() {
              return this.$_addRule(e);
            }), r && (s(!l[e], "Rule conflict in", u.type, e), l[e] = r), s(!m[e], "Rule conflict in", u.type, e), m[e] = t, t.alias) {
              const e = [].concat(t.alias);

              for (const r of e) l[r] = t.method;
            }

            t.args && (t.argsByName = new Map(), t.args = t.args.map(e => ("string" == typeof e && (e = {
              name: e
            }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), a.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e)));
          }
          u.rules = m;
          const d = Object.assign({}, f.modifiers);
          if (u.modifiers) for (const e in u.modifiers) {
            s(!l[e], "Rule conflict in", u.type, e);
            const t = u.modifiers[e];
            s("function" == typeof t, "Invalid modifier definition for", u.type, e);

            const r = function r(t) {
              return this.rule({
                [e]: t
              });
            };

            l[e] = r, d[e] = t;
          }

          if (u.modifiers = d, u.overrides) {
            l._super = r, c.$_super = {};

            for (const e in u.overrides) s(r[e], "Cannot override missing", e), u.overrides[e][a.symbols.parent] = r[e], c.$_super[e] = r[e].bind(c);

            Object.assign(l, u.overrides);
          }

          u.cast = Object.assign({}, f.cast, u.cast);
          const p = Object.assign({}, f.manifest, u.manifest);
          return p.build = o.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = p, u.rebuild = o.rebuild(u.rebuild, f.rebuild), c;
        }, o.build = function (e, t) {
          return e && t ? function (r, s) {
            return t(e(r, s), s);
          } : e || t;
        }, o.coerce = function (e, t) {
          return e && t ? {
            from: e.from && t.from ? [...new Set([...e.from, ...t.from])] : null,

            method(r, s) {
              let n;

              if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
                if (n.errors || void 0 === n.value) return n;
                r = n.value;
              }

              if (!e.from || e.from.includes(typeof r)) {
                const t = e.method(r, s);
                if (t) return t;
              }

              return n;
            }

          } : e || t;
        }, o.prepare = function (e, t) {
          return e && t ? function (r, s) {
            const n = e(r, s);

            if (n) {
              if (n.errors || void 0 === n.value) return n;
              r = n.value;
            }

            return t(r, s) || n;
          } : e || t;
        }, o.rebuild = function (e, t) {
          return e && t ? function (r) {
            t(r), e(r);
          } : e || t;
        }, o.validate = function (e, t) {
          return e && t ? function (r, s) {
            const n = t(r, s);

            if (n) {
              if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
              r = n.value;
            }

            return e(r, s) || n;
          } : e || t;
        };
      },
      5107: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(8652),
              i = r(8160),
              o = r(3292),
              l = r(6354),
              c = r(8901),
              u = r(9708),
              f = r(6133),
              h = r(3328),
              m = r(1152);
        let d;
        const p = {
          types: {
            alternatives: r(4946),
            any: r(8068),
            array: r(546),
            boolean: r(4937),
            date: r(7500),
            function: r(390),
            link: r(8785),
            number: r(3832),
            object: r(8966),
            string: r(7417),
            symbol: r(8826)
          },
          aliases: {
            alt: "alternatives",
            bool: "boolean",
            func: "function"
          },
          root: function root() {
            const e = {
              _types: new Set(Object.keys(p.types))
            };

            for (const t of e._types) e[t] = function () {
              for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];

              return s(!r.length || ["alternatives", "link", "object"].includes(t), "The", t, "type does not allow arguments"), p.generate(this, p.types[t], r);
            };

            for (const t of ["allow", "custom", "disallow", "equal", "exist", "forbidden", "invalid", "not", "only", "optional", "options", "prefs", "preferences", "required", "strip", "valid", "when"]) e[t] = function () {
              return this.any()[t](...arguments);
            };

            Object.assign(e, p.methods);

            for (const t in p.aliases) {
              const r = p.aliases[t];
              e[t] = e[r];
            }

            return e.x = e.expression, m.setup && m.setup(e), e;
          }
        };
        p.methods = {
          ValidationError: l.ValidationError,
          version: i.version,
          cache: a.provider,

          assert(e, t) {
            for (var r = arguments.length, s = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++) s[n - 2] = arguments[n];

            p.assert(e, t, !0, s);
          },

          attempt(e, t) {
            for (var r = arguments.length, s = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++) s[n - 2] = arguments[n];

            return p.assert(e, t, !1, s);
          },

          build(e) {
            return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
          },

          checkPreferences(e) {
            i.checkPreferences(e);
          },

          compile(e, t) {
            return o.compile(this, e, t);
          },

          defaults(e) {
            s("function" == typeof e, "modifier must be a function");
            const t = Object.assign({}, this);

            for (const r of t._types) {
              const n = e(t[r]());
              s(i.isSchema(n), "modifier must return a valid schema object"), t[r] = function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                return p.generate(this, n, t);
              };
            }

            return t;
          },

          expression() {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

            return new h(...t);
          },

          extend() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];

            i.verifyFlat(t, "extend"), d = d || r(3378), s(t.length, "You need to provide at least one extension"), this.assert(t, d.extensions);
            const a = Object.assign({}, this);
            a._types = new Set(a._types);

            for (let e of t) {
              "function" == typeof e && (e = e(a)), this.assert(e, d.extension);
              const t = p.expandExtension(e, a);

              for (const e of t) {
                s(void 0 === a[e.type] || a._types.has(e.type), "Cannot override name", e.type);
                const t = e.base || this.any(),
                      r = c.type(t, e);
                a._types.add(e.type), a[e.type] = function () {
                  for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];

                  return p.generate(this, r, t);
                };
              }
            }

            return a;
          },

          isError: l.ValidationError.isError,
          isExpression: h.isTemplate,
          isRef: f.isRef,
          isSchema: i.isSchema,

          in() {
            return f.in(...arguments);
          },

          override: i.symbols.override,

          ref() {
            return f.create(...arguments);
          },

          types() {
            const e = {};

            for (const t of this._types) e[t] = this[t]();

            for (const t in p.aliases) e[t] = this[t]();

            return e;
          }

        }, p.assert = function (e, t, r, s) {
          const a = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null,
                o = null !== a ? s[1] : s[0],
                c = t.validate(e, i.preferences({
            errors: {
              stack: !0
            }
          }, o || {}));
          let u = c.error;
          if (!u) return c.value;
          if (a instanceof Error) throw a;
          const f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
          throw u instanceof l.ValidationError == 0 && (u = n(u)), u.message = a ? "".concat(a, " ").concat(f) : f, u;
        }, p.generate = function (e, t, r) {
          return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? t._definition.args(t, ...r) : t;
        }, p.expandExtension = function (e, t) {
          if ("string" == typeof e.type) return [e];
          const r = [];

          for (const s of t._types) if (e.type.test(s)) {
            const n = Object.assign({}, e);
            n.type = s, n.base = t[s](), r.push(n);
          }

          return r;
        }, e.exports = p.root();
      },
      6914: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(3328);
        t.compile = function (e, t) {
          if ("string" == typeof e) return s(!t, "Cannot set single message string"), new a(e);
          if (a.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
          s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};

          for (let r in e) {
            const n = e[r];

            if ("root" === r || a.isTemplate(n)) {
              t[r] = n;
              continue;
            }

            if ("string" == typeof n) {
              t[r] = new a(n);
              continue;
            }

            s("object" == typeof n && !Array.isArray(n), "Invalid message for", r);
            const i = r;

            for (r in t[i] = t[i] || {}, n) {
              const e = n[r];
              "root" === r || a.isTemplate(e) ? t[i][r] = e : (s("string" == typeof e, "Invalid message for", r, "in", i), t[i][r] = new a(e));
            }
          }

          return t;
        }, t.decompile = function (e) {
          const t = {};

          for (let r in e) {
            const s = e[r];

            if ("root" === r) {
              t.root = s;
              continue;
            }

            if (a.isTemplate(s)) {
              t[r] = s.describe({
                compact: !0
              });
              continue;
            }

            const n = r;

            for (r in t[n] = {}, s) {
              const e = s[r];
              "root" !== r ? t[n][r] = e.describe({
                compact: !0
              }) : t[n].root = e;
            }
          }

          return t;
        }, t.merge = function (e, r) {
          if (!e) return t.compile(r);
          if (!r) return e;
          if ("string" == typeof r) return new a(r);
          if (a.isTemplate(r)) return r;
          const i = n(e);

          for (let e in r) {
            const t = r[e];

            if ("root" === e || a.isTemplate(t)) {
              i[e] = t;
              continue;
            }

            if ("string" == typeof t) {
              i[e] = new a(t);
              continue;
            }

            s("object" == typeof t && !Array.isArray(t), "Invalid message for", e);
            const n = e;

            for (e in i[n] = i[n] || {}, t) {
              const r = t[e];
              "root" === e || a.isTemplate(r) ? i[n][e] = r : (s("string" == typeof r, "Invalid message for", e, "in", n), i[n][e] = new a(r));
            }
          }

          return i;
        };
      },
      2294: (e, t, r) => {

        const s = r(375),
              n = r(8160),
              a = r(6133),
              i = {};
        t.Ids = i.Ids = class {
          constructor() {
            this._byId = new Map(), this._byKey = new Map(), this._schemaChain = !1;
          }

          clone() {
            const e = new i.Ids();
            return e._byId = new Map(this._byId), e._byKey = new Map(this._byKey), e._schemaChain = this._schemaChain, e;
          }

          concat(e) {
            e._schemaChain && (this._schemaChain = !0);

            for (const [t, r] of e._byId.entries()) s(!this._byKey.has(t), "Schema id conflicts with existing key:", t), this._byId.set(t, r);

            for (const [t, r] of e._byKey.entries()) s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, r);
          }

          fork(e, t, r) {
            const a = this._collect(e);

            a.push({
              schema: r
            });
            const o = a.shift();
            let l = {
              id: o.id,
              schema: t(o.schema)
            };
            s(n.isSchema(l.schema), "adjuster function failed to return a joi schema type");

            for (const e of a) l = {
              id: e.id,
              schema: i.fork(e.schema, l.id, l.schema)
            };

            return l.schema;
          }

          labels(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];

            const r = e[0],
                  s = this._get(r);

            if (!s) return [...t, ...e].join(".");
            const n = e.slice(1);
            return t = [...t, s.schema._flags.label || r], n.length ? s.schema._ids.labels(n, t) : t.join(".");
          }

          reach(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];

            const r = e[0],
                  n = this._get(r);

            s(n, "Schema does not contain path", [...t, ...e].join("."));
            const a = e.slice(1);
            return a.length ? n.schema._ids.reach(a, [...t, r]) : n.schema;
          }

          register(e) {
            let {
              key: t
            } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!e || !n.isSchema(e)) return;
            (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
            const r = e._flags.id;

            if (r) {
              const t = this._byId.get(r);

              s(!t || t.schema === e, "Cannot add different schemas with the same id:", r), s(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
                schema: e,
                id: r
              });
            }

            t && (s(!this._byKey.has(t), "Schema already contains key:", t), s(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
              schema: e,
              id: t
            }));
          }

          reset() {
            this._byId = new Map(), this._byKey = new Map(), this._schemaChain = !1;
          }

          _collect(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];

            const n = e[0],
                  a = this._get(n);

            s(a, "Schema does not contain path", [...t, ...e].join(".")), r = [a, ...r];
            const i = e.slice(1);
            return i.length ? a.schema._ids._collect(i, [...t, n], r) : r;
          }

          _get(e) {
            return this._byId.get(e) || this._byKey.get(e);
          }

        }, i.fork = function (e, r, s) {
          const n = t.schema(e, {
            each: (e, t) => {
              let {
                key: n
              } = t;
              if (r === (e._flags.id || n)) return s;
            },
            ref: !1
          });
          return n ? n.$_mutateRebuild() : e;
        }, t.schema = function (e, t) {
          let r;

          for (const s in e._flags) {
            if ("_" === s[0]) continue;
            const n = i.scan(e._flags[s], {
              source: "flags",
              name: s
            }, t);
            void 0 !== n && (r = r || e.clone(), r._flags[s] = n);
          }

          for (let s = 0; s < e._rules.length; ++s) {
            const n = e._rules[s],
                  a = i.scan(n.args, {
              source: "rules",
              name: n.name
            }, t);

            if (void 0 !== a) {
              r = r || e.clone();
              const t = Object.assign({}, n);
              t.args = a, r._rules[s] = t, r._singleRules.get(n.name) === n && r._singleRules.set(n.name, t);
            }
          }

          for (const s in e.$_terms) {
            if ("_" === s[0]) continue;
            const n = i.scan(e.$_terms[s], {
              source: "terms",
              name: s
            }, t);
            void 0 !== n && (r = r || e.clone(), r.$_terms[s] = n);
          }

          return r;
        }, i.scan = function (e, t, r, s, o) {
          const l = s || [];
          if (null === e || "object" != typeof e) return;
          let c;

          if (Array.isArray(e)) {
            for (let s = 0; s < e.length; ++s) {
              const n = "terms" === t.source && "keys" === t.name && e[s].key,
                    a = i.scan(e[s], t, r, [s, ...l], n);
              void 0 !== a && (c = c || e.slice(), c[s] = a);
            }

            return c;
          }

          if (!1 !== r.schema && n.isSchema(e) || !1 !== r.ref && a.isRef(e)) {
            const s = r.each(e, _objectSpread2(_objectSpread2({}, t), {}, {
              path: l,
              key: o
            }));
            if (s === e) return;
            return s;
          }

          for (const s in e) {
            if ("_" === s[0]) continue;
            const n = i.scan(e[s], t, r, [s, ...l], o);
            void 0 !== n && (c = c || Object.assign({}, e), c[s] = n);
          }

          return c;
        };
      },
      6133: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(9621),
              i = r(8160);
        let o;
        const l = {
          symbol: Symbol("ref"),
          defaults: {
            adjust: null,
            in: !1,
            iterables: null,
            map: null,
            separator: ".",
            type: "value"
          }
        };
        t.create = function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          s("string" == typeof e, "Invalid reference key:", e), i.assertOptions(t, ["adjust", "ancestor", "in", "iterables", "map", "prefix", "render", "separator"]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
          const r = Object.assign({}, l.defaults, t);
          delete r.prefix;
          const n = r.separator,
                a = l.context(e, n, t.prefix);
          if (r.type = a.type, e = a.key, "value" === r.type) if (a.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");else {
            const [t, s] = l.ancestor(e, n);
            s && "" === (e = e.slice(s)) && (e = null), r.ancestor = t;
          }
          return r.path = n ? null === e ? [] : e.split(n) : [e], new l.Ref(r);
        }, t.in = function (e) {
          let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return t.create(e, _objectSpread2(_objectSpread2({}, r), {}, {
            in: !0
          }));
        }, t.isRef = function (e) {
          return !!e && !!e[i.symbols.ref];
        }, l.Ref = class {
          constructor(e) {
            s("object" == typeof e, "Invalid reference construction"), i.assertOptions(e, ["adjust", "ancestor", "in", "iterables", "map", "path", "render", "separator", "type", "depth", "key", "root", "display"]), s([!1, void 0].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, l.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
          }

          resolve(e, t, r, n) {
            let a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
            return s(!this.in || a.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, a) : "local" === this.type ? this._resolve(n, t, a) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, a) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, a)) : this._resolve(e, t, a);
          }

          _resolve(e, t, r) {
            let s;

            if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = a(e, this.path, {
              iterables: this.iterables,
              functions: !0
            })), this.adjust && (s = this.adjust(s)), this.map) {
              const e = this.map.get(s);
              void 0 !== e && (s = e);
            }

            return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
          }

          toString() {
            return this.display;
          }

          absolute(e) {
            return [...e.path.slice(0, -this.ancestor), ...this.path];
          }

          clone() {
            return new l.Ref(this);
          }

          describe() {
            const e = {
              path: this.path
            };
            "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = [...this.map]);

            for (const t of ["adjust", "iterables", "render"]) null !== this[t] && void 0 !== this[t] && (e[t] = this[t]);

            return !1 !== this.in && (e.in = !0), {
              ref: e
            };
          }

          updateDisplay() {
            const e = null !== this.key ? this.key : "";
            if ("value" !== this.type) return void (this.display = "ref:".concat(this.type, ":").concat(e));
            if (!this.separator) return void (this.display = "ref:".concat(e));
            if (!this.ancestor) return void (this.display = "ref:".concat(this.separator).concat(e));
            if ("root" === this.ancestor) return void (this.display = "ref:root:".concat(e));
            if (1 === this.ancestor) return void (this.display = "ref:".concat(e || ".."));
            const t = new Array(this.ancestor + 1).fill(this.separator).join("");
            this.display = "ref:".concat(t).concat(e || "");
          }

        }, l.Ref.prototype[i.symbols.ref] = !0, t.build = function (e) {
          return "value" === (e = Object.assign({}, l.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new l.Ref(e);
        }, l.context = function (e, t) {
          let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

          if (e = e.trim(), r) {
            const s = void 0 === r.global ? "$" : r.global;
            if (s !== t && e.startsWith(s)) return {
              key: e.slice(s.length),
              type: "global"
            };
            const n = void 0 === r.local ? "#" : r.local;
            if (n !== t && e.startsWith(n)) return {
              key: e.slice(n.length),
              type: "local"
            };
            const a = void 0 === r.root ? "/" : r.root;
            if (a !== t && e.startsWith(a)) return {
              key: e.slice(a.length),
              type: "value",
              root: !0
            };
          }

          return {
            key: e,
            type: "value"
          };
        }, l.ancestor = function (e, t) {
          if (!t) return [1, 0];
          if (e[0] !== t) return [1, 0];
          if (e[1] !== t) return [0, 1];
          let r = 2;

          for (; e[r] === t;) ++r;

          return [r - 1, r];
        }, t.toSibling = 0, t.toParent = 1, t.Manager = class {
          constructor() {
            this.refs = [];
          }

          register(e, s) {
            if (e) if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) for (const t of e) this.register(t, s);else if (i.isSchema(e)) for (const t of e._refs.refs) t.ancestor - s >= 0 && this.refs.push({
              ancestor: t.ancestor - s,
              root: t.root
            });else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
              ancestor: e.ancestor - s,
              root: e.root
            }), o = o || r(3328), o.isTemplate(e) && this.register(e.refs(), s);
          }

          get length() {
            return this.refs.length;
          }

          clone() {
            const e = new t.Manager();
            return e.refs = n(this.refs), e;
          }

          reset() {
            this.refs = [];
          }

          roots() {
            return this.refs.filter(e => !e.ancestor).map(e => e.root);
          }

        };
      },
      3378: (e, t, r) => {

        const s = r(5107),
              n = {};
        n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
          allowUnknown: s.boolean(),
          abortEarly: s.boolean(),
          artifacts: s.boolean(),
          cache: s.boolean(),
          context: s.object(),
          convert: s.boolean(),
          dateFormat: s.valid("date", "iso", "string", "time", "utc"),
          debug: s.boolean(),
          errors: {
            escapeHtml: s.boolean(),
            label: s.valid("path", "key", !1),
            language: [s.string(), s.object().ref()],
            render: s.boolean(),
            stack: s.boolean(),
            wrap: {
              label: n.wrap,
              array: n.wrap,
              string: n.wrap
            }
          },
          externals: s.boolean(),
          messages: s.object(),
          noDefaults: s.boolean(),
          nonEnumerables: s.boolean(),
          presence: s.valid("required", "optional", "forbidden"),
          skipFunctions: s.boolean(),
          stripUnknown: s.object({
            arrays: s.boolean(),
            objects: s.boolean()
          }).or("arrays", "objects").allow(!0, !1),
          warnings: s.boolean()
        }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.rule = s.object({
          alias: s.array().items(s.string().pattern(n.nameRx)).single(),
          args: s.array().items(s.string(), s.object({
            name: s.string().pattern(n.nameRx).required(),
            ref: s.boolean(),
            assert: s.alternatives([s.function(), s.object().schema()]).conditional("ref", {
              is: !0,
              then: s.required()
            }),
            normalize: s.function(),
            message: s.string().when("assert", {
              is: s.function(),
              then: s.required()
            })
          })),
          convert: s.boolean(),
          manifest: s.boolean(),
          method: s.function().allow(!1),
          multi: s.boolean(),
          validate: s.function()
        }), t.extension = s.object({
          type: s.alternatives([s.string(), s.object().regex()]).required(),
          args: s.function(),
          cast: s.object().pattern(n.nameRx, s.object({
            from: s.function().maxArity(1).required(),
            to: s.function().minArity(1).maxArity(2).required()
          })),
          base: s.object().schema().when("type", {
            is: s.object().regex(),
            then: s.forbidden()
          }),
          coerce: [s.function().maxArity(3), s.object({
            method: s.function().maxArity(3).required(),
            from: s.array().items(s.string()).single()
          })],
          flags: s.object().pattern(n.nameRx, s.object({
            setter: s.string(),
            default: s.any()
          })),
          manifest: {
            build: s.function().arity(2)
          },
          messages: [s.object(), s.string()],
          modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
          overrides: s.object().pattern(n.nameRx, s.function()),
          prepare: s.function().maxArity(3),
          rebuild: s.function().arity(1),
          rules: s.object().pattern(n.nameRx, n.rule),
          terms: s.object().pattern(n.nameRx, s.object({
            init: s.array().allow(null).required(),
            manifest: s.object().pattern(/.+/, [s.valid("schema", "single"), s.object({
              mapped: s.object({
                from: s.string().required(),
                to: s.string().required()
              }).required()
            })])
          })),
          validate: s.function().maxArity(3)
        }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
          buffer: s.object({
            buffer: s.string()
          }),
          func: s.object({
            function: s.function().required(),
            options: {
              literal: !0
            }
          }),
          override: s.object({
            override: !0
          }),
          ref: s.object({
            ref: s.object({
              type: s.valid("value", "global", "local"),
              path: s.array().required(),
              separator: s.string().length(1).allow(!1),
              ancestor: s.number().min(0).integer().allow("root"),
              map: s.array().items(s.array().length(2)).min(1),
              adjust: s.function(),
              iterables: s.boolean(),
              in: s.boolean(),
              render: s.boolean()
            }).required()
          }),
          regex: s.object({
            regex: s.string().min(3)
          }),
          special: s.object({
            special: s.valid("deep").required()
          }),
          template: s.object({
            template: s.string().required(),
            options: s.object()
          }),
          value: s.object({
            value: s.alternatives([s.object(), s.array()]).required()
          })
        }, n.desc.entity = s.alternatives([s.array().items(s.link("...")), s.boolean(), s.function(), s.number(), s.string(), n.desc.buffer, n.desc.func, n.desc.ref, n.desc.regex, n.desc.special, n.desc.template, n.desc.value, s.link("/")]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [s.string(), n.desc.template, s.object().pattern(/.+/, [s.string(), n.desc.template])]), t.description = s.object({
          type: s.string().required(),
          flags: s.object({
            cast: s.string(),
            default: s.any(),
            description: s.string(),
            empty: s.link("/"),
            failover: n.desc.entity,
            id: s.string(),
            label: s.string(),
            only: !0,
            presence: ["optional", "required", "forbidden"],
            result: ["raw", "strip"],
            strip: s.boolean(),
            unit: s.string()
          }).unknown(),
          preferences: {
            allowUnknown: s.boolean(),
            abortEarly: s.boolean(),
            artifacts: s.boolean(),
            cache: s.boolean(),
            convert: s.boolean(),
            dateFormat: ["date", "iso", "string", "time", "utc"],
            errors: {
              escapeHtml: s.boolean(),
              label: ["path", "key"],
              language: [s.string(), n.desc.ref],
              wrap: {
                label: n.wrap,
                array: n.wrap
              }
            },
            externals: s.boolean(),
            messages: n.desc.messages,
            noDefaults: s.boolean(),
            nonEnumerables: s.boolean(),
            presence: ["required", "optional", "forbidden"],
            skipFunctions: s.boolean(),
            stripUnknown: s.object({
              arrays: s.boolean(),
              objects: s.boolean()
            }).or("arrays", "objects").allow(!0, !1),
            warnings: s.boolean()
          },
          allow: n.desc.values,
          invalid: n.desc.values,
          rules: s.array().min(1).items({
            name: s.string().required(),
            args: s.object().min(1),
            keep: s.boolean(),
            message: [s.string(), n.desc.messages],
            warn: s.boolean()
          }),
          keys: s.object().pattern(/.*/, s.link("/")),
          link: n.desc.ref
        }).pattern(/^[a-z]\w*$/, s.any());
      },
      493: (e, t, r) => {

        const s = r(8571),
              n = r(9621),
              a = r(8160),
              i = {
          value: Symbol("value")
        };
        e.exports = i.State = class {
          constructor(e, t, r) {
            this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
          }

          localize(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            const s = new i.State(e, t, this);
            return r && s.schemas && (s.schemas = [i.schemas(r), ...s.schemas]), s;
          }

          nest(e, t) {
            const r = new i.State(this.path, this.ancestors, this);
            return r.schemas = r.schemas && [i.schemas(e), ...r.schemas], r.debug = t, r;
          }

          shadow(e, t) {
            this.mainstay.shadow = this.mainstay.shadow || new i.Shadow(), this.mainstay.shadow.set(this.path, e, t);
          }

          snapshot() {
            this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path))), this.mainstay.snapshot();
          }

          restore() {
            this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.restore();
          }

          commit() {
            this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0), this.mainstay.commit();
          }

        }, i.schemas = function (e) {
          return a.isSchema(e) ? {
            schema: e
          } : e;
        }, i.Shadow = class {
          constructor() {
            this._values = null;
          }

          set(e, t, r) {
            if (!e.length) return;
            if ("strip" === r && "number" == typeof e[e.length - 1]) return;
            this._values = this._values || new Map();
            let s = this._values;

            for (let t = 0; t < e.length; ++t) {
              const r = e[t];
              let n = s.get(r);
              n || (n = new Map(), s.set(r, n)), s = n;
            }

            s[i.value] = t;
          }

          get(e) {
            const t = this.node(e);
            if (t) return t[i.value];
          }

          node(e) {
            if (this._values) return n(this._values, e, {
              iterables: !0
            });
          }

          override(e, t) {
            if (!this._values) return;
            const r = e.slice(0, -1),
                  s = e[e.length - 1],
                  a = n(this._values, r, {
              iterables: !0
            });
            t ? a.set(s, t) : a && a.delete(s);
          }

        };
      },
      3328: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(5277),
              i = r(1447),
              o = r(8160),
              l = r(6354),
              c = r(6133),
              u = {
          symbol: Symbol("template"),
          opens: new Array(1e3).join("\0"),
          closes: new Array(1e3).join(""),
          dateFormat: {
            date: Date.prototype.toDateString,
            iso: Date.prototype.toISOString,
            string: Date.prototype.toString,
            time: Date.prototype.toTimeString,
            utc: Date.prototype.toUTCString
          }
        };
        e.exports = u.Template = class {
          constructor(e, t) {
            s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes(""), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, this._settings = n(t), this._parse();
          }

          _parse() {
            if (!this.source.includes("{")) return;
            const e = u.encode(this.source),
                  t = u.split(e);
            let r = !1;
            const s = [],
                  n = t.shift();
            n && s.push(n);

            for (const e of t) {
              const t = "{" !== e[0],
                    n = t ? "}" : "}}",
                    a = e.indexOf(n);

              if (-1 === a || "{" === e[1]) {
                s.push("{".concat(u.decode(e)));
                continue;
              }

              let i = e.slice(t ? 0 : 1, a);
              const o = ":" === i[0];
              o && (i = i.slice(1));

              const l = this._ref(u.decode(i), {
                raw: t,
                wrapped: o
              });

              s.push(l), "string" != typeof l && (r = !0);
              const c = e.slice(a + n.length);
              c && s.push(u.decode(c));
            }

            r ? this._template = s : this.rendered = s.join("");
          }

          static date(e, t) {
            return u.dateFormat[t.dateFormat].call(e);
          }

          describe() {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (!this._settings && e.compact) return this.source;
            const t = {
              template: this.source
            };
            return this._settings && (t.options = this._settings), t;
          }

          static build(e) {
            return new u.Template(e.template, e.options);
          }

          isDynamic() {
            return !!this._template;
          }

          static isTemplate(e) {
            return !!e && !!e[o.symbols.template];
          }

          refs() {
            if (!this._template) return;
            const e = [];

            for (const t of this._template) "string" != typeof t && e.push(...t.refs);

            return e;
          }

          resolve(e, t, r, s) {
            return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
          }

          _part(e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) r[s - 1] = arguments[s];

            return e.ref ? e.ref.resolve(...r) : e.formula.evaluate(r);
          }

          render(e, t, r, s) {
            let n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
            if (!this.isDynamic()) return this.rendered;
            const i = [];

            for (const o of this._template) if ("string" == typeof o) i.push(o);else {
              const l = this._part(o, e, t, r, s, n),
                    c = u.stringify(l, e, t, r, s, n);

              if (void 0 !== c) {
                const e = o.raw || !1 === (n.errors && n.errors.escapeHtml) ? c : a(c);
                i.push(u.wrap(e, o.wrapped && r.errors.wrap.label));
              }
            }

            return i.join("");
          }

          _ref(e, t) {
            let {
              raw: r,
              wrapped: s
            } = t;

            const n = [],
                  a = e => {
              const t = c.create(e, this._settings);
              return n.push(t), e => t.resolve(...e);
            };

            try {
              var o = new i.Parser(e, {
                reference: a,
                functions: u.functions,
                constants: u.constants
              });
            } catch (t) {
              throw t.message = "Invalid template variable \"".concat(e, "\" fails due to: ").concat(t.message), t;
            }

            if (o.single) {
              if ("reference" === o.single.type) {
                const e = n[0];
                return {
                  ref: e,
                  raw: r,
                  refs: n,
                  wrapped: s || "local" === e.type && "label" === e.key
                };
              }

              return u.stringify(o.single.value);
            }

            return {
              formula: o,
              raw: r,
              refs: n
            };
          }

          toString() {
            return this.source;
          }

        }, u.Template.prototype[o.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function (e) {
          return e.replace(/\\(\{+)/g, (e, t) => u.opens.slice(0, t.length)).replace(/\\(\}+)/g, (e, t) => u.closes.slice(0, t.length));
        }, u.decode = function (e) {
          return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
        }, u.split = function (e) {
          const t = [];
          let r = "";

          for (let s = 0; s < e.length; ++s) {
            const n = e[s];

            if ("{" === n) {
              let n = "";

              for (; s + 1 < e.length && "{" === e[s + 1];) n += "{", ++s;

              t.push(r), r = n;
            } else r += n;
          }

          return t.push(r), t;
        }, u.wrap = function (e, t) {
          return t ? 1 === t.length ? "".concat(t).concat(e).concat(t) : "".concat(t[0]).concat(e).concat(t[1]) : e;
        }, u.stringify = function (e, t, r, s, n) {
          let a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          const i = typeof e,
                o = s && s.errors && s.errors.wrap || {};
          let l = !1;
          if (c.isRef(e) && e.render && (l = e.in, e = e.resolve(t, r, s, n, _objectSpread2({
            in: e.in
          }, a))), null === e) return "null";
          if ("string" === i) return u.wrap(e, a.arrayItems && o.string);
          if ("number" === i || "function" === i || "symbol" === i) return e.toString();
          if ("object" !== i) return JSON.stringify(e);
          if (e instanceof Date) return u.Template.date(e, s);

          if (e instanceof Map) {
            const t = [];

            for (const [r, s] of e.entries()) t.push("".concat(r.toString(), " -> ").concat(s.toString()));

            e = t;
          }

          if (!Array.isArray(e)) return e.toString();
          const f = [];

          for (const i of e) f.push(u.stringify(i, t, r, s, n, _objectSpread2({
            arrayItems: !0
          }, a)));

          return u.wrap(f.join(", "), !l && o.array);
        }, u.constants = {
          true: !0,
          false: !1,
          null: null,
          second: 1e3,
          minute: 6e4,
          hour: 36e5,
          day: 864e5
        }, u.functions = {
          if: (e, t, r) => e ? t : r,
          length: e => "string" == typeof e ? e.length : e && "object" == typeof e ? Array.isArray(e) ? e.length : Object.keys(e).length : null,

          msg(e) {
            const [t, r, s, n, a] = this,
                  i = a.messages;
            if (!i) return "";
            const o = l.template(t, i[0], e, r, s) || l.template(t, i[1], e, r, s);
            return o ? o.render(t, r, s, n, a) : "";
          },

          number: e => "number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null
        };
      },
      4946: (e, t, r) => {

        const s = r(375),
              n = r(1687),
              a = r(8068),
              i = r(8160),
              o = r(3292),
              l = r(6354),
              c = r(6133),
              u = {};
        e.exports = a.extend({
          type: "alternatives",
          flags: {
            match: {
              default: "any"
            }
          },
          terms: {
            matches: {
              init: [],
              register: c.toSibling
            }
          },

          args(e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++) r[s - 1] = arguments[s];

            return 1 === r.length && Array.isArray(r[0]) ? e.try(...r[0]) : e.try(...r);
          },

          validate(e, t) {
            const {
              schema: r,
              error: s,
              state: a,
              prefs: i
            } = t;

            if (r._flags.match) {
              const t = [],
                    o = [];

              for (let s = 0; s < r.$_terms.matches.length; ++s) {
                const n = r.$_terms.matches[s],
                      l = a.nest(n.schema, "match.".concat(s));
                l.snapshot();
                const c = n.schema.$_validate(e, l, i);
                c.errors ? (o.push(c.errors), l.restore()) : (t.push(c.value), l.commit());
              }

              if (0 === t.length) return {
                errors: s("alternatives.any", {
                  details: o.map(e => l.details(e, {
                    override: !1
                  }))
                })
              };
              if ("one" === r._flags.match) return 1 === t.length ? {
                value: t[0]
              } : {
                errors: s("alternatives.one")
              };
              if (t.length !== r.$_terms.matches.length) return {
                errors: s("alternatives.all", {
                  details: o.map(e => l.details(e, {
                    override: !1
                  }))
                })
              };

              const c = e => e.$_terms.matches.some(e => "object" === e.schema.type || "alternatives" === e.schema.type && c(e.schema));

              return c(r) ? {
                value: t.reduce((e, t) => n(e, t, {
                  mergeArrays: !1
                }))
              } : {
                value: t[t.length - 1]
              };
            }

            const o = [];

            for (let t = 0; t < r.$_terms.matches.length; ++t) {
              const s = r.$_terms.matches[t];

              if (s.schema) {
                const r = a.nest(s.schema, "match.".concat(t));
                r.snapshot();
                const n = s.schema.$_validate(e, r, i);
                if (!n.errors) return r.commit(), n;
                r.restore(), o.push({
                  schema: s.schema,
                  reports: n.errors
                });
                continue;
              }

              const n = s.ref ? s.ref.resolve(e, a, i) : e,
                    l = s.is ? [s] : s.switch;

              for (let r = 0; r < l.length; ++r) {
                const o = l[r],
                      {
                  is: c,
                  then: u,
                  otherwise: f
                } = o,
                      h = "match.".concat(t).concat(s.switch ? "." + r : "");

                if (c.$_match(n, a.nest(c, "".concat(h, ".is")), i)) {
                  if (u) return u.$_validate(e, a.nest(u, "".concat(h, ".then")), i);
                } else if (f) return f.$_validate(e, a.nest(f, "".concat(h, ".otherwise")), i);
              }
            }

            return u.errors(o, t);
          },

          rules: {
            conditional: {
              method(e, t) {
                s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
                const r = this.clone(),
                      n = o.when(r, e, t),
                      a = n.is ? [n] : n.switch;

                for (const e of a) if (e.then && e.otherwise) {
                  r.$_setFlag("_endedSwitch", !0, {
                    clone: !1
                  });
                  break;
                }

                return r.$_terms.matches.push(n), r.$_mutateRebuild();
              }

            },
            match: {
              method(e) {
                if (s(["any", "one", "all"].includes(e), "Invalid alternatives match mode", e), "any" !== e) for (const t of this.$_terms.matches) s(t.schema, "Cannot combine match mode", e, "with conditional rules");
                return this.$_setFlag("match", e);
              }

            },
            try: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                s(t.length, "Missing alternative schemas"), i.verifyFlat(t, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
                const n = this.clone();

                for (const e of t) n.$_terms.matches.push({
                  schema: n.$_compile(e)
                });

                return n.$_mutateRebuild();
              }

            }
          },
          overrides: {
            label(e) {
              return this.$_parent("label", e).$_modify({
                each: (t, r) => "is" !== r.path[0] ? t.label(e) : void 0,
                ref: !1
              });
            }

          },

          rebuild(e) {
            e.$_modify({
              each: t => {
                i.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
                  clone: !1
                });
              }
            });
          },

          manifest: {
            build(e, t) {
              if (t.matches) for (const r of t.matches) {
                const {
                  schema: t,
                  ref: s,
                  is: n,
                  not: a,
                  then: i,
                  otherwise: o
                } = r;
                e = t ? e.try(t) : s ? e.conditional(s, {
                  is: n,
                  then: i,
                  not: a,
                  otherwise: o,
                  switch: r.switch
                }) : e.conditional(n, {
                  then: i,
                  otherwise: o
                });
              }
              return e;
            }

          },
          messages: {
            "alternatives.all": "{{#label}} does not match all of the required types",
            "alternatives.any": "{{#label}} does not match any of the allowed types",
            "alternatives.match": "{{#label}} does not match any of the allowed types",
            "alternatives.one": "{{#label}} matches more than one allowed type",
            "alternatives.types": "{{#label}} must be one of {{#types}}"
          }
        }), u.errors = function (e, t) {
          let {
            error: r,
            state: s
          } = t;
          if (!e.length) return {
            errors: r("alternatives.any")
          };
          if (1 === e.length) return {
            errors: e[0].reports
          };
          const n = new Set(),
                a = [];

          for (const {
            reports: t,
            schema: i
          } of e) {
            if (t.length > 1) return u.unmatched(e, r);
            const o = t[0];
            if (o instanceof l.Report == 0) return u.unmatched(e, r);

            if (o.state.path.length !== s.path.length) {
              a.push({
                type: i.type,
                report: o
              });
              continue;
            }

            if ("any.only" === o.code) {
              for (const e of o.local.valids) n.add(e);

              continue;
            }

            const [c, f] = o.code.split(".");
            "base" === f ? n.add(c) : a.push({
              type: i.type,
              report: o
            });
          }

          return a.length ? 1 === a.length ? {
            errors: a[0].report
          } : u.unmatched(e, r) : {
            errors: r("alternatives.types", {
              types: [...n]
            })
          };
        }, u.unmatched = function (e, t) {
          const r = [];

          for (const t of e) r.push(...t.reports);

          return {
            errors: t("alternatives.match", l.details(r, {
              override: !1
            }))
          };
        };
      },
      8068: (e, t, r) => {

        const s = r(375),
              n = r(7629),
              a = r(8160),
              i = r(6914);
        e.exports = n.extend({
          type: "any",
          flags: {
            only: {
              default: !1
            }
          },
          terms: {
            alterations: {
              init: null
            },
            examples: {
              init: null
            },
            externals: {
              init: null
            },
            metas: {
              init: []
            },
            notes: {
              init: []
            },
            shared: {
              init: null
            },
            tags: {
              init: []
            },
            whens: {
              init: null
            }
          },
          rules: {
            custom: {
              method(e, t) {
                return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
                  name: "custom",
                  args: {
                    method: e,
                    description: t
                  }
                });
              },

              validate(e, t, r) {
                let {
                  method: s
                } = r;

                try {
                  return s(e, t);
                } catch (e) {
                  return t.error("any.custom", {
                    error: e
                  });
                }
              },

              args: ["method", "description"],
              multi: !0
            },
            messages: {
              method(e) {
                return this.prefs({
                  messages: e
                });
              }

            },
            shared: {
              method(e) {
                s(a.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
                const t = this.clone();
                return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
              }

            },
            warning: {
              method(e, t) {
                return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
                  name: "warning",
                  args: {
                    code: e,
                    local: t
                  },
                  warn: !0
                });
              },

              validate(e, t, r) {
                let {
                  code: s,
                  local: n
                } = r;
                return t.error(s, n);
              },

              args: ["code", "local"],
              multi: !0
            }
          },
          modifiers: {
            keep(e) {
              let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
              e.keep = t;
            },

            message(e, t) {
              e.message = i.compile(t);
            },

            warn(e) {
              let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
              e.warn = t;
            }

          },
          manifest: {
            build(e, t) {
              for (const r in t) {
                const s = t[r];
                if (["examples", "externals", "metas", "notes", "tags"].includes(r)) for (const t of s) e = e[r.slice(0, -1)](t);else if ("alterations" !== r) {
                  if ("whens" !== r) {
                    if ("shared" === r) for (const t of s) e = e.shared(t);
                  } else for (const t of s) {
                    const {
                      ref: r,
                      is: s,
                      not: n,
                      then: a,
                      otherwise: i,
                      concat: o
                    } = t;
                    e = o ? e.concat(o) : r ? e.when(r, {
                      is: s,
                      not: n,
                      then: a,
                      otherwise: i,
                      switch: t.switch,
                      break: t.break
                    }) : e.when(s, {
                      then: a,
                      otherwise: i,
                      break: t.break
                    });
                  }
                } else {
                  const t = {};

                  for (const {
                    target: e,
                    adjuster: r
                  } of s) t[e] = r;

                  e = e.alter(t);
                }
              }

              return e;
            }

          },
          messages: {
            "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
            "any.default": "{{#label}} threw an error when running default method",
            "any.failover": "{{#label}} threw an error when running failover method",
            "any.invalid": "{{#label}} contains an invalid value",
            "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
            "any.ref": "{{#label}} {{#arg}} references {{:#ref}} which {{#reason}}",
            "any.required": "{{#label}} is required",
            "any.unknown": "{{#label}} is not allowed"
          }
        });
      },
      546: (e, t, r) => {

        const s = r(375),
              n = r(9474),
              a = r(9621),
              i = r(8068),
              o = r(8160),
              l = r(3292),
              c = {};
        e.exports = i.extend({
          type: "array",
          flags: {
            single: {
              default: !1
            },
            sparse: {
              default: !1
            }
          },
          terms: {
            items: {
              init: [],
              manifest: "schema"
            },
            ordered: {
              init: [],
              manifest: "schema"
            },
            _exclusions: {
              init: []
            },
            _inclusions: {
              init: []
            },
            _requireds: {
              init: []
            }
          },
          coerce: {
            from: "object",

            method(e, t) {
              let {
                schema: r,
                state: s,
                prefs: n
              } = t;
              if (!Array.isArray(e)) return;
              const a = r.$_getRule("sort");
              return a ? c.sort(r, e, a.args.options, s, n) : void 0;
            }

          },

          validate(e, t) {
            let {
              schema: r,
              error: s
            } = t;

            if (!Array.isArray(e)) {
              if (r._flags.single) {
                const t = [e];
                return t[o.symbols.arraySingle] = !0, {
                  value: t
                };
              }

              return {
                errors: s("array.base")
              };
            }

            if (r.$_getRule("items") || r.$_terms.externals) return {
              value: e.slice()
            };
          },

          rules: {
            has: {
              method(e) {
                e = this.$_compile(e, {
                  appendPath: !0
                });
                const t = this.$_addRule({
                  name: "has",
                  args: {
                    schema: e
                  }
                });
                return t.$_mutateRegister(e), t;
              },

              validate(e, t, r) {
                let {
                  state: s,
                  prefs: n,
                  error: a
                } = t,
                    {
                  schema: i
                } = r;
                const o = [e, ...s.ancestors];

                for (let t = 0; t < e.length; ++t) {
                  const r = s.localize([...s.path, t], o, i);
                  if (i.$_match(e[t], r, n)) return e;
                }

                const l = i._flags.label;
                return l ? a("array.hasKnown", {
                  patternLabel: l
                }) : a("array.hasUnknown", null);
              },

              multi: !0
            },
            items: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                o.verifyFlat(t, "items");
                const s = this.$_addRule("items");

                for (let e = 0; e < t.length; ++e) {
                  const r = o.tryWithPath(() => this.$_compile(t[e]), e, {
                    append: !0
                  });
                  s.$_terms.items.push(r);
                }

                return s.$_mutateRebuild();
              },

              validate(e, t) {
                let {
                  schema: r,
                  error: s,
                  state: n,
                  prefs: a,
                  errorsArray: i
                } = t;

                const l = r.$_terms._requireds.slice(),
                      u = r.$_terms.ordered.slice(),
                      f = [...r.$_terms._inclusions, ...l],
                      h = !e[o.symbols.arraySingle];

                delete e[o.symbols.arraySingle];
                const m = i();
                let d = e.length;

                for (let t = 0; t < d; ++t) {
                  const i = e[t];
                  let o = !1,
                      p = !1;
                  const g = h ? t : new Number(t),
                        y = [...n.path, g];

                  if (!r._flags.sparse && void 0 === i) {
                    if (m.push(s("array.sparse", {
                      key: g,
                      path: y,
                      pos: t,
                      value: void 0
                    }, n.localize(y))), a.abortEarly) return m;
                    u.shift();
                    continue;
                  }

                  const b = [e, ...n.ancestors];

                  for (const e of r.$_terms._exclusions) if (e.$_match(i, n.localize(y, b, e), a, {
                    presence: "ignore"
                  })) {
                    if (m.push(s("array.excludes", {
                      pos: t,
                      value: i
                    }, n.localize(y))), a.abortEarly) return m;
                    o = !0, u.shift();
                    break;
                  }

                  if (o) continue;

                  if (r.$_terms.ordered.length) {
                    if (u.length) {
                      const o = u.shift(),
                            l = o.$_validate(i, n.localize(y, b, o), a);

                      if (l.errors) {
                        if (m.push(...l.errors), a.abortEarly) return m;
                      } else if ("strip" === o._flags.result) c.fastSplice(e, t), --t, --d;else {
                        if (!r._flags.sparse && void 0 === l.value) {
                          if (m.push(s("array.sparse", {
                            key: g,
                            path: y,
                            pos: t,
                            value: void 0
                          }, n.localize(y))), a.abortEarly) return m;
                          continue;
                        }

                        e[t] = l.value;
                      }

                      continue;
                    }

                    if (!r.$_terms.items.length) {
                      if (m.push(s("array.orderedLength", {
                        pos: t,
                        limit: r.$_terms.ordered.length
                      })), a.abortEarly) return m;
                      break;
                    }
                  }

                  const v = [];
                  let _ = l.length;

                  for (let o = 0; o < _; ++o) {
                    const u = n.localize(y, b, l[o]);
                    u.snapshot();
                    const f = l[o].$_validate(i, u, a);

                    if (v[o] = f, !f.errors) {
                      if (u.commit(), e[t] = f.value, p = !0, c.fastSplice(l, o), --o, --_, !r._flags.sparse && void 0 === f.value && (m.push(s("array.sparse", {
                        key: g,
                        path: y,
                        pos: t,
                        value: void 0
                      }, n.localize(y))), a.abortEarly)) return m;
                      break;
                    }

                    u.restore();
                  }

                  if (p) continue;
                  const w = a.stripUnknown && !!a.stripUnknown.arrays || !1;
                  _ = f.length;

                  for (const u of f) {
                    let f;
                    const h = l.indexOf(u);
                    if (-1 !== h) f = v[h];else {
                      const l = n.localize(y, b, u);

                      if (l.snapshot(), f = u.$_validate(i, l, a), !f.errors) {
                        l.commit(), "strip" === u._flags.result ? (c.fastSplice(e, t), --t, --d) : r._flags.sparse || void 0 !== f.value ? e[t] = f.value : (m.push(s("array.sparse", {
                          key: g,
                          path: y,
                          pos: t,
                          value: void 0
                        }, n.localize(y))), o = !0), p = !0;
                        break;
                      }

                      l.restore();
                    }

                    if (1 === _) {
                      if (w) {
                        c.fastSplice(e, t), --t, --d, p = !0;
                        break;
                      }

                      if (m.push(...f.errors), a.abortEarly) return m;
                      o = !0;
                      break;
                    }
                  }

                  if (!o && (r.$_terms._inclusions.length || r.$_terms._requireds.length) && !p) {
                    if (w) {
                      c.fastSplice(e, t), --t, --d;
                      continue;
                    }

                    if (m.push(s("array.includes", {
                      pos: t,
                      value: i
                    }, n.localize(y))), a.abortEarly) return m;
                  }
                }

                return l.length && c.fillMissedErrors(r, m, l, e, n, a), u.length && (c.fillOrderedErrors(r, m, u, e, n, a), m.length || c.fillDefault(u, e, n, a)), m.length ? m : e;
              },

              priority: !0,
              manifest: !1
            },
            length: {
              method(e) {
                return this.$_addRule({
                  name: "length",
                  args: {
                    limit: e
                  },
                  operator: "="
                });
              },

              validate(e, t, r, s) {
                let {
                  limit: n
                } = r,
                    {
                  name: a,
                  operator: i,
                  args: l
                } = s;
                return o.compare(e.length, n, i) ? e : t.error("array." + a, {
                  limit: l.limit,
                  value: e
                });
              },

              args: [{
                name: "limit",
                ref: !0,
                assert: o.limit,
                message: "must be a positive integer"
              }]
            },
            max: {
              method(e) {
                return this.$_addRule({
                  name: "max",
                  method: "length",
                  args: {
                    limit: e
                  },
                  operator: "<="
                });
              }

            },
            min: {
              method(e) {
                return this.$_addRule({
                  name: "min",
                  method: "length",
                  args: {
                    limit: e
                  },
                  operator: ">="
                });
              }

            },
            ordered: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                o.verifyFlat(t, "ordered");
                const s = this.$_addRule("items");

                for (let e = 0; e < t.length; ++e) {
                  const r = o.tryWithPath(() => this.$_compile(t[e]), e, {
                    append: !0
                  });
                  c.validateSingle(r, s), s.$_mutateRegister(r), s.$_terms.ordered.push(r);
                }

                return s.$_mutateRebuild();
              }

            },
            single: {
              method(e) {
                const t = void 0 === e || !!e;
                return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
              }

            },
            sort: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                o.assertOptions(e, ["by", "order"]);
                const t = {
                  order: e.order || "ascending"
                };
                return e.by && (t.by = l.ref(e.by, {
                  ancestor: 0
                }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
                  name: "sort",
                  args: {
                    options: t
                  }
                });
              },

              validate(e, t, r) {
                let {
                  error: s,
                  state: n,
                  prefs: a,
                  schema: i
                } = t,
                    {
                  options: o
                } = r;
                const {
                  value: l,
                  errors: u
                } = c.sort(i, e, o, n, a);
                if (u) return u;

                for (let t = 0; t < e.length; ++t) if (e[t] !== l[t]) return s("array.sort", {
                  order: o.order,
                  by: o.by ? o.by.key : "value"
                });

                return e;
              },

              convert: !0
            },
            sparse: {
              method(e) {
                const t = void 0 === e || !!e;
                return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
                  clone: !1
                });
              }

            },
            unique: {
              method(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), o.assertOptions(t, ["ignoreUndefined", "separator"]);
                const r = {
                  name: "unique",
                  args: {
                    options: t,
                    comparator: e
                  }
                };
                if (e) if ("string" == typeof e) {
                  const s = o.default(t.separator, ".");
                  r.path = s ? e.split(s) : [e];
                } else r.comparator = e;
                return this.$_addRule(r);
              },

              validate(e, t, r, i) {
                let {
                  state: o,
                  error: l,
                  schema: c
                } = t,
                    {
                  comparator: u,
                  options: f
                } = r,
                    {
                  comparator: h,
                  path: m
                } = i;
                const d = {
                  string: Object.create(null),
                  number: Object.create(null),
                  undefined: Object.create(null),
                  boolean: Object.create(null),
                  object: new Map(),
                  function: new Map(),
                  custom: new Map()
                },
                      p = h || n,
                      g = f.ignoreUndefined;

                for (let t = 0; t < e.length; ++t) {
                  const r = m ? a(e[t], m) : e[t],
                        n = h ? d.custom : d[typeof r];

                  if (s(n, "Failed to find unique map container for type", typeof r), n instanceof Map) {
                    const s = n.entries();
                    let a;

                    for (; !(a = s.next()).done;) if (p(a.value[0], r)) {
                      const r = o.localize([...o.path, t], [e, ...o.ancestors]),
                            s = {
                        pos: t,
                        value: e[t],
                        dupePos: a.value[1],
                        dupeValue: e[a.value[1]]
                      };
                      return m && (s.path = u), l("array.unique", s, r);
                    }

                    n.set(r, t);
                  } else {
                    if ((!g || void 0 !== r) && void 0 !== n[r]) {
                      const s = {
                        pos: t,
                        value: e[t],
                        dupePos: n[r],
                        dupeValue: e[n[r]]
                      };
                      return m && (s.path = u), l("array.unique", s, o.localize([...o.path, t], [e, ...o.ancestors]));
                    }

                    n[r] = t;
                  }
                }

                return e;
              },

              args: ["comparator", "options"],
              multi: !0
            }
          },
          cast: {
            set: {
              from: Array.isArray,
              to: (e, t) => new Set(e)
            }
          },

          rebuild(e) {
            e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];

            for (const t of e.$_terms.items) c.validateSingle(t, e), "required" === t._flags.presence ? e.$_terms._requireds.push(t) : "forbidden" === t._flags.presence ? e.$_terms._exclusions.push(t) : e.$_terms._inclusions.push(t);

            for (const t of e.$_terms.ordered) c.validateSingle(t, e);
          },

          manifest: {
            build: (e, t) => (t.items && (e = e.items(...t.items)), t.ordered && (e = e.ordered(...t.ordered)), e)
          },
          messages: {
            "array.base": "{{#label}} must be an array",
            "array.excludes": "{{#label}} contains an excluded value",
            "array.hasKnown": "{{#label}} does not contain at least one required match for type {:#patternLabel}",
            "array.hasUnknown": "{{#label}} does not contain at least one required match",
            "array.includes": "{{#label}} does not match any of the allowed types",
            "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
            "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
            "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
            "array.length": "{{#label}} must contain {{#limit}} items",
            "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
            "array.min": "{{#label}} must contain at least {{#limit}} items",
            "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
            "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
            "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
            "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
            "array.sparse": "{{#label}} must not be a sparse array item",
            "array.unique": "{{#label}} contains a duplicate value"
          }
        }), c.fillMissedErrors = function (e, t, r, s, n, a) {
          const i = [];
          let o = 0;

          for (const e of r) {
            const t = e._flags.label;
            t ? i.push(t) : ++o;
          }

          i.length ? o ? t.push(e.$_createError("array.includesRequiredBoth", s, {
            knownMisses: i,
            unknownMisses: o
          }, n, a)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
            knownMisses: i
          }, n, a)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
            unknownMisses: o
          }, n, a));
        }, c.fillOrderedErrors = function (e, t, r, s, n, a) {
          const i = [];

          for (const e of r) "required" === e._flags.presence && i.push(e);

          i.length && c.fillMissedErrors(e, t, i, s, n, a);
        }, c.fillDefault = function (e, t, r, s) {
          const n = [];
          let a = !0;

          for (let i = e.length - 1; i >= 0; --i) {
            const o = e[i],
                  l = [t, ...r.ancestors],
                  c = o.$_validate(void 0, r.localize(r.path, l, o), s).value;

            if (a) {
              if (void 0 === c) continue;
              a = !1;
            }

            n.unshift(c);
          }

          n.length && t.push(...n);
        }, c.fastSplice = function (e, t) {
          let r = t;

          for (; r < e.length;) e[r++] = e[r];

          --e.length;
        }, c.validateSingle = function (e, t) {
          ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
            clone: !1
          }));
        }, c.sort = function (e, t, r, s, n) {
          const a = "ascending" === r.order ? 1 : -1,
                i = -1 * a,
                o = a,
                l = (l, u) => {
            let f = c.compare(l, u, i, o);
            if (null !== f) return f;
            if (r.by && (l = r.by.resolve(l, s, n), u = r.by.resolve(u, s, n)), f = c.compare(l, u, i, o), null !== f) return f;
            const h = typeof l;
            if (h !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
            if ("number" !== h && "string" !== h) throw e.$_createError("array.sort.unsupported", t, {
              type: h
            }, s, n);
            return "number" === h ? (l - u) * a : l < u ? i : o;
          };

          try {
            return {
              value: t.slice().sort(l)
            };
          } catch (e) {
            return {
              errors: e
            };
          }
        }, c.compare = function (e, t, r, s) {
          return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
        };
      },
      4937: (e, t, r) => {

        const s = r(375),
              n = r(8068),
              a = r(8160),
              i = r(2036),
              o = {
          isBool: function isBool(e) {
            return "boolean" == typeof e;
          }
        };
        e.exports = n.extend({
          type: "boolean",
          flags: {
            sensitive: {
              default: !1
            }
          },
          terms: {
            falsy: {
              init: null,
              manifest: "values"
            },
            truthy: {
              init: null,
              manifest: "values"
            }
          },

          coerce(e, t) {
            let {
              schema: r
            } = t;

            if ("boolean" != typeof e) {
              if ("string" == typeof e) {
                const t = r._flags.sensitive ? e : e.toLowerCase();
                e = "true" === t || "false" !== t && e;
              }

              return "boolean" != typeof e && (e = r.$_terms.truthy && r.$_terms.truthy.has(e, null, null, !r._flags.sensitive) || (!r.$_terms.falsy || !r.$_terms.falsy.has(e, null, null, !r._flags.sensitive)) && e), {
                value: e
              };
            }
          },

          validate(e, t) {
            let {
              error: r
            } = t;
            if ("boolean" != typeof e) return {
              value: e,
              errors: r("boolean.base")
            };
          },

          rules: {
            truthy: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                a.verifyFlat(t, "truthy");
                const n = this.clone();
                n.$_terms.truthy = n.$_terms.truthy || new i();

                for (let e = 0; e < t.length; ++e) {
                  const r = t[e];
                  s(void 0 !== r, "Cannot call truthy with undefined"), n.$_terms.truthy.add(r);
                }

                return n;
              }

            },
            falsy: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                a.verifyFlat(t, "falsy");
                const n = this.clone();
                n.$_terms.falsy = n.$_terms.falsy || new i();

                for (let e = 0; e < t.length; ++e) {
                  const r = t[e];
                  s(void 0 !== r, "Cannot call falsy with undefined"), n.$_terms.falsy.add(r);
                }

                return n;
              }

            },
            sensitive: {
              method() {
                let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return this.$_setFlag("sensitive", e);
              }

            }
          },
          cast: {
            number: {
              from: o.isBool,
              to: (e, t) => e ? 1 : 0
            },
            string: {
              from: o.isBool,
              to: (e, t) => e ? "true" : "false"
            }
          },
          manifest: {
            build: (e, t) => (t.truthy && (e = e.truthy(...t.truthy)), t.falsy && (e = e.falsy(...t.falsy)), e)
          },
          messages: {
            "boolean.base": "{{#label}} must be a boolean"
          }
        });
      },
      7500: (e, t, r) => {

        const s = r(375),
              n = r(8068),
              a = r(8160),
              i = r(3328),
              o = {
          isDate: function isDate(e) {
            return e instanceof Date;
          }
        };
        e.exports = n.extend({
          type: "date",
          coerce: {
            from: ["number", "string"],

            method(e, t) {
              let {
                schema: r
              } = t;
              return {
                value: o.parse(e, r._flags.format) || e
              };
            }

          },

          validate(e, t) {
            let {
              schema: r,
              error: s,
              prefs: n
            } = t;
            if (e instanceof Date && !isNaN(e.getTime())) return;
            const a = r._flags.format;
            return n.convert && a && "string" == typeof e ? {
              value: e,
              errors: s("date.format", {
                format: a
              })
            } : {
              value: e,
              errors: s("date.base")
            };
          },

          rules: {
            compare: {
              method: !1,

              validate(e, t, r, s) {
                let {
                  date: n
                } = r,
                    {
                  name: i,
                  operator: o,
                  args: l
                } = s;
                const c = "now" === n ? Date.now() : n.getTime();
                return a.compare(e.getTime(), c, o) ? e : t.error("date." + i, {
                  limit: l.date,
                  value: e
                });
              },

              args: [{
                name: "date",
                ref: !0,
                normalize: e => "now" === e ? e : o.parse(e),
                assert: e => null !== e,
                message: "must have a valid date format"
              }]
            },
            format: {
              method(e) {
                return s(["iso", "javascript", "unix"].includes(e), "Unknown date format", e), this.$_setFlag("format", e);
              }

            },
            greater: {
              method(e) {
                return this.$_addRule({
                  name: "greater",
                  method: "compare",
                  args: {
                    date: e
                  },
                  operator: ">"
                });
              }

            },
            iso: {
              method() {
                return this.format("iso");
              }

            },
            less: {
              method(e) {
                return this.$_addRule({
                  name: "less",
                  method: "compare",
                  args: {
                    date: e
                  },
                  operator: "<"
                });
              }

            },
            max: {
              method(e) {
                return this.$_addRule({
                  name: "max",
                  method: "compare",
                  args: {
                    date: e
                  },
                  operator: "<="
                });
              }

            },
            min: {
              method(e) {
                return this.$_addRule({
                  name: "min",
                  method: "compare",
                  args: {
                    date: e
                  },
                  operator: ">="
                });
              }

            },
            timestamp: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "javascript";
                return s(["javascript", "unix"].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
              }

            }
          },
          cast: {
            number: {
              from: o.isDate,
              to: (e, t) => e.getTime()
            },
            string: {
              from: o.isDate,

              to(e, t) {
                let {
                  prefs: r
                } = t;
                return i.date(e, r);
              }

            }
          },
          messages: {
            "date.base": "{{#label}} must be a valid date",
            "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
            "date.greater": "{{#label}} must be greater than {{:#limit}}",
            "date.less": "{{#label}} must be less than {{:#limit}}",
            "date.max": "{{#label}} must be less than or equal to {{:#limit}}",
            "date.min": "{{#label}} must be greater than or equal to {{:#limit}}",
            "date.format.iso": "ISO 8601 date",
            "date.format.javascript": "timestamp or number of milliseconds",
            "date.format.unix": "timestamp or number of seconds"
          }
        }), o.parse = function (e, t) {
          if (e instanceof Date) return e;
          if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
          if (/^\s*$/.test(e)) return null;
          if ("iso" === t) return a.isIsoDate(e) ? o.date(e.toString()) : null;
          const r = e;

          if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
            if ("javascript" === t) return o.date(1 * e);
            if ("unix" === t) return o.date(1e3 * e);
            if ("string" == typeof r) return null;
          }

          return o.date(e);
        }, o.date = function (e) {
          const t = new Date(e);
          return isNaN(t.getTime()) ? null : t;
        };
      },
      390: (e, t, r) => {

        const s = r(375),
              n = r(7824);
        e.exports = n.extend({
          type: "function",
          properties: {
            typeof: "function"
          },
          rules: {
            arity: {
              method(e) {
                return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                  name: "arity",
                  args: {
                    n: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  n: s
                } = r;
                return e.length === s ? e : t.error("function.arity", {
                  n: s
                });
              }

            },
            class: {
              method() {
                return this.$_addRule("class");
              },

              validate: (e, t) => /^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
                value: e
              })
            },
            minArity: {
              method(e) {
                return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
                  name: "minArity",
                  args: {
                    n: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  n: s
                } = r;
                return e.length >= s ? e : t.error("function.minArity", {
                  n: s
                });
              }

            },
            maxArity: {
              method(e) {
                return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                  name: "maxArity",
                  args: {
                    n: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  n: s
                } = r;
                return e.length <= s ? e : t.error("function.maxArity", {
                  n: s
                });
              }

            }
          },
          messages: {
            "function.arity": "{{#label}} must have an arity of {{#n}}",
            "function.class": "{{#label}} must be a class",
            "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
            "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
          }
        });
      },
      7824: (e, t, r) => {

        const s = r(978),
              n = r(375),
              a = r(8571),
              i = r(3652),
              o = r(8068),
              l = r(8160),
              c = r(3292),
              u = r(6354),
              f = r(6133),
              h = r(3328),
              m = {
          renameDefaults: {
            alias: !1,
            multiple: !1,
            override: !1
          }
        };
        e.exports = o.extend({
          type: "_keys",
          properties: {
            typeof: "object"
          },
          flags: {
            unknown: {
              default: !1
            }
          },
          terms: {
            dependencies: {
              init: null
            },
            keys: {
              init: null,
              manifest: {
                mapped: {
                  from: "schema",
                  to: "key"
                }
              }
            },
            patterns: {
              init: null
            },
            renames: {
              init: null
            }
          },
          args: (e, t) => e.keys(t),

          validate(e, t) {
            let {
              schema: r,
              error: s,
              state: n,
              prefs: a
            } = t;
            if (!e || typeof e !== r.$_property("typeof") || Array.isArray(e)) return {
              value: e,
              errors: s("object.base", {
                type: r.$_property("typeof")
              })
            };
            if (!(r.$_terms.renames || r.$_terms.dependencies || r.$_terms.keys || r.$_terms.patterns || r.$_terms.externals)) return;
            e = m.clone(e, a);
            const i = [];
            if (r.$_terms.renames && !m.rename(r, e, n, a, i)) return {
              value: e,
              errors: i
            };
            if (!r.$_terms.keys && !r.$_terms.patterns && !r.$_terms.dependencies) return {
              value: e,
              errors: i
            };
            const o = new Set(Object.keys(e));

            if (r.$_terms.keys) {
              const t = [e, ...n.ancestors];

              for (const s of r.$_terms.keys) {
                const r = s.key,
                      l = e[r];
                o.delete(r);
                const c = n.localize([...n.path, r], t, s),
                      u = s.schema.$_validate(l, c, a);

                if (u.errors) {
                  if (a.abortEarly) return {
                    value: e,
                    errors: u.errors
                  };
                  void 0 !== u.value && (e[r] = u.value), i.push(...u.errors);
                } else "strip" === s.schema._flags.result || void 0 === u.value && void 0 !== l ? delete e[r] : void 0 !== u.value && (e[r] = u.value);
              }
            }

            if (o.size || r._flags._hasPatternMatch) {
              const t = m.unknown(r, e, o, i, n, a);
              if (t) return t;
            }

            if (r.$_terms.dependencies) for (const t of r.$_terms.dependencies) {
              if (null !== t.key && !1 === m.isPresent(t.options)(t.key.resolve(e, n, a, null, {
                shadow: !1
              }))) continue;
              const s = m.dependencies[t.rel](r, t, e, n, a);

              if (s) {
                const t = r.$_createError(s.code, e, s.context, n, a);
                if (a.abortEarly) return {
                  value: e,
                  errors: t
                };
                i.push(t);
              }
            }
            return {
              value: e,
              errors: i
            };
          },

          rules: {
            and: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                return l.verifyFlat(t, "and"), m.dependency(this, "and", null, t);
              }

            },
            append: {
              method(e) {
                return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
              }

            },
            assert: {
              method(e, t, r) {
                h.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
                  appendPath: !0
                });
                const s = this.$_addRule({
                  name: "assert",
                  args: {
                    subject: e,
                    schema: t,
                    message: r
                  }
                });
                return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
              },

              validate(e, t, r) {
                let {
                  error: s,
                  prefs: n,
                  state: a
                } = t,
                    {
                  subject: i,
                  schema: o,
                  message: l
                } = r;
                const c = i.resolve(e, a, n),
                      u = f.isRef(i) ? i.absolute(a) : [];
                return o.$_match(c, a.localize(u, [e, ...a.ancestors], o), n) ? e : s("object.assert", {
                  subject: i,
                  message: l
                });
              },

              args: ["subject", "schema", "message"],
              multi: !0
            },
            instance: {
              method(e, t) {
                return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
                  name: "instance",
                  args: {
                    constructor: e,
                    name: t
                  }
                });
              },

              validate(e, t, r) {
                let {
                  constructor: s,
                  name: n
                } = r;
                return e instanceof s ? e : t.error("object.instance", {
                  type: n,
                  value: e
                });
              },

              args: ["constructor", "name"]
            },
            keys: {
              method(e) {
                n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
                const t = this.clone();
                if (e) {
                  if (Object.keys(e).length) {
                    t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter(t => !e.hasOwnProperty(t.key)) : new m.Keys();

                    for (const r in e) l.tryWithPath(() => t.$_terms.keys.push({
                      key: r,
                      schema: this.$_compile(e[r])
                    }), r);
                  } else t.$_terms.keys = new m.Keys();
                } else t.$_terms.keys = null;
                return t.$_mutateRebuild();
              }

            },
            length: {
              method(e) {
                return this.$_addRule({
                  name: "length",
                  args: {
                    limit: e
                  },
                  operator: "="
                });
              },

              validate(e, t, r, s) {
                let {
                  limit: n
                } = r,
                    {
                  name: a,
                  operator: i,
                  args: o
                } = s;
                return l.compare(Object.keys(e).length, n, i) ? e : t.error("object." + a, {
                  limit: o.limit,
                  value: e
                });
              },

              args: [{
                name: "limit",
                ref: !0,
                assert: l.limit,
                message: "must be a positive integer"
              }]
            },
            max: {
              method(e) {
                return this.$_addRule({
                  name: "max",
                  method: "length",
                  args: {
                    limit: e
                  },
                  operator: "<="
                });
              }

            },
            min: {
              method(e) {
                return this.$_addRule({
                  name: "min",
                  method: "length",
                  args: {
                    limit: e
                  },
                  operator: ">="
                });
              }

            },
            nand: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                return l.verifyFlat(t, "nand"), m.dependency(this, "nand", null, t);
              }

            },
            or: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                return l.verifyFlat(t, "or"), m.dependency(this, "or", null, t);
              }

            },
            oxor: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                return m.dependency(this, "oxor", null, t);
              }

            },
            pattern: {
              method(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                const s = e instanceof RegExp;
                s || (e = this.$_compile(e, {
                  appendPath: !0
                })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, ["fallthrough", "matches"]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
                  appendPath: !0
                });
                const a = this.clone();
                a.$_terms.patterns = a.$_terms.patterns || [];
                const i = {
                  [s ? "regex" : "schema"]: e,
                  rule: t
                };
                return r.matches && (i.matches = this.$_compile(r.matches), "array" !== i.matches.type && (i.matches = i.matches.$_root.array().items(i.matches)), a.$_mutateRegister(i.matches), a.$_setFlag("_hasPatternMatch", !0, {
                  clone: !1
                })), r.fallthrough && (i.fallthrough = !0), a.$_terms.patterns.push(i), a.$_mutateRegister(t), a;
              }

            },
            ref: {
              method() {
                return this.$_addRule("ref");
              },

              validate: (e, t) => f.isRef(e) ? e : t.error("object.refType", {
                value: e
              })
            },
            regex: {
              method() {
                return this.$_addRule("regex");
              },

              validate: (e, t) => e instanceof RegExp ? e : t.error("object.regex", {
                value: e
              })
            },
            rename: {
              method(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof h, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, ["alias", "ignoreUndefined", "override", "multiple"]);
                const a = this.clone();
                a.$_terms.renames = a.$_terms.renames || [];

                for (const t of a.$_terms.renames) n(t.from !== e, "Cannot rename the same key multiple times");

                return t instanceof h && a.$_mutateRegister(t), a.$_terms.renames.push({
                  from: e,
                  to: t,
                  options: s(m.renameDefaults, r)
                }), a;
              }

            },
            schema: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "any";
                return this.$_addRule({
                  name: "schema",
                  args: {
                    type: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  type: s
                } = r;
                return !l.isSchema(e) || "any" !== s && e.type !== s ? t.error("object.schema", {
                  type: s
                }) : e;
              }

            },
            unknown: {
              method(e) {
                return this.$_setFlag("unknown", !1 !== e);
              }

            },
            with: {
              method(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return m.dependency(this, "with", e, t, r);
              }

            },
            without: {
              method(e, t) {
                let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return m.dependency(this, "without", e, t, r);
              }

            },
            xor: {
              method() {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

                return l.verifyFlat(t, "xor"), m.dependency(this, "xor", null, t);
              }

            }
          },
          overrides: {
            default(e, t) {
              return void 0 === e && (e = l.symbols.deepDefault), this.$_parent("default", e, t);
            }

          },

          rebuild(e) {
            if (e.$_terms.keys) {
              const t = new i.Sorter();

              for (const r of e.$_terms.keys) l.tryWithPath(() => t.add(r, {
                after: r.schema.$_rootReferences(),
                group: r.key
              }), r.key);

              e.$_terms.keys = new m.Keys(...t.nodes);
            }
          },

          manifest: {
            build(e, t) {
              if (t.keys && (e = e.keys(t.keys)), t.dependencies) for (const {
                rel: r,
                key: s = null,
                peers: n,
                options: a
              } of t.dependencies) e = m.dependency(e, r, s, n, a);
              if (t.patterns) for (const {
                regex: r,
                schema: s,
                rule: n,
                fallthrough: a,
                matches: i
              } of t.patterns) e = e.pattern(r || s, n, {
                fallthrough: a,
                matches: i
              });
              if (t.renames) for (const {
                from: r,
                to: s,
                options: n
              } of t.renames) e = e.rename(r, s, n);
              return e;
            }

          },
          messages: {
            "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
            "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
            "object.base": "{{#label}} must be of type {{#type}}",
            "object.instance": "{{#label}} must be an instance of {{:#type}}",
            "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
            "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
            "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
            "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
            "object.nand": "{{:#mainWithLabel}} must not exist simultaneously with {{#peersWithLabels}}",
            "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
            "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
            "object.refType": "{{#label}} must be a Joi reference",
            "object.regex": "{{#label}} must be a RegExp object",
            "object.rename.multiple": "{{#label}} cannot rename {{:#from}} because multiple renames are disabled and another key was already renamed to {{:#to}}",
            "object.rename.override": "{{#label}} cannot rename {{:#from}} because override is disabled and target {{:#to}} exists",
            "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
            "object.unknown": "{{#label}} is not allowed",
            "object.with": "{{:#mainWithLabel}} missing required peer {{:#peerWithLabel}}",
            "object.without": "{{:#mainWithLabel}} conflict with forbidden peer {{:#peerWithLabel}}",
            "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
          }
        }), m.clone = function (e, t) {
          if ("object" == typeof e) {
            if (t.nonEnumerables) return a(e, {
              shallow: !0
            });
            const r = Object.create(Object.getPrototypeOf(e));
            return Object.assign(r, e), r;
          }

          const r = function r() {
            for (var t = arguments.length, r = new Array(t), s = 0; s < t; s++) r[s] = arguments[s];

            return e.apply(this, r);
          };

          return r.prototype = a(e.prototype), Object.defineProperty(r, "name", {
            value: e.name,
            writable: !1
          }), Object.defineProperty(r, "length", {
            value: e.length,
            writable: !1
          }), Object.assign(r, e), r;
        }, m.dependency = function (e, t, r, s, a) {
          n(null === r || "string" == typeof r, t, "key must be a strings"), a || (a = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(a, ["separator", "isPresent"]), s = [].concat(s);
          const i = l.default(a.separator, "."),
                o = [];

          for (const e of s) n("string" == typeof e, t, "peers must be strings"), o.push(c.ref(e, {
            separator: i,
            ancestor: 0,
            prefix: !1
          }));

          null !== r && (r = c.ref(r, {
            separator: i,
            ancestor: 0,
            prefix: !1
          }));
          const u = e.clone();
          return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new m.Dependency(t, r, o, s, a)), u;
        }, m.dependencies = {
          and(e, t, r, s, n) {
            const a = [],
                  i = [],
                  o = t.peers.length,
                  l = m.isPresent(t.options);

            for (const e of t.peers) !1 === l(e.resolve(r, s, n, null, {
              shadow: !1
            })) ? a.push(e.key) : i.push(e.key);

            if (a.length !== o && i.length !== o) return {
              code: "object.and",
              context: {
                present: i,
                presentWithLabels: m.keysToLabels(e, i),
                missing: a,
                missingWithLabels: m.keysToLabels(e, a)
              }
            };
          },

          nand(e, t, r, s, n) {
            const a = [],
                  i = m.isPresent(t.options);

            for (const e of t.peers) i(e.resolve(r, s, n, null, {
              shadow: !1
            })) && a.push(e.key);

            if (a.length !== t.peers.length) return;
            const o = t.paths[0],
                  l = t.paths.slice(1);
            return {
              code: "object.nand",
              context: {
                main: o,
                mainWithLabel: m.keysToLabels(e, o),
                peers: l,
                peersWithLabels: m.keysToLabels(e, l)
              }
            };
          },

          or(e, t, r, s, n) {
            const a = m.isPresent(t.options);

            for (const e of t.peers) if (a(e.resolve(r, s, n, null, {
              shadow: !1
            }))) return;

            return {
              code: "object.missing",
              context: {
                peers: t.paths,
                peersWithLabels: m.keysToLabels(e, t.paths)
              }
            };
          },

          oxor(e, t, r, s, n) {
            const a = [],
                  i = m.isPresent(t.options);

            for (const e of t.peers) i(e.resolve(r, s, n, null, {
              shadow: !1
            })) && a.push(e.key);

            if (!a.length || 1 === a.length) return;
            const o = {
              peers: t.paths,
              peersWithLabels: m.keysToLabels(e, t.paths)
            };
            return o.present = a, o.presentWithLabels = m.keysToLabels(e, a), {
              code: "object.oxor",
              context: o
            };
          },

          with(e, t, r, s, n) {
            const a = m.isPresent(t.options);

            for (const i of t.peers) if (!1 === a(i.resolve(r, s, n, null, {
              shadow: !1
            }))) return {
              code: "object.with",
              context: {
                main: t.key.key,
                mainWithLabel: m.keysToLabels(e, t.key.key),
                peer: i.key,
                peerWithLabel: m.keysToLabels(e, i.key)
              }
            };
          },

          without(e, t, r, s, n) {
            const a = m.isPresent(t.options);

            for (const i of t.peers) if (a(i.resolve(r, s, n, null, {
              shadow: !1
            }))) return {
              code: "object.without",
              context: {
                main: t.key.key,
                mainWithLabel: m.keysToLabels(e, t.key.key),
                peer: i.key,
                peerWithLabel: m.keysToLabels(e, i.key)
              }
            };
          },

          xor(e, t, r, s, n) {
            const a = [],
                  i = m.isPresent(t.options);

            for (const e of t.peers) i(e.resolve(r, s, n, null, {
              shadow: !1
            })) && a.push(e.key);

            if (1 === a.length) return;
            const o = {
              peers: t.paths,
              peersWithLabels: m.keysToLabels(e, t.paths)
            };
            return 0 === a.length ? {
              code: "object.missing",
              context: o
            } : (o.present = a, o.presentWithLabels = m.keysToLabels(e, a), {
              code: "object.xor",
              context: o
            });
          }

        }, m.keysToLabels = function (e, t) {
          return Array.isArray(t) ? t.map(t => e.$_mapLabels(t)) : e.$_mapLabels(t);
        }, m.isPresent = function (e) {
          return "function" == typeof e.isPresent ? e.isPresent : e => void 0 !== e;
        }, m.rename = function (e, t, r, s, n) {
          const a = {};

          for (const i of e.$_terms.renames) {
            const o = [],
                  l = "string" != typeof i.from;
            if (l) for (const e in t) {
              if (void 0 === t[e] && i.options.ignoreUndefined) continue;
              if (e === i.to) continue;
              const r = i.from.exec(e);
              r && o.push({
                from: e,
                to: i.to,
                match: r
              });
            } else !Object.prototype.hasOwnProperty.call(t, i.from) || void 0 === t[i.from] && i.options.ignoreUndefined || o.push(i);

            for (const c of o) {
              const o = c.from;
              let u = c.to;

              if (u instanceof h && (u = u.render(t, r, s, c.match)), o !== u) {
                if (!i.options.multiple && a[u] && (n.push(e.$_createError("object.rename.multiple", t, {
                  from: o,
                  to: u,
                  pattern: l
                }, r, s)), s.abortEarly)) return !1;
                if (Object.prototype.hasOwnProperty.call(t, u) && !i.options.override && !a[u] && (n.push(e.$_createError("object.rename.override", t, {
                  from: o,
                  to: u,
                  pattern: l
                }, r, s)), s.abortEarly)) return !1;
                void 0 === t[o] ? delete t[u] : t[u] = t[o], a[u] = !0, i.options.alias || delete t[o];
              }
            }
          }

          return !0;
        }, m.unknown = function (e, t, r, s, n, a) {
          if (e.$_terms.patterns) {
            let i = !1;
            const o = e.$_terms.patterns.map(e => {
              if (e.matches) return i = !0, [];
            }),
                  l = [t, ...n.ancestors];

            for (const i of r) {
              const c = t[i],
                    u = [...n.path, i];

              for (let f = 0; f < e.$_terms.patterns.length; ++f) {
                const h = e.$_terms.patterns[f];

                if (h.regex) {
                  const e = h.regex.test(i);
                  if (n.mainstay.tracer.debug(n, "rule", "pattern.".concat(f), e ? "pass" : "error"), !e) continue;
                } else if (!h.schema.$_match(i, n.nest(h.schema, "pattern.".concat(f)), a)) continue;

                r.delete(i);
                const m = n.localize(u, l, {
                  schema: h.rule,
                  key: i
                }),
                      d = h.rule.$_validate(c, m, a);

                if (d.errors) {
                  if (a.abortEarly) return {
                    value: t,
                    errors: d.errors
                  };
                  s.push(...d.errors);
                }

                if (h.matches && o[f].push(i), t[i] = d.value, !h.fallthrough) break;
              }
            }

            if (i) for (let r = 0; r < o.length; ++r) {
              const i = o[r];
              if (!i) continue;
              const c = e.$_terms.patterns[r].matches,
                    f = n.localize(n.path, l, c),
                    h = c.$_validate(i, f, a);

              if (h.errors) {
                const r = u.details(h.errors, {
                  override: !1
                });
                r.matches = i;
                const o = e.$_createError("object.pattern.match", t, r, n, a);
                if (a.abortEarly) return {
                  value: t,
                  errors: o
                };
                s.push(o);
              }
            }
          }

          if (r.size && (e.$_terms.keys || e.$_terms.patterns)) {
            if (a.stripUnknown && !e._flags.unknown || a.skipFunctions) {
              const e = !(!a.stripUnknown || !0 !== a.stripUnknown && !a.stripUnknown.objects);

              for (const s of r) e ? (delete t[s], r.delete(s)) : "function" == typeof t[s] && r.delete(s);
            }

            if (!l.default(e._flags.unknown, a.allowUnknown)) for (const i of r) {
              const r = n.localize([...n.path, i], []),
                    o = e.$_createError("object.unknown", t[i], {
                child: i
              }, r, a, {
                flags: !1
              });
              if (a.abortEarly) return {
                value: t,
                errors: o
              };
              s.push(o);
            }
          }
        }, m.Dependency = class {
          constructor(e, t, r, s, n) {
            this.rel = e, this.key = t, this.peers = r, this.paths = s, this.options = n;
          }

          describe() {
            const e = {
              rel: this.rel,
              peers: this.paths
            };
            return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = _objectSpread2(_objectSpread2({}, e.options), {}, {
              separator: this.peers[0].separator
            })), this.options.isPresent && (e.options = _objectSpread2(_objectSpread2({}, e.options), {}, {
              isPresent: this.options.isPresent
            })), e;
          }

        }, m.Keys = class extends Array {
          concat(e) {
            const t = this.slice(),
                  r = new Map();

            for (let e = 0; e < t.length; ++e) r.set(t[e].key, e);

            for (const s of e) {
              const e = s.key,
                    n = r.get(e);
              void 0 !== n ? t[n] = {
                key: e,
                schema: t[n].schema.concat(s.schema)
              } : t.push(s);
            }

            return t;
          }

        };
      },
      8785: (e, t, r) => {

        const s = r(375),
              n = r(8068),
              a = r(8160),
              i = r(3292),
              o = r(6354),
              l = {};
        e.exports = n.extend({
          type: "link",
          properties: {
            schemaChain: !0
          },
          terms: {
            link: {
              init: null,
              manifest: "single",
              register: !1
            }
          },
          args: (e, t) => e.ref(t),

          validate(e, t) {
            let {
              schema: r,
              state: n,
              prefs: a
            } = t;
            s(r.$_terms.link, "Uninitialized link schema");
            const i = l.generate(r, e, n, a),
                  o = r.$_terms.link[0].ref;
            return i.$_validate(e, n.nest(i, "link:".concat(o.display, ":").concat(i.type)), a);
          },

          generate: (e, t, r, s) => l.generate(e, t, r, s),
          rules: {
            ref: {
              method(e) {
                s(!this.$_terms.link, "Cannot reinitialize schema"), e = i.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
                const t = this.clone();
                return t.$_terms.link = [{
                  ref: e
                }], t;
              }

            },
            relative: {
              method() {
                let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return this.$_setFlag("relative", e);
              }

            }
          },
          overrides: {
            concat(e) {
              s(this.$_terms.link, "Uninitialized link schema"), s(a.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
              const t = this.clone();
              return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
                concat: e
              }), t.$_mutateRebuild();
            }

          },
          manifest: {
            build: (e, t) => (s(t.link, "Invalid link description missing link"), e.ref(t.link))
          }
        }), l.generate = function (e, t, r, s) {
          let n = r.mainstay.links.get(e);
          if (n) return n._generate(t, r, s).schema;
          const a = e.$_terms.link[0].ref,
                {
            perspective: i,
            path: o
          } = l.perspective(a, r);
          l.assert(i, "which is outside of schema boundaries", a, e, r, s);

          try {
            n = o.length ? i.$_reach(o) : i;
          } catch (t) {
            l.assert(!1, "to non-existing schema", a, e, r, s);
          }

          return l.assert("link" !== n.type, "which is another link", a, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
        }, l.perspective = function (e, t) {
          if ("local" === e.type) {
            for (const {
              schema: r,
              key: s
            } of t.schemas) {
              if ((r._flags.id || s) === e.path[0]) return {
                perspective: r,
                path: e.path.slice(1)
              };
              if (r.$_terms.shared) for (const t of r.$_terms.shared) if (t._flags.id === e.path[0]) return {
                perspective: t,
                path: e.path.slice(1)
              };
            }

            return {
              perspective: null,
              path: null
            };
          }

          return "root" === e.ancestor ? {
            perspective: t.schemas[t.schemas.length - 1].schema,
            path: e.path
          } : {
            perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
            path: e.path
          };
        }, l.assert = function (e, t, r, n, a, i) {
          e || s(!1, "\"".concat(o.label(n._flags, a, i), "\" contains link reference \"").concat(r.display, "\" ").concat(t));
        };
      },
      3832: (e, t, r) => {

        const s = r(375),
              n = r(8068),
              a = r(8160),
              i = {
          numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
          precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/,
          exponentialPartRegex: /[eE][+-]?\d+$/,
          leadingSignAndZerosRegex: /^[+-]?(0*)?/,
          dotRegex: /\./,
          trailingZerosRegex: /0+$/
        };
        e.exports = n.extend({
          type: "number",
          flags: {
            unsafe: {
              default: !1
            }
          },
          coerce: {
            from: "string",

            method(e, t) {
              let {
                schema: r,
                error: s
              } = t;
              if (!e.match(i.numberRx)) return;
              e = e.trim();
              const n = {
                value: parseFloat(e)
              };
              if (0 === n.value && (n.value = 0), !r._flags.unsafe) if (e.match(/e/i)) {
                if (i.extractSignificantDigits(e) !== i.extractSignificantDigits(String(n.value))) return n.errors = s("number.unsafe"), n;
              } else {
                const t = n.value.toString();
                if (t.match(/e/i)) return n;
                if (t !== i.normalizeDecimal(e)) return n.errors = s("number.unsafe"), n;
              }
              return n;
            }

          },

          validate(e, t) {
            let {
              schema: r,
              error: s,
              prefs: n
            } = t;
            if (e === 1 / 0 || e === -1 / 0) return {
              value: e,
              errors: s("number.infinity")
            };
            if (!a.isNumber(e)) return {
              value: e,
              errors: s("number.base")
            };
            const i = {
              value: e
            };

            if (n.convert) {
              const e = r.$_getRule("precision");

              if (e) {
                const t = Math.pow(10, e.args.limit);
                i.value = Math.round(i.value * t) / t;
              }
            }

            return 0 === i.value && (i.value = 0), !r._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (i.errors = s("number.unsafe")), i;
          },

          rules: {
            compare: {
              method: !1,

              validate(e, t, r, s) {
                let {
                  limit: n
                } = r,
                    {
                  name: i,
                  operator: o,
                  args: l
                } = s;
                return a.compare(e, n, o) ? e : t.error("number." + i, {
                  limit: l.limit,
                  value: e
                });
              },

              args: [{
                name: "limit",
                ref: !0,
                assert: a.isNumber,
                message: "must be a number"
              }]
            },
            greater: {
              method(e) {
                return this.$_addRule({
                  name: "greater",
                  method: "compare",
                  args: {
                    limit: e
                  },
                  operator: ">"
                });
              }

            },
            integer: {
              method() {
                return this.$_addRule("integer");
              },

              validate: (e, t) => Math.trunc(e) - e == 0 ? e : t.error("number.integer")
            },
            less: {
              method(e) {
                return this.$_addRule({
                  name: "less",
                  method: "compare",
                  args: {
                    limit: e
                  },
                  operator: "<"
                });
              }

            },
            max: {
              method(e) {
                return this.$_addRule({
                  name: "max",
                  method: "compare",
                  args: {
                    limit: e
                  },
                  operator: "<="
                });
              }

            },
            min: {
              method(e) {
                return this.$_addRule({
                  name: "min",
                  method: "compare",
                  args: {
                    limit: e
                  },
                  operator: ">="
                });
              }

            },
            multiple: {
              method(e) {
                return this.$_addRule({
                  name: "multiple",
                  args: {
                    base: e
                  }
                });
              },

              validate(e, t, r, s) {
                let {
                  base: n
                } = r;
                return e * (1 / n) % 1 == 0 ? e : t.error("number.multiple", {
                  multiple: s.args.base,
                  value: e
                });
              },

              args: [{
                name: "base",
                ref: !0,
                assert: e => "number" == typeof e && isFinite(e) && e > 0,
                message: "must be a positive number"
              }],
              multi: !0
            },
            negative: {
              method() {
                return this.sign("negative");
              }

            },
            port: {
              method() {
                return this.$_addRule("port");
              },

              validate: (e, t) => Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port")
            },
            positive: {
              method() {
                return this.sign("positive");
              }

            },
            precision: {
              method(e) {
                return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
                  name: "precision",
                  args: {
                    limit: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  limit: s
                } = r;
                const n = e.toString().match(i.precisionRx);
                return Math.max((n[1] ? n[1].length : 0) - (n[2] ? parseInt(n[2], 10) : 0), 0) <= s ? e : t.error("number.precision", {
                  limit: s,
                  value: e
                });
              },

              convert: !0
            },
            sign: {
              method(e) {
                return s(["negative", "positive"].includes(e), "Invalid sign", e), this.$_addRule({
                  name: "sign",
                  args: {
                    sign: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  sign: s
                } = r;
                return "negative" === s && e < 0 || "positive" === s && e > 0 ? e : t.error("number.".concat(s));
              }

            },
            unsafe: {
              method() {
                let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
              }

            }
          },
          cast: {
            string: {
              from: e => "number" == typeof e,
              to: (e, t) => e.toString()
            }
          },
          messages: {
            "number.base": "{{#label}} must be a number",
            "number.greater": "{{#label}} must be greater than {{#limit}}",
            "number.infinity": "{{#label}} cannot be infinity",
            "number.integer": "{{#label}} must be an integer",
            "number.less": "{{#label}} must be less than {{#limit}}",
            "number.max": "{{#label}} must be less than or equal to {{#limit}}",
            "number.min": "{{#label}} must be greater than or equal to {{#limit}}",
            "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
            "number.negative": "{{#label}} must be a negative number",
            "number.port": "{{#label}} must be a valid port",
            "number.positive": "{{#label}} must be a positive number",
            "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
            "number.unsafe": "{{#label}} must be a safe number"
          }
        }), i.extractSignificantDigits = function (e) {
          return e.replace(i.exponentialPartRegex, "").replace(i.dotRegex, "").replace(i.trailingZerosRegex, "").replace(i.leadingSignAndZerosRegex, "");
        }, i.normalizeDecimal = function (e) {
          return (e = e.replace(/^\+/, "").replace(/\.0*$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([0-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
        };
      },
      8966: (e, t, r) => {

        const s = r(7824);
        e.exports = s.extend({
          type: "object",
          cast: {
            map: {
              from: e => e && "object" == typeof e,
              to: (e, t) => new Map(Object.entries(e))
            }
          }
        });
      },
      7417: (e, t, r) => {

        const s = r(375),
              n = r(5380),
              a = r(1745),
              i = r(9959),
              o = r(6064),
              l = r(9926),
              c = r(5752),
              u = r(8068),
              f = r(8160),
              h = {
          tlds: l instanceof Set && {
            tlds: {
              allow: l,
              deny: null
            }
          },
          base64Regex: {
            true: {
              true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
              false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
            },
            false: {
              true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
              false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
            }
          },
          dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
          hexRegex: /^[a-f0-9]+$/i,
          ipRegex: i.regex({
            cidr: "forbidden"
          }).regex,
          isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
          guidBrackets: {
            "{": "}",
            "[": "]",
            "(": ")",
            "": ""
          },
          guidVersions: {
            uuidv1: "1",
            uuidv2: "2",
            uuidv3: "3",
            uuidv4: "4",
            uuidv5: "5"
          },
          guidSeparators: new Set([void 0, !0, !1, "-", ":"]),
          normalizationForms: ["NFC", "NFD", "NFKC", "NFKD"]
        };
        e.exports = u.extend({
          type: "string",
          flags: {
            insensitive: {
              default: !1
            },
            truncate: {
              default: !1
            }
          },
          terms: {
            replacements: {
              init: null
            }
          },
          coerce: {
            from: "string",

            method(e, t) {
              let {
                schema: r,
                state: s,
                prefs: n
              } = t;
              const a = r.$_getRule("normalize");
              a && (e = e.normalize(a.args.form));
              const i = r.$_getRule("case");
              i && (e = "upper" === i.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
              const o = r.$_getRule("trim");
              if (o && o.args.enabled && (e = e.trim()), r.$_terms.replacements) for (const t of r.$_terms.replacements) e = e.replace(t.pattern, t.replacement);
              const l = r.$_getRule("hex");

              if (l && l.args.options.byteAligned && e.length % 2 != 0 && (e = "0".concat(e)), r.$_getRule("isoDate")) {
                const t = h.isoDate(e);
                t && (e = t);
              }

              if (r._flags.truncate) {
                const t = r.$_getRule("max");

                if (t) {
                  let a = t.args.limit;
                  if (f.isResolvable(a) && (a = a.resolve(e, s, n), !f.limit(a))) return {
                    value: e,
                    errors: r.$_createError("any.ref", a, {
                      ref: t.args.limit,
                      arg: "limit",
                      reason: "must be a positive integer"
                    }, s, n)
                  };
                  e = e.slice(0, a);
                }
              }

              return {
                value: e
              };
            }

          },

          validate(e, t) {
            let {
              schema: r,
              error: s
            } = t;
            if ("string" != typeof e) return {
              value: e,
              errors: s("string.base")
            };

            if ("" === e) {
              const t = r.$_getRule("min");
              if (t && 0 === t.args.limit) return;
              return {
                value: e,
                errors: s("string.empty")
              };
            }
          },

          rules: {
            alphanum: {
              method() {
                return this.$_addRule("alphanum");
              },

              validate: (e, t) => /^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum")
            },
            base64: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return f.assertOptions(e, ["paddingRequired", "urlSafe"]), e = _objectSpread2({
                  urlSafe: !1,
                  paddingRequired: !0
                }, e), s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), s("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
                  name: "base64",
                  args: {
                    options: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  options: s
                } = r;
                return h.base64Regex[s.paddingRequired][s.urlSafe].test(e) ? e : t.error("string.base64");
              }

            },
            case: {
              method(e) {
                return s(["lower", "upper"].includes(e), "Invalid case:", e), this.$_addRule({
                  name: "case",
                  args: {
                    direction: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  direction: s
                } = r;
                return "lower" === s && e === e.toLocaleLowerCase() || "upper" === s && e === e.toLocaleUpperCase() ? e : t.error("string.".concat(s, "case"));
              },

              convert: !0
            },
            creditCard: {
              method() {
                return this.$_addRule("creditCard");
              },

              validate(e, t) {
                let r = e.length,
                    s = 0,
                    n = 1;

                for (; r--;) {
                  const t = e.charAt(r) * n;
                  s += t - 9 * (t > 9), n ^= 3;
                }

                return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
              }

            },
            dataUri: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return f.assertOptions(e, ["paddingRequired"]), e = _objectSpread2({
                  paddingRequired: !0
                }, e), s("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
                  name: "dataUri",
                  args: {
                    options: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  options: s
                } = r;
                const n = e.match(h.dataUriRegex);

                if (n) {
                  if (!n[2]) return e;
                  if ("base64" !== n[2]) return e;
                  if (h.base64Regex[s.paddingRequired].false.test(n[3])) return e;
                }

                return t.error("string.dataUri");
              }

            },
            domain: {
              method(e) {
                e && f.assertOptions(e, ["allowFullyQualified", "allowUnicode", "maxDomainSegments", "minDomainSegments", "tlds"]);
                const t = h.addressOptions(e);
                return this.$_addRule({
                  name: "domain",
                  args: {
                    options: e
                  },
                  address: t
                });
              },

              validate(e, t, r, s) {
                let {
                  address: a
                } = s;
                return n.isValid(e, a) ? e : t.error("string.domain");
              }

            },
            email: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                f.assertOptions(e, ["allowFullyQualified", "allowUnicode", "ignoreLength", "maxDomainSegments", "minDomainSegments", "multiple", "separator", "tlds"]), s(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
                const t = h.addressOptions(e),
                      r = new RegExp("\\s*[".concat(e.separator ? o(e.separator) : ",", "]\\s*"));
                return this.$_addRule({
                  name: "email",
                  args: {
                    options: e
                  },
                  regex: r,
                  address: t
                });
              },

              validate(e, t, r, s) {
                let {
                  options: n
                } = r,
                    {
                  regex: i,
                  address: o
                } = s;
                const l = n.multiple ? e.split(i) : [e],
                      c = [];

                for (const e of l) a.isValid(e, o) || c.push(e);

                return c.length ? t.error("string.email", {
                  value: e,
                  invalids: c
                }) : e;
              }

            },
            guid: {
              alias: "uuid",

              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                f.assertOptions(e, ["version", "separator"]);
                let t = "";

                if (e.version) {
                  const r = [].concat(e.version);
                  s(r.length >= 1, "version must have at least 1 valid version specified");
                  const n = new Set();

                  for (let e = 0; e < r.length; ++e) {
                    const a = r[e];
                    s("string" == typeof a, "version at position " + e + " must be a string");
                    const i = h.guidVersions[a.toLowerCase()];
                    s(i, "version at position " + e + " must be one of " + Object.keys(h.guidVersions).join(", ")), s(!n.has(i), "version at position " + e + " must not be a duplicate"), t += i, n.add(i);
                  }
                }

                s(h.guidSeparators.has(e.separator), 'separator must be one of true, false, "-", or ":"');
                const r = void 0 === e.separator ? "[:-]?" : !0 === e.separator ? "[:-]" : !1 === e.separator ? "[]?" : "\\".concat(e.separator),
                      n = new RegExp("^([\\[{\\(]?)[0-9A-F]{8}(".concat(r, ")[0-9A-F]{4}\\2?[").concat(t || "0-9A-F", "][0-9A-F]{3}\\2?[").concat(t ? "89AB" : "0-9A-F", "][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$"), "i");
                return this.$_addRule({
                  name: "guid",
                  args: {
                    options: e
                  },
                  regex: n
                });
              },

              validate(e, t, r, s) {
                let {
                  regex: n
                } = s;
                const a = n.exec(e);
                return a ? h.guidBrackets[a[1]] !== a[a.length - 1] ? t.error("string.guid") : e : t.error("string.guid");
              }

            },
            hex: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return f.assertOptions(e, ["byteAligned"]), e = _objectSpread2({
                  byteAligned: !1
                }, e), s("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), this.$_addRule({
                  name: "hex",
                  args: {
                    options: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  options: s
                } = r;
                return h.hexRegex.test(e) ? s.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex");
              }

            },
            hostname: {
              method() {
                return this.$_addRule("hostname");
              },

              validate: (e, t) => n.isValid(e, {
                minDomainSegments: 1
              }) || h.ipRegex.test(e) ? e : t.error("string.hostname")
            },
            insensitive: {
              method() {
                return this.$_setFlag("insensitive", !0);
              }

            },
            ip: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                f.assertOptions(e, ["cidr", "version"]);
                const {
                  cidr: t,
                  versions: r,
                  regex: s
                } = i.regex(e),
                      n = e.version ? r : void 0;
                return this.$_addRule({
                  name: "ip",
                  args: {
                    options: {
                      cidr: t,
                      version: n
                    }
                  },
                  regex: s
                });
              },

              validate(e, t, r, s) {
                let {
                  options: n
                } = r,
                    {
                  regex: a
                } = s;
                return a.test(e) ? e : n.version ? t.error("string.ipVersion", {
                  value: e,
                  cidr: n.cidr,
                  version: n.version
                }) : t.error("string.ip", {
                  value: e,
                  cidr: n.cidr
                });
              }

            },
            isoDate: {
              method() {
                return this.$_addRule("isoDate");
              },

              validate(e, t) {
                let {
                  error: r
                } = t;
                return h.isoDate(e) ? e : r("string.isoDate");
              }

            },
            isoDuration: {
              method() {
                return this.$_addRule("isoDuration");
              },

              validate: (e, t) => h.isoDurationRegex.test(e) ? e : t.error("string.isoDuration")
            },
            length: {
              method(e, t) {
                return h.length(this, "length", e, "=", t);
              },

              validate(e, t, r, s) {
                let {
                  limit: n,
                  encoding: a
                } = r,
                    {
                  name: i,
                  operator: o,
                  args: l
                } = s;
                const c = !a && e.length;
                return f.compare(c, n, o) ? e : t.error("string." + i, {
                  limit: l.limit,
                  value: e,
                  encoding: a
                });
              },

              args: [{
                name: "limit",
                ref: !0,
                assert: f.limit,
                message: "must be a positive integer"
              }, "encoding"]
            },
            lowercase: {
              method() {
                return this.case("lower");
              }

            },
            max: {
              method(e, t) {
                return h.length(this, "max", e, "<=", t);
              },

              args: ["limit", "encoding"]
            },
            min: {
              method(e, t) {
                return h.length(this, "min", e, ">=", t);
              },

              args: ["limit", "encoding"]
            },
            normalize: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "NFC";
                return s(h.normalizationForms.includes(e), "normalization form must be one of " + h.normalizationForms.join(", ")), this.$_addRule({
                  name: "normalize",
                  args: {
                    form: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  error: s
                } = t,
                    {
                  form: n
                } = r;
                return e === e.normalize(n) ? e : s("string.normalize", {
                  value: e,
                  form: n
                });
              },

              convert: !0
            },
            pattern: {
              alias: "regex",

              method(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                s(e instanceof RegExp, "regex must be a RegExp"), s(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
                  name: t
                }), f.assertOptions(t, ["invert", "name"]);
                const r = ["string.pattern", t.invert ? ".invert" : "", t.name ? ".name" : ".base"].join("");
                return this.$_addRule({
                  name: "pattern",
                  args: {
                    regex: e,
                    options: t
                  },
                  errorCode: r
                });
              },

              validate(e, t, r, s) {
                let {
                  regex: n,
                  options: a
                } = r,
                    {
                  errorCode: i
                } = s;
                return n.test(e) ^ a.invert ? e : t.error(i, {
                  name: a.name,
                  regex: n,
                  value: e
                });
              },

              args: ["regex", "options"],
              multi: !0
            },
            replace: {
              method(e, t) {
                "string" == typeof e && (e = new RegExp(o(e), "g")), s(e instanceof RegExp, "pattern must be a RegExp"), s("string" == typeof t, "replacement must be a String");
                const r = this.clone();
                return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
                  pattern: e,
                  replacement: t
                }), r;
              }

            },
            token: {
              method() {
                return this.$_addRule("token");
              },

              validate: (e, t) => /^\w+$/.test(e) ? e : t.error("string.token")
            },
            trim: {
              method() {
                let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return s("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
                  name: "trim",
                  args: {
                    enabled: e
                  }
                });
              },

              validate(e, t, r) {
                let {
                  enabled: s
                } = r;
                return s && e !== e.trim() ? t.error("string.trim") : e;
              },

              convert: !0
            },
            truncate: {
              method() {
                let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
              }

            },
            uppercase: {
              method() {
                return this.case("upper");
              }

            },
            uri: {
              method() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                f.assertOptions(e, ["allowRelative", "allowQuerySquareBrackets", "domain", "relativeOnly", "scheme"]), e.domain && f.assertOptions(e.domain, ["allowFullyQualified", "allowUnicode", "maxDomainSegments", "minDomainSegments", "tlds"]);
                const {
                  regex: t,
                  scheme: r
                } = c.regex(e),
                      s = e.domain ? h.addressOptions(e.domain) : null;
                return this.$_addRule({
                  name: "uri",
                  args: {
                    options: e
                  },
                  regex: t,
                  domain: s,
                  scheme: r
                });
              },

              validate(e, t, r, s) {
                let {
                  options: a
                } = r,
                    {
                  regex: i,
                  domain: o,
                  scheme: l
                } = s;
                if (["http:/", "https:/"].includes(e)) return t.error("string.uri");
                const c = i.exec(e);

                if (c) {
                  const r = c[1] || c[2];
                  return !o || a.allowRelative && !r || n.isValid(r, o) ? e : t.error("string.domain", {
                    value: r
                  });
                }

                return a.relativeOnly ? t.error("string.uriRelativeOnly") : a.scheme ? t.error("string.uriCustomScheme", {
                  scheme: l,
                  value: e
                }) : t.error("string.uri");
              }

            }
          },
          manifest: {
            build(e, t) {
              if (t.replacements) for (const {
                pattern: r,
                replacement: s
              } of t.replacements) e = e.replace(r, s);
              return e;
            }

          },
          messages: {
            "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
            "string.base": "{{#label}} must be a string",
            "string.base64": "{{#label}} must be a valid base64 string",
            "string.creditCard": "{{#label}} must be a credit card",
            "string.dataUri": "{{#label}} must be a valid dataUri string",
            "string.domain": "{{#label}} must contain a valid domain name",
            "string.email": "{{#label}} must be a valid email",
            "string.empty": "{{#label}} is not allowed to be empty",
            "string.guid": "{{#label}} must be a valid GUID",
            "string.hex": "{{#label}} must only contain hexadecimal characters",
            "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
            "string.hostname": "{{#label}} must be a valid hostname",
            "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
            "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
            "string.isoDate": "{{#label}} must be in iso format",
            "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
            "string.length": "{{#label}} length must be {{#limit}} characters long",
            "string.lowercase": "{{#label}} must only contain lowercase characters",
            "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
            "string.min": "{{#label}} length must be at least {{#limit}} characters long",
            "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
            "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
            "string.pattern.base": "{{#label}} with value {:[.]} fails to match the required pattern: {{#regex}}",
            "string.pattern.name": "{{#label}} with value {:[.]} fails to match the {{#name}} pattern",
            "string.pattern.invert.base": "{{#label}} with value {:[.]} matches the inverted pattern: {{#regex}}",
            "string.pattern.invert.name": "{{#label}} with value {:[.]} matches the inverted {{#name}} pattern",
            "string.trim": "{{#label}} must not have leading or trailing whitespace",
            "string.uri": "{{#label}} must be a valid uri",
            "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
            "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
            "string.uppercase": "{{#label}} must only contain uppercase characters"
          }
        }), h.addressOptions = function (e) {
          if (!e) return e;
          if (s(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), s(void 0 === e.maxDomainSegments || Number.isSafeInteger(e.maxDomainSegments) && e.maxDomainSegments > 0, "maxDomainSegments must be a positive integer"), !1 === e.tlds) return e;
          if (!0 === e.tlds || void 0 === e.tlds) return s(h.tlds, "Built-in TLD list disabled"), Object.assign({}, e, h.tlds);
          s("object" == typeof e.tlds, "tlds must be true, false, or an object");
          const t = e.tlds.deny;
          if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
            tlds: {
              deny: new Set(t)
            }
          })), s(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), s(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), h.validateTlds(e.tlds.deny, "tlds.deny"), e;
          const r = e.tlds.allow;
          return r ? !0 === r ? (s(h.tlds, "Built-in TLD list disabled"), Object.assign({}, e, h.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
            tlds: {
              allow: new Set(r)
            }
          })), s(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), h.validateTlds(e.tlds.allow, "tlds.allow"), e) : e;
        }, h.validateTlds = function (e, t) {
          for (const r of e) s(n.isValid(r, {
            minDomainSegments: 1,
            maxDomainSegments: 1
          }), "".concat(t, " must contain valid top level domain names"));
        }, h.isoDate = function (e) {
          if (!f.isIsoDate(e)) return null;
          /.*T.*[+-]\d\d$/.test(e) && (e += "00");
          const t = new Date(e);
          return isNaN(t.getTime()) ? null : t.toISOString();
        }, h.length = function (e, t, r, n, a) {
          return s(!a || !1, "Invalid encoding:", a), e.$_addRule({
            name: t,
            method: "length",
            args: {
              limit: r,
              encoding: a
            },
            operator: n
          });
        };
      },
      8826: (e, t, r) => {

        const s = r(375),
              n = r(8068),
              a = {};
        a.Map = class extends Map {
          slice() {
            return new a.Map(this);
          }

        }, e.exports = n.extend({
          type: "symbol",
          terms: {
            map: {
              init: new a.Map()
            }
          },
          coerce: {
            method(e, t) {
              let {
                schema: r,
                error: s
              } = t;
              const n = r.$_terms.map.get(e);
              return n && (e = n), r._flags.only && "symbol" != typeof e ? {
                value: e,
                errors: s("symbol.map", {
                  map: r.$_terms.map
                })
              } : {
                value: e
              };
            }

          },

          validate(e, t) {
            let {
              error: r
            } = t;
            if ("symbol" != typeof e) return {
              value: e,
              errors: r("symbol.base")
            };
          },

          rules: {
            map: {
              method(e) {
                e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
                const t = this.clone(),
                      r = [];

                for (const n of e) {
                  s(n && n[Symbol.iterator], "Entry must be an iterable");
                  const [e, a] = n;
                  s("object" != typeof e && "function" != typeof e && "symbol" != typeof e, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof a, "Value must be a Symbol"), t.$_terms.map.set(e, a), r.push(a);
                }

                return t.valid(...r);
              }

            }
          },
          manifest: {
            build: (e, t) => (t.map && (e = e.map(t.map)), e)
          },
          messages: {
            "symbol.base": "{{#label}} must be a symbol",
            "symbol.map": "{{#label}} must be one of {{#map}}"
          }
        });
      },
      8863: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(738),
              i = r(9621),
              o = r(8160),
              l = r(6354),
              c = r(493),
              u = {
          result: Symbol("result")
        };
        t.entry = function (e, t, r) {
          let n = o.defaults;
          r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), s(void 0 === r.artifacts, "Cannot override artifacts preference in synchronous validation"), n = o.preferences(o.defaults, r));
          const a = u.entry(e, t, n);
          s(!a.mainstay.externals.length, "Schema with external rules must use validateAsync()");
          const i = {
            value: a.value
          };
          return a.error && (i.error = a.error), a.mainstay.warnings.length && (i.warning = l.details(a.mainstay.warnings)), a.mainstay.debug && (i.debug = a.mainstay.debug), a.mainstay.artifacts && (i.artifacts = a.mainstay.artifacts), i;
        }, t.entryAsync = async function (e, t, r) {
          let s = o.defaults;
          r && (s = o.preferences(o.defaults, r));
          const n = u.entry(e, t, s),
                a = n.mainstay;
          if (n.error) throw a.debug && (n.error.debug = a.debug), n.error;

          if (a.externals.length) {
            let t = n.value;
            const c = [];

            for (const n of a.externals) {
              const f = n.state.path,
                    h = "link" === n.schema.type ? a.links.get(n.schema) : null;
              let m,
                  d,
                  p = t;
              const g = f.length ? [t] : [],
                    y = f.length ? i(e, f) : e;

              if (f.length) {
                m = f[f.length - 1];
                let e = t;

                for (const t of f.slice(0, -1)) e = e[t], g.unshift(e);

                d = g[0], p = d[m];
              }

              try {
                const e = (e, t) => (h || n.schema).$_createError(e, p, t, n.state, s),
                      i = await n.method(p, {
                  schema: n.schema,
                  linked: h,
                  state: n.state,
                  prefs: r,
                  original: y,
                  error: e,
                  errorsArray: u.errorsArray,
                  warn: (e, t) => a.warnings.push((h || n.schema).$_createError(e, p, t, n.state, s)),
                  message: (e, t) => (h || n.schema).$_createError("external", p, t, n.state, s, {
                    messages: e
                  })
                });

                if (void 0 === i || i === p) continue;

                if (i instanceof l.Report) {
                  if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(i), s.abortEarly) break;
                  continue;
                }

                if (Array.isArray(i) && i[o.symbols.errors]) {
                  if (a.tracer.log(n.schema, n.state, "rule", "external", "error"), c.push(...i), s.abortEarly) break;
                  continue;
                }

                d ? (a.tracer.value(n.state, "rule", p, i, "external"), d[m] = i) : (a.tracer.value(n.state, "rule", t, i, "external"), t = i);
              } catch (e) {
                throw s.errors.label && (e.message += " (".concat(n.label, ")")), e;
              }
            }

            if (n.value = t, c.length) throw n.error = l.process(c, e, s), a.debug && (n.error.debug = a.debug), n.error;
          }

          if (!s.warnings && !s.debug && !s.artifacts) return n.value;
          const c = {
            value: n.value
          };
          return a.warnings.length && (c.warning = l.details(a.warnings)), a.debug && (c.debug = a.debug), a.artifacts && (c.artifacts = a.artifacts), c;
        }, u.Mainstay = class {
          constructor(e, t, r) {
            this.externals = [], this.warnings = [], this.tracer = e, this.debug = t, this.links = r, this.shadow = null, this.artifacts = null, this._snapshots = [];
          }

          snapshot() {
            this._snapshots.push({
              externals: this.externals.slice(),
              warnings: this.warnings.slice()
            });
          }

          restore() {
            const e = this._snapshots.pop();

            this.externals = e.externals, this.warnings = e.warnings;
          }

          commit() {
            this._snapshots.pop();
          }

        }, u.entry = function (e, r, s) {
          const {
            tracer: n,
            cleanup: a
          } = u.tracer(r, s),
                i = s.debug ? [] : null,
                o = r._ids._schemaChain ? new Map() : null,
                f = new u.Mainstay(n, i, o),
                h = r._ids._schemaChain ? [{
            schema: r
          }] : null,
                m = new c([], [], {
            mainstay: f,
            schemas: h
          }),
                d = t.validate(e, r, m, s);
          a && r.$_root.untrace();
          const p = l.process(d.errors, e, s);
          return {
            value: d.value,
            error: p,
            mainstay: f
          };
        }, u.tracer = function (e, t) {
          return e.$_root._tracer ? {
            tracer: e.$_root._tracer._register(e)
          } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
            tracer: e.$_root.trace()._register(e),
            cleanup: !0
          }) : {
            tracer: u.ignore
          };
        }, t.validate = function (e, t, r, s) {
          let n = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};

          if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
            const s = t._cache.get(e);

            if (r.mainstay.tracer.debug(r, "validate", "cached", !!s), s) return s;
          }

          const a = (n, a, i) => t.$_createError(n, e, a, i || r, s),
                i = {
            original: e,
            prefs: s,
            schema: t,
            state: r,
            error: a,
            errorsArray: u.errorsArray,
            warn: (e, t, s) => r.mainstay.warnings.push(a(e, t, s)),
            message: (n, a) => t.$_createError("custom", e, a, r, s, {
              messages: n
            })
          };

          r.mainstay.tracer.entry(t, r);
          const l = t._definition;

          if (l.prepare && void 0 !== e && s.convert) {
            const t = l.prepare(e, i);

            if (t) {
              if (r.mainstay.tracer.value(r, "prepare", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
              e = t.value;
            }
          }

          if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
            const t = l.coerce.method(e, i);

            if (t) {
              if (r.mainstay.tracer.value(r, "coerced", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), i);
              e = t.value;
            }
          }

          const c = t._flags.empty;
          c && c.$_match(u.trim(e, t), r.nest(c), o.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
          const f = n.presence || t._flags.presence || (t._flags._endedSwitch ? null : s.presence);

          if (void 0 === e) {
            if ("forbidden" === f) return u.finalize(e, null, i);
            if ("required" === f) return u.finalize(e, [t.$_createError("any.required", e, null, r, s)], i);

            if ("optional" === f) {
              if (t._flags.default !== o.symbols.deepDefault) return u.finalize(e, null, i);
              r.mainstay.tracer.value(r, "default", e, {}), e = {};
            }
          } else if ("forbidden" === f) return u.finalize(e, [t.$_createError("any.unknown", e, null, r, s)], i);

          const h = [];

          if (t._valids) {
            const n = t._valids.get(e, r, s, t._flags.insensitive);

            if (n) return s.convert && (r.mainstay.tracer.value(r, "valids", e, n.value), e = n.value), r.mainstay.tracer.filter(t, r, "valid", n), u.finalize(e, null, i);

            if (t._flags.only) {
              const n = t.$_createError("any.only", e, {
                valids: t._valids.values({
                  display: !0
                })
              }, r, s);
              if (s.abortEarly) return u.finalize(e, [n], i);
              h.push(n);
            }
          }

          if (t._invalids) {
            const n = t._invalids.get(e, r, s, t._flags.insensitive);

            if (n) {
              r.mainstay.tracer.filter(t, r, "invalid", n);
              const a = t.$_createError("any.invalid", e, {
                invalids: t._invalids.values({
                  display: !0
                })
              }, r, s);
              if (s.abortEarly) return u.finalize(e, [a], i);
              h.push(a);
            }
          }

          if (l.validate) {
            const t = l.validate(e, i);

            if (t && (r.mainstay.tracer.value(r, "base", e, t.value), e = t.value, t.errors)) {
              if (!Array.isArray(t.errors)) return h.push(t.errors), u.finalize(e, h, i);
              if (t.errors.length) return h.push(...t.errors), u.finalize(e, h, i);
            }
          }

          return t._rules.length ? u.rules(e, h, i) : u.finalize(e, h, i);
        }, u.rules = function (e, t, r) {
          const {
            schema: s,
            state: n,
            prefs: a
          } = r;

          for (const i of s._rules) {
            const l = s._definition.rules[i.method];

            if (l.convert && a.convert) {
              n.mainstay.tracer.log(s, n, "rule", i.name, "full");
              continue;
            }

            let c,
                f = i.args;

            if (i._resolve.length) {
              f = Object.assign({}, f);

              for (const t of i._resolve) {
                const r = l.argsByName.get(t),
                      i = f[t].resolve(e, n, a),
                      u = r.normalize ? r.normalize(i) : i,
                      h = o.validateArg(u, null, r);

                if (h) {
                  c = s.$_createError("any.ref", i, {
                    arg: t,
                    ref: f[t],
                    reason: h
                  }, n, a);
                  break;
                }

                f[t] = u;
              }
            }

            c = c || l.validate(e, r, f, i);
            const h = u.rule(c, i);

            if (h.errors) {
              if (n.mainstay.tracer.log(s, n, "rule", i.name, "error"), i.warn) {
                n.mainstay.warnings.push(...h.errors);
                continue;
              }

              if (a.abortEarly) return u.finalize(e, h.errors, r);
              t.push(...h.errors);
            } else n.mainstay.tracer.log(s, n, "rule", i.name, "pass"), n.mainstay.tracer.value(n, "rule", e, h.value, i.name), e = h.value;
          }

          return u.finalize(e, t, r);
        }, u.rule = function (e, t) {
          return e instanceof l.Report ? (u.error(e, t), {
            errors: [e],
            value: null
          }) : Array.isArray(e) && e[o.symbols.errors] ? (e.forEach(e => u.error(e, t)), {
            errors: e,
            value: null
          }) : {
            errors: null,
            value: e
          };
        }, u.error = function (e, t) {
          return t.message && e._setTemplate(t.message), e;
        }, u.finalize = function (e, t, r) {
          t = t || [];
          const {
            schema: n,
            state: a,
            prefs: i
          } = r;

          if (t.length) {
            const s = u.default("failover", void 0, t, r);
            void 0 !== s && (a.mainstay.tracer.value(a, "failover", e, s), e = s, t = []);
          }

          if (t.length && n._flags.error) if ("function" == typeof n._flags.error) {
            t = n._flags.error(t), Array.isArray(t) || (t = [t]);

            for (const e of t) s(e instanceof Error || e instanceof l.Report, "error() must return an Error object");
          } else t = [n._flags.error];

          if (void 0 === e) {
            const s = u.default("default", e, t, r);
            a.mainstay.tracer.value(a, "default", e, s), e = s;
          }

          if (n._flags.cast && void 0 !== e) {
            const t = n._definition.cast[n._flags.cast];

            if (t.from(e)) {
              const s = t.to(e, r);
              a.mainstay.tracer.value(a, "cast", e, s, n._flags.cast), e = s;
            }
          }

          if (n.$_terms.externals && i.externals && !1 !== i._externals) for (const {
            method: e
          } of n.$_terms.externals) a.mainstay.externals.push({
            method: e,
            schema: n,
            state: a,
            label: l.label(n._flags, a, i)
          });
          const o = {
            value: e,
            errors: t.length ? t : null
          };
          return n._flags.result && (o.value = "strip" === n._flags.result ? void 0 : r.original, a.mainstay.tracer.value(a, n._flags.result, e, o.value), a.shadow(e, n._flags.result)), n._cache && !1 !== i.cache && !n._refs.length && n._cache.set(r.original, o), void 0 === e || o.errors || void 0 === n._flags.artifact || (a.mainstay.artifacts = a.mainstay.artifacts || new Map(), a.mainstay.artifacts.has(n._flags.artifact) || a.mainstay.artifacts.set(n._flags.artifact, []), a.mainstay.artifacts.get(n._flags.artifact).push(a.path)), o;
        }, u.prefs = function (e, t) {
          const r = t === o.defaults;
          return r && e._preferences[o.symbols.prefs] ? e._preferences[o.symbols.prefs] : (t = o.preferences(t, e._preferences), r && (e._preferences[o.symbols.prefs] = t), t);
        }, u.default = function (e, t, r, s) {
          const {
            schema: a,
            state: i,
            prefs: l
          } = s,
                c = a._flags[e];
          if (l.noDefaults || void 0 === c) return t;
          if (i.mainstay.tracer.log(a, i, "rule", e, "full"), !c) return c;

          if ("function" == typeof c) {
            const t = c.length ? [n(i.ancestors[0]), s] : [];

            try {
              return c(...t);
            } catch (t) {
              return void r.push(a.$_createError("any.".concat(e), null, {
                error: t
              }, i, l));
            }
          }

          return "object" != typeof c ? c : c[o.symbols.literal] ? c.literal : o.isResolvable(c) ? c.resolve(t, i, l) : n(c);
        }, u.trim = function (e, t) {
          if ("string" != typeof e) return e;
          const r = t.$_getRule("trim");
          return r && r.args.enabled ? e.trim() : e;
        }, u.ignore = {
          active: !1,
          debug: a,
          entry: a,
          filter: a,
          log: a,
          resolve: a,
          value: a
        }, u.errorsArray = function () {
          const e = [];
          return e[o.symbols.errors] = !0, e;
        };
      },
      2036: (e, t, r) => {

        const s = r(375),
              n = r(9474),
              a = r(8160),
              i = {};
        e.exports = i.Values = class {
          constructor(e, t) {
            this._values = new Set(e), this._refs = new Set(t), this._lowercase = i.lowercases(e), this._override = !1;
          }

          get length() {
            return this._values.size + this._refs.size;
          }

          add(e, t) {
            a.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
          }

          static merge(e, t, r) {
            if (e = e || new i.Values(), t) {
              if (t._override) return t.clone();

              for (const r of [...t._values, ...t._refs]) e.add(r);
            }

            if (r) for (const t of [...r._values, ...r._refs]) e.remove(t);
            return e.length ? e : null;
          }

          remove(e) {
            a.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
          }

          has(e, t, r, s) {
            return !!this.get(e, t, r, s);
          }

          get(e, t, r, s) {
            if (!this.length) return !1;
            if (this._values.has(e)) return {
              value: e
            };

            if ("string" == typeof e && e && s) {
              const t = this._lowercase.get(e.toLowerCase());

              if (t) return {
                value: t
              };
            }

            if (!this._refs.size && "object" != typeof e) return !1;
            if ("object" == typeof e) for (const t of this._values) if (n(t, e)) return {
              value: t
            };
            if (t) for (const a of this._refs) {
              const i = a.resolve(e, t, r, null, {
                in: !0
              });
              if (void 0 === i) continue;
              const o = a.in && "object" == typeof i ? Array.isArray(i) ? i : Object.keys(i) : [i];

              for (const t of o) if (typeof t == typeof e) if (s && e && "string" == typeof e) {
                if (t.toLowerCase() === e.toLowerCase()) return {
                  value: t,
                  ref: a
                };
              } else if (n(t, e)) return {
                value: t,
                ref: a
              };
            }
            return !1;
          }

          override() {
            this._override = !0;
          }

          values(e) {
            if (e && e.display) {
              const e = [];

              for (const t of [...this._values, ...this._refs]) void 0 !== t && e.push(t);

              return e;
            }

            return Array.from([...this._values, ...this._refs]);
          }

          clone() {
            const e = new i.Values(this._values, this._refs);
            return e._override = this._override, e;
          }

          concat(e) {
            s(!e._override, "Cannot concat override set of values");
            const t = new i.Values([...this._values, ...e._values], [...this._refs, ...e._refs]);
            return t._override = this._override, t;
          }

          describe() {
            const e = [];
            this._override && e.push({
              override: !0
            });

            for (const t of this._values.values()) e.push(t && "object" == typeof t ? {
              value: t
            } : t);

            for (const t of this._refs.values()) e.push(t.describe());

            return e;
          }

        }, i.Values.prototype[a.symbols.values] = !0, i.Values.prototype.slice = i.Values.prototype.clone, i.lowercases = function (e) {
          const t = new Map();
          if (e) for (const r of e) "string" == typeof r && t.set(r.toLowerCase(), r);
          return t;
        };
      },
      978: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(1687),
              i = r(9621),
              o = {};
        e.exports = function (e, t) {
          let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
          if (r.shallow) return o.applyToDefaultsWithShallow(e, t, r);
          const i = n(e);
          if (!0 === t) return i;
          const l = void 0 !== r.nullOverride && r.nullOverride;
          return a(i, t, {
            nullOverride: l,
            mergeArrays: !1
          });
        }, o.applyToDefaultsWithShallow = function (e, t, r) {
          const l = r.shallow;
          s(Array.isArray(l), "Invalid keys");
          const c = new Map(),
                u = !0 === t ? null : new Set();

          for (let r of l) {
            r = Array.isArray(r) ? r : r.split(".");
            const s = i(e, r);
            s && "object" == typeof s ? c.set(s, u && i(t, r) || s) : u && u.add(r);
          }

          const f = n(e, {}, c);
          if (!u) return f;

          for (const e of u) o.reachCopy(f, t, e);

          const h = void 0 !== r.nullOverride && r.nullOverride;
          return a(f, t, {
            nullOverride: h,
            mergeArrays: !1
          });
        }, o.reachCopy = function (e, t, r) {
          for (const e of r) {
            if (!(e in t)) return;
            const r = t[e];
            if ("object" != typeof r || null === r) return;
            t = r;
          }

          const s = t;
          let n = e;

          for (let e = 0; e < r.length - 1; ++e) {
            const t = r[e];
            "object" != typeof n[t] && (n[t] = {}), n = n[t];
          }

          n[r[r.length - 1]] = s;
        };
      },
      375: (e, t, r) => {

        const s = r(7916);

        e.exports = function (e) {
          if (!e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

            if (1 === r.length && r[0] instanceof Error) throw r[0];
            throw new s(r);
          }
        };
      },
      8571: (e, t, r) => {

        const s = r(9621),
              n = r(4277),
              a = r(7043),
              i = {
          needsProtoHack: new Set([n.set, n.map, n.weakSet, n.weakMap])
        };
        e.exports = i.clone = function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          if ("object" != typeof e || null === e) return e;
          let s = i.clone,
              o = r;

          if (t.shallow) {
            if (!0 !== t.shallow) return i.cloneWithShallow(e, t);

            s = e => e;
          } else if (o) {
            const t = o.get(e);
            if (t) return t;
          } else o = new Map();

          const l = n.getInternalProto(e);
          if (l === n.buffer) return !1;
          if (l === n.date) return new Date(e.getTime());
          if (l === n.regex) return new RegExp(e);
          const c = i.base(e, l, t);
          if (c === e) return e;
          if (o && o.set(e, c), l === n.set) for (const r of e) c.add(s(r, t, o));else if (l === n.map) for (const [r, n] of e) c.set(r, s(n, t, o));
          const u = a.keys(e, t);

          for (const r of u) {
            if ("__proto__" === r) continue;

            if (l === n.array && "length" === r) {
              c.length = e.length;
              continue;
            }

            const a = Object.getOwnPropertyDescriptor(e, r);
            a ? a.get || a.set ? Object.defineProperty(c, r, a) : a.enumerable ? c[r] = s(e[r], t, o) : Object.defineProperty(c, r, {
              enumerable: !1,
              writable: !0,
              configurable: !0,
              value: s(e[r], t, o)
            }) : Object.defineProperty(c, r, {
              enumerable: !0,
              writable: !0,
              configurable: !0,
              value: s(e[r], t, o)
            });
          }

          return c;
        }, i.cloneWithShallow = function (e, t) {
          const r = t.shallow;
          (t = Object.assign({}, t)).shallow = !1;
          const n = new Map();

          for (const t of r) {
            const r = s(e, t);
            "object" != typeof r && "function" != typeof r || n.set(r, r);
          }

          return i.clone(e, t, n);
        }, i.base = function (e, t, r) {
          if (!1 === r.prototype) return i.needsProtoHack.has(t) ? new t.constructor() : t === n.array ? [] : {};
          const s = Object.getPrototypeOf(e);
          if (s && s.isImmutable) return e;

          if (t === n.array) {
            const e = [];
            return s !== t && Object.setPrototypeOf(e, s), e;
          }

          if (i.needsProtoHack.has(t)) {
            const e = new s.constructor();
            return s !== t && Object.setPrototypeOf(e, s), e;
          }

          return Object.create(s);
        };
      },
      9474: (e, t, r) => {

        const s = r(4277),
              n = {
          mismatched: null
        };
        e.exports = function (e, t, r) {
          return r = Object.assign({
            prototype: !0
          }, r), !!n.isDeepEqual(e, t, r, []);
        }, n.isDeepEqual = function (e, t, r, a) {
          if (e === t) return 0 !== e || 1 / e == 1 / t;
          const i = typeof e;
          if (i !== typeof t) return !1;
          if (null === e || null === t) return !1;

          if ("function" === i) {
            if (!r.deepFunction || e.toString() !== t.toString()) return !1;
          } else if ("object" !== i) return e != e && t != t;

          const o = n.getSharedType(e, t, !!r.prototype);

          switch (o) {
            case s.buffer:
              return !1;

            case s.promise:
              return e === t;

            case s.regex:
              return e.toString() === t.toString();

            case n.mismatched:
              return !1;
          }

          for (let r = a.length - 1; r >= 0; --r) if (a[r].isSame(e, t)) return !0;

          a.push(new n.SeenEntry(e, t));

          try {
            return !!n.isDeepEqualObj(o, e, t, r, a);
          } finally {
            a.pop();
          }
        }, n.getSharedType = function (e, t, r) {
          if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
          const a = s.getInternalProto(e);
          return a !== s.getInternalProto(t) ? n.mismatched : a;
        }, n.valueOf = function (e) {
          const t = e.valueOf;
          if (void 0 === t) return e;

          try {
            return t.call(e);
          } catch (e) {
            return e;
          }
        }, n.hasOwnEnumerableProperty = function (e, t) {
          return Object.prototype.propertyIsEnumerable.call(e, t);
        }, n.isSetSimpleEqual = function (e, t) {
          for (const r of Set.prototype.values.call(e)) if (!Set.prototype.has.call(t, r)) return !1;

          return !0;
        }, n.isDeepEqualObj = function (e, t, r, a, i) {
          const {
            isDeepEqual: o,
            valueOf: l,
            hasOwnEnumerableProperty: c
          } = n,
                {
            keys: u,
            getOwnPropertySymbols: f
          } = Object;

          if (e === s.array) {
            if (!a.part) {
              if (t.length !== r.length) return !1;

              for (let e = 0; e < t.length; ++e) if (!o(t[e], r[e], a, i)) return !1;

              return !0;
            }

            for (const e of t) for (const t of r) if (o(e, t, a, i)) return !0;
          } else if (e === s.set) {
            if (t.size !== r.size) return !1;

            if (!n.isSetSimpleEqual(t, r)) {
              const e = new Set(Set.prototype.values.call(r));

              for (const r of Set.prototype.values.call(t)) {
                if (e.delete(r)) continue;
                let t = !1;

                for (const s of e) if (o(r, s, a, i)) {
                  e.delete(s), t = !0;
                  break;
                }

                if (!t) return !1;
              }
            }
          } else if (e === s.map) {
            if (t.size !== r.size) return !1;

            for (const [e, s] of Map.prototype.entries.call(t)) {
              if (void 0 === s && !Map.prototype.has.call(r, e)) return !1;
              if (!o(s, Map.prototype.get.call(r, e), a, i)) return !1;
            }
          } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;

          const h = l(t),
                m = l(r);
          if ((t !== h || r !== m) && !o(h, m, a, i)) return !1;
          const d = u(t);
          if (!a.part && d.length !== u(r).length && !a.skip) return !1;
          let p = 0;

          for (const e of d) if (a.skip && a.skip.includes(e)) void 0 === r[e] && ++p;else {
            if (!c(r, e)) return !1;
            if (!o(t[e], r[e], a, i)) return !1;
          }

          if (!a.part && d.length - p !== u(r).length) return !1;

          if (!1 !== a.symbols) {
            const e = f(t),
                  s = new Set(f(r));

            for (const n of e) {
              if (!a.skip || !a.skip.includes(n)) if (c(t, n)) {
                if (!c(r, n)) return !1;
                if (!o(t[n], r[n], a, i)) return !1;
              } else if (c(r, n)) return !1;
              s.delete(n);
            }

            for (const e of s) if (c(r, e)) return !1;
          }

          return !0;
        }, n.SeenEntry = class {
          constructor(e, t) {
            this.obj = e, this.ref = t;
          }

          isSame(e, t) {
            return this.obj === e && this.ref === t;
          }

        };
      },
      7916: (e, t, r) => {

        const s = r(8761);
        e.exports = class extends Error {
          constructor(e) {
            super(e.filter(e => "" !== e).map(e => "string" == typeof e ? e : e instanceof Error ? e.message : s(e)).join(" ") || "Unknown error"), "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, t.assert);
          }

        };
      },
      5277: e => {

        const t = {};
        e.exports = function (e) {
          if (!e) return "";
          let r = "";

          for (let s = 0; s < e.length; ++s) {
            const n = e.charCodeAt(s);
            t.isSafe(n) ? r += e[s] : r += t.escapeHtmlChar(n);
          }

          return r;
        }, t.escapeHtmlChar = function (e) {
          return t.namedHtml.get(e) || (e >= 256 ? "&#" + e + ";" : "&#x".concat(e.toString(16).padStart(2, "0"), ";"));
        }, t.isSafe = function (e) {
          return t.safeCharCodes.has(e);
        }, t.namedHtml = new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [34, "&quot;"], [160, "&nbsp;"], [162, "&cent;"], [163, "&pound;"], [164, "&curren;"], [169, "&copy;"], [174, "&reg;"]]), t.safeCharCodes = function () {
          const e = new Set();

          for (let t = 32; t < 123; ++t) (t >= 97 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || 32 === t || 46 === t || 44 === t || 45 === t || 58 === t || 95 === t) && e.add(t);

          return e;
        }();
      },
      6064: e => {

        e.exports = function (e) {
          return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
        };
      },
      738: e => {

        e.exports = function () {};
      },
      1687: (e, t, r) => {

        const s = r(375),
              n = r(8571),
              a = r(7043),
              i = {};

        e.exports = i.merge = function (e, t, r) {
          if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;

          if (r = Object.assign({
            nullOverride: !0,
            mergeArrays: !0
          }, r), Array.isArray(t)) {
            s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);

            for (let s = 0; s < t.length; ++s) e.push(n(t[s], {
              symbols: r.symbols
            }));

            return e;
          }

          const o = a.keys(t, r);

          for (let s = 0; s < o.length; ++s) {
            const a = o[s];
            if ("__proto__" === a || !Object.prototype.propertyIsEnumerable.call(t, a)) continue;
            const l = t[a];

            if (l && "object" == typeof l) {
              if (e[a] === l) continue;
              !e[a] || "object" != typeof e[a] || Array.isArray(e[a]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[a] = n(l, {
                symbols: r.symbols
              }) : i.merge(e[a], l, r);
            } else (null != l || r.nullOverride) && (e[a] = l);
          }

          return e;
        };
      },
      9621: (e, t, r) => {

        const s = r(375),
              n = {};
        e.exports = function (e, t, r) {
          if (!1 === t || null == t) return e;
          "string" == typeof (r = r || {}) && (r = {
            separator: r
          });
          const a = Array.isArray(t);
          s(!a || !r.separator, "Separator option is not valid for array-based chain");
          const i = a ? t : t.split(r.separator || ".");
          let o = e;

          for (let e = 0; e < i.length; ++e) {
            let a = i[e];
            const l = r.iterables && n.iterables(o);

            if (Array.isArray(o) || "set" === l) {
              const e = Number(a);
              Number.isInteger(e) && (a = e < 0 ? o.length + e : e);
            }

            if (!o || "function" == typeof o && !1 === r.functions || !l && void 0 === o[a]) {
              s(!r.strict || e + 1 === i.length, "Missing segment", a, "in reach path ", t), s("object" == typeof o || !0 === r.functions || "function" != typeof o, "Invalid segment", a, "in reach path ", t), o = r.default;
              break;
            }

            o = l ? "set" === l ? [...o][a] : o.get(a) : o[a];
          }

          return o;
        }, n.iterables = function (e) {
          return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
        };
      },
      8761: e => {

        e.exports = function () {
          try {
            return JSON.stringify(...arguments);
          } catch (e) {
            return "[Cannot display object: " + e.message + "]";
          }
        };
      },
      4277: (e, t) => {

        const r = {};
        t = e.exports = {
          array: Array.prototype,
          buffer: !1,
          date: Date.prototype,
          error: Error.prototype,
          generic: Object.prototype,
          map: Map.prototype,
          promise: Promise.prototype,
          regex: RegExp.prototype,
          set: Set.prototype,
          weakMap: WeakMap.prototype,
          weakSet: WeakSet.prototype
        }, r.typeMap = new Map([["[object Error]", t.error], ["[object Map]", t.map], ["[object Promise]", t.promise], ["[object Set]", t.set], ["[object WeakMap]", t.weakMap], ["[object WeakSet]", t.weakSet]]), t.getInternalProto = function (e) {
          if (Array.isArray(e)) return t.array;
          if (e instanceof Date) return t.date;
          if (e instanceof RegExp) return t.regex;
          if (e instanceof Error) return t.error;
          const s = Object.prototype.toString.call(e);
          return r.typeMap.get(s) || t.generic;
        };
      },
      7043: (e, t) => {

        t.keys = function (e) {
          return !1 !== (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
        };
      },
      3652: (e, t, r) => {

        const s = r(375),
              n = {};
        t.Sorter = class {
          constructor() {
            this._items = [], this.nodes = [];
          }

          add(e, t) {
            const r = [].concat((t = t || {}).before || []),
                  n = [].concat(t.after || []),
                  a = t.group || "?",
                  i = t.sort || 0;
            s(!r.includes(a), "Item cannot come before itself: ".concat(a)), s(!r.includes("?"), "Item cannot come before unassociated items"), s(!n.includes(a), "Item cannot come after itself: ".concat(a)), s(!n.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [e]);

            for (const t of e) {
              const e = {
                seq: this._items.length,
                sort: i,
                before: r,
                after: n,
                group: a,
                node: t
              };

              this._items.push(e);
            }

            if (!t.manual) {
              const e = this._sort();

              s(e, "item", "?" !== a ? "added into group ".concat(a) : "", "created a dependencies error");
            }

            return this.nodes;
          }

          merge(e) {
            Array.isArray(e) || (e = [e]);

            for (const t of e) if (t) for (const e of t._items) this._items.push(Object.assign({}, e));

            this._items.sort(n.mergeSort);

            for (let e = 0; e < this._items.length; ++e) this._items[e].seq = e;

            const t = this._sort();

            return s(t, "merge created a dependencies error"), this.nodes;
          }

          sort() {
            const e = this._sort();

            return s(e, "sort created a dependencies error"), this.nodes;
          }

          _sort() {
            const e = {},
                  t = Object.create(null),
                  r = Object.create(null);

            for (const s of this._items) {
              const n = s.seq,
                    a = s.group;
              r[a] = r[a] || [], r[a].push(n), e[n] = s.before;

              for (const e of s.after) t[e] = t[e] || [], t[e].push(n);
            }

            for (const t in e) {
              const s = [];

              for (const n in e[t]) {
                const a = e[t][n];
                r[a] = r[a] || [], s.push(...r[a]);
              }

              e[t] = s;
            }

            for (const s in t) if (r[s]) for (const n of r[s]) e[n].push(...t[s]);

            const s = {};

            for (const t in e) {
              const r = e[t];

              for (const e of r) s[e] = s[e] || [], s[e].push(t);
            }

            const n = {},
                  a = [];

            for (let e = 0; e < this._items.length; ++e) {
              let t = e;

              if (s[e]) {
                t = null;

                for (let e = 0; e < this._items.length; ++e) {
                  if (!0 === n[e]) continue;
                  s[e] || (s[e] = []);
                  const r = s[e].length;
                  let a = 0;

                  for (let t = 0; t < r; ++t) n[s[e][t]] && ++a;

                  if (a === r) {
                    t = e;
                    break;
                  }
                }
              }

              null !== t && (n[t] = !0, a.push(t));
            }

            if (a.length !== this._items.length) return !1;
            const i = {};

            for (const e of this._items) i[e.seq] = e;

            this._items = [], this.nodes = [];

            for (const e of a) {
              const t = i[e];
              this.nodes.push(t.node), this._items.push(t);
            }

            return !0;
          }

        }, n.mergeSort = (e, t) => e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
      },
      5380: (e, t, r) => {

        const s = r(443),
              n = r(2178),
              a = {
          minDomainSegments: 2,
          nonAsciiRx: /[^\x00-\x7f]/,
          domainControlRx: /[\x00-\x20@\:\/\\#!\$&\'\(\)\*\+,;=\?]/,
          tldSegmentRx: /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
          domainSegmentRx: /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
          URL: s.URL || URL
        };
        t.analyze = function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!e) return n.code("DOMAIN_NON_EMPTY_STRING");
          if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
          if (e.length > 256) return n.code("DOMAIN_TOO_LONG");

          if (a.nonAsciiRx.test(e)) {
            if (!1 === t.allowUnicode) return n.code("DOMAIN_INVALID_UNICODE_CHARS");
            e = e.normalize("NFC");
          }

          if (a.domainControlRx.test(e)) return n.code("DOMAIN_INVALID_CHARS");
          e = a.punycode(e), t.allowFullyQualified && "." === e[e.length - 1] && (e = e.slice(0, -1));
          const r = t.minDomainSegments || a.minDomainSegments,
                s = e.split(".");
          if (s.length < r) return n.code("DOMAIN_SEGMENTS_COUNT");
          if (t.maxDomainSegments && s.length > t.maxDomainSegments) return n.code("DOMAIN_SEGMENTS_COUNT_MAX");
          const i = t.tlds;

          if (i) {
            const e = s[s.length - 1].toLowerCase();
            if (i.deny && i.deny.has(e) || i.allow && !i.allow.has(e)) return n.code("DOMAIN_FORBIDDEN_TLDS");
          }

          for (let e = 0; e < s.length; ++e) {
            const t = s[e];
            if (!t.length) return n.code("DOMAIN_EMPTY_SEGMENT");
            if (t.length > 63) return n.code("DOMAIN_LONG_SEGMENT");

            if (e < s.length - 1) {
              if (!a.domainSegmentRx.test(t)) return n.code("DOMAIN_INVALID_CHARS");
            } else if (!a.tldSegmentRx.test(t)) return n.code("DOMAIN_INVALID_TLDS_CHARS");
          }

          return null;
        }, t.isValid = function (e, r) {
          return !t.analyze(e, r);
        }, a.punycode = function (e) {
          e.includes("%") && (e = e.replace(/%/g, "%25"));

          try {
            return new a.URL("http://".concat(e)).host;
          } catch (t) {
            return e;
          }
        };
      },
      1745: (e, t, r) => {

        const s = r(9848),
              n = r(5380),
              a = r(2178),
              i = {
          nonAsciiRx: /[^\x00-\x7f]/,
          encoder: new (s.TextEncoder || TextEncoder)()
        };
        t.analyze = function (e, t) {
          return i.email(e, t);
        }, t.isValid = function (e, t) {
          return !i.email(e, t);
        }, i.email = function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
          if (!e) return a.code("EMPTY_STRING");
          const r = !i.nonAsciiRx.test(e);

          if (!r) {
            if (!1 === t.allowUnicode) return a.code("FORBIDDEN_UNICODE");
            e = e.normalize("NFC");
          }

          const s = e.split("@");
          if (2 !== s.length) return s.length > 2 ? a.code("MULTIPLE_AT_CHAR") : a.code("MISSING_AT_CHAR");
          const [o, l] = s;
          if (!o) return a.code("EMPTY_LOCAL");

          if (!t.ignoreLength) {
            if (e.length > 254) return a.code("ADDRESS_TOO_LONG");
            if (i.encoder.encode(o).length > 64) return a.code("LOCAL_TOO_LONG");
          }

          return i.local(o, r) || n.analyze(l, t);
        }, i.local = function (e, t) {
          const r = e.split(".");

          for (const e of r) {
            if (!e.length) return a.code("EMPTY_LOCAL_SEGMENT");

            if (t) {
              if (!i.atextRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
            } else for (const t of e) {
              if (i.atextRx.test(t)) continue;
              const e = i.binary(t);
              if (!i.atomRx.test(e)) return a.code("INVALID_LOCAL_CHARS");
            }
          }
        }, i.binary = function (e) {
          return Array.from(i.encoder.encode(e)).map(e => String.fromCharCode(e)).join("");
        }, i.atextRx = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, i.atomRx = new RegExp(["(?:[\\xc2-\\xdf][\\x80-\\xbf])", "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})", "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"].join("|"));
      },
      2178: (e, t) => {

        t.codes = {
          EMPTY_STRING: "Address must be a non-empty string",
          FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
          MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
          MISSING_AT_CHAR: "Address must contain one @ character",
          EMPTY_LOCAL: "Address local part cannot be empty",
          ADDRESS_TOO_LONG: "Address too long",
          LOCAL_TOO_LONG: "Address local part too long",
          EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
          INVALID_LOCAL_CHARS: "Address local part contains invalid character",
          DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
          DOMAIN_TOO_LONG: "Domain too long",
          DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
          DOMAIN_INVALID_CHARS: "Domain contains invalid character",
          DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
          DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
          DOMAIN_SEGMENTS_COUNT_MAX: "Domain contains too many segments",
          DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
          DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
          DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
        }, t.code = function (e) {
          return {
            code: e,
            error: t.codes[e]
          };
        };
      },
      9959: (e, t, r) => {

        const s = r(375),
              n = r(5752);

        t.regex = function () {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          s(void 0 === e.cidr || "string" == typeof e.cidr, "options.cidr must be a string");
          const t = e.cidr ? e.cidr.toLowerCase() : "optional";
          s(["required", "optional", "forbidden"].includes(t), "options.cidr must be one of required, optional, forbidden"), s(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
          let r = e.version || ["ipv4", "ipv6", "ipvfuture"];
          Array.isArray(r) || (r = [r]), s(r.length >= 1, "options.version must have at least 1 version specified");

          for (let e = 0; e < r.length; ++e) s("string" == typeof r[e], "options.version must only contain strings"), r[e] = r[e].toLowerCase(), s(["ipv4", "ipv6", "ipvfuture"].includes(r[e]), "options.version contains unknown version " + r[e] + " - must be one of ipv4, ipv6, ipvfuture");

          r = Array.from(new Set(r));
          const a = "(?:".concat(r.map(e => {
            if ("forbidden" === t) return n.ip[e];
            const r = "\\/".concat("ipv4" === e ? n.ip.v4Cidr : n.ip.v6Cidr);
            return "required" === t ? "".concat(n.ip[e]).concat(r) : "".concat(n.ip[e], "(?:").concat(r, ")?");
          }).join("|"), ")"),
                i = new RegExp("^".concat(a, "$"));
          return {
            cidr: t,
            versions: r,
            regex: i,
            raw: a
          };
        };
      },
      5752: (e, t, r) => {

        const s = r(375),
              n = r(6064),
              a = {
          generate: function generate() {
            const e = {},
                  t = "\\dA-Fa-f",
                  r = "[" + t + "]",
                  s = "\\w-\\.~",
                  n = "!\\$&'\\(\\)\\*\\+,;=",
                  a = "%" + t,
                  i = s + a + n + ":@",
                  o = "[" + i + "]",
                  l = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
            e.ipv4address = "(?:" + l + "\\.){3}" + l;
            const c = r + "{1,4}",
                  u = "(?:" + c + ":" + c + "|" + e.ipv4address + ")",
                  f = "(?:" + c + ":){6}" + u,
                  h = "::(?:" + c + ":){5}" + u,
                  m = "(?:" + c + ")?::(?:" + c + ":){4}" + u,
                  d = "(?:(?:" + c + ":){0,1}" + c + ")?::(?:" + c + ":){3}" + u,
                  p = "(?:(?:" + c + ":){0,2}" + c + ")?::(?:" + c + ":){2}" + u,
                  g = "(?:(?:" + c + ":){0,3}" + c + ")?::" + c + ":" + u,
                  y = "(?:(?:" + c + ":){0,4}" + c + ")?::" + u,
                  b = "(?:(?:" + c + ":){0,5}" + c + ")?::" + c,
                  v = "(?:(?:" + c + ":){0,6}" + c + ")?::";
            e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + f + "|" + h + "|" + m + "|" + d + "|" + p + "|" + g + "|" + y + "|" + b + "|" + v + ")", e.ipvFuture = "v" + r + "+\\.[" + s + n + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);

            const _ = "[" + s + a + n + ":]*",
                  w = "[" + s + a + n + "]{1,255}",
                  $ = "(?:\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]|" + e.ipv4address + "|" + w + ")",
                  x = "(?:" + _ + "@)?" + $ + "(?::\\d*)?",
                  j = "(?:" + _ + "@)?(" + $ + ")(?::\\d*)?",
                  k = o + "*",
                  R = o + "+",
                  A = "(?:\\/" + k + ")*",
                  S = "\\/(?:" + R + A + ")?",
                  O = R + A,
                  E = "[" + s + a + n + "@]+" + A,
                  D = "(?:\\/\\/\\/" + k + A + ")";

            return e.hierPart = "(?:(?:\\/\\/" + x + A + ")|" + S + "|" + O + "|" + D + ")", e.hierPartCapture = "(?:(?:\\/\\/" + j + A + ")|" + S + "|" + O + ")", e.relativeRef = "(?:(?:\\/\\/" + x + A + ")|" + S + "|" + E + "|)", e.relativeRefCapture = "(?:(?:\\/\\/" + j + A + ")|" + S + "|" + E + "|)", e.query = "[" + i + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + i + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + i + "\\/\\?]*", e;
          }
        };
        a.rfc3986 = a.generate(), t.ip = {
          v4Cidr: a.rfc3986.ipv4Cidr,
          v6Cidr: a.rfc3986.ipv6Cidr,
          ipv4: a.rfc3986.ipv4address,
          ipv6: a.rfc3986.ipv6address,
          ipvfuture: a.rfc3986.ipvFuture
        }, a.createRegex = function (e) {
          const t = a.rfc3986,
                r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?",
                i = e.domain ? t.relativeRefCapture : t.relativeRef;
          if (e.relativeOnly) return a.wrap(i + r);
          let o = "";

          if (e.scheme) {
            s(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");
            const r = [].concat(e.scheme);
            s(r.length >= 1, "scheme must have at least 1 scheme specified");
            const a = [];

            for (let e = 0; e < r.length; ++e) {
              const i = r[e];
              s(i instanceof RegExp || "string" == typeof i, "scheme at position " + e + " must be a RegExp or String"), i instanceof RegExp ? a.push(i.source.toString()) : (s(t.schemeRegex.test(i), "scheme at position " + e + " must be a valid scheme"), a.push(n(i)));
            }

            o = a.join("|");
          }

          const l = "(?:" + (o ? "(?:" + o + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")",
                c = e.allowRelative ? "(?:" + l + "|" + i + ")" : l;
          return a.wrap(c + r, o);
        }, a.wrap = function (e, t) {
          return {
            raw: e = "(?=.)(?!https?:/(?:$|[^/]))(?!https?:///)(?!https?:[^/])".concat(e),
            regex: new RegExp("^".concat(e, "$")),
            scheme: t
          };
        }, a.uriRegex = a.createRegex({}), t.regex = function () {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? a.createRegex(e) : a.uriRegex;
        };
      },
      1447: (e, t) => {

        const r = {
          operators: ["!", "^", "*", "/", "%", "+", "-", "<", "<=", ">", ">=", "==", "!=", "&&", "||", "??"],
          operatorCharacters: ["!", "^", "*", "/", "%", "+", "-", "<", "=", ">", "&", "|", "?"],
          operatorsOrder: [["^"], ["*", "/", "%"], ["+", "-"], ["<", "<=", ">", ">="], ["==", "!="], ["&&"], ["||", "??"]],
          operatorsPrefix: ["!", "n"],
          literals: {
            '"': '"',
            "`": "`",
            "'": "'",
            "[": "]"
          },
          numberRx: /^(?:[0-9]*(\.[0-9]*)?){1}$/,
          tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
          symbol: Symbol("formula"),
          settings: Symbol("settings")
        };
        t.Parser = class {
          constructor(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!t[r.settings] && t.constants) for (const e in t.constants) {
              const r = t.constants[e];
              if (null !== r && !["boolean", "number", "string"].includes(typeof r)) throw new Error("Formula constant ".concat(e, " contains invalid ").concat(typeof r, " value type"));
            }
            this.settings = t[r.settings] ? t : Object.assign({
              [r.settings]: !0,
              constants: {},
              functions: {}
            }, t), this.single = null, this._parts = null, this._parse(e);
          }

          _parse(e) {
            let s = [],
                n = "",
                a = 0,
                i = !1;

            const o = e => {
              if (a) throw new Error("Formula missing closing parenthesis");
              const o = s.length ? s[s.length - 1] : null;

              if (i || n || e) {
                if (o && "reference" === o.type && ")" === e) return o.type = "function", o.value = this._subFormula(n, o.value), void (n = "");

                if (")" === e) {
                  const e = new t.Parser(n, this.settings);
                  s.push({
                    type: "segment",
                    value: e
                  });
                } else if (i) {
                  if ("]" === i) return s.push({
                    type: "reference",
                    value: n
                  }), void (n = "");
                  s.push({
                    type: "literal",
                    value: n
                  });
                } else if (r.operatorCharacters.includes(n)) o && "operator" === o.type && r.operators.includes(o.value + n) ? o.value += n : s.push({
                  type: "operator",
                  value: n
                });else if (n.match(r.numberRx)) s.push({
                  type: "constant",
                  value: parseFloat(n)
                });else if (void 0 !== this.settings.constants[n]) s.push({
                  type: "constant",
                  value: this.settings.constants[n]
                });else {
                  if (!n.match(r.tokenRx)) throw new Error("Formula contains invalid token: ".concat(n));
                  s.push({
                    type: "reference",
                    value: n
                  });
                }

                n = "";
              }
            };

            for (const t of e) i ? t === i ? (o(), i = !1) : n += t : a ? "(" === t ? (n += t, ++a) : ")" === t ? (--a, a ? n += t : o(t)) : n += t : t in r.literals ? i = r.literals[t] : "(" === t ? (o(), ++a) : r.operatorCharacters.includes(t) ? (o(), n = t, o()) : " " !== t ? n += t : o();

            o(), s = s.map((e, t) => "operator" !== e.type || "-" !== e.value || t && "operator" !== s[t - 1].type ? e : {
              type: "operator",
              value: "n"
            });
            let l = !1;

            for (const e of s) {
              if ("operator" === e.type) {
                if (r.operatorsPrefix.includes(e.value)) continue;
                if (!l) throw new Error("Formula contains an operator in invalid position");
                if (!r.operators.includes(e.value)) throw new Error("Formula contains an unknown operator ".concat(e.value));
              } else if (l) throw new Error("Formula missing expected operator");

              l = !l;
            }

            if (!l) throw new Error("Formula contains invalid trailing operator");
            1 === s.length && ["reference", "literal", "constant"].includes(s[0].type) && (this.single = {
              type: "reference" === s[0].type ? "reference" : "value",
              value: s[0].value
            }), this._parts = s.map(e => {
              if ("operator" === e.type) return r.operatorsPrefix.includes(e.value) ? e : e.value;
              if ("reference" !== e.type) return e.value;
              if (this.settings.tokenRx && !this.settings.tokenRx.test(e.value)) throw new Error("Formula contains invalid reference ".concat(e.value));
              return this.settings.reference ? this.settings.reference(e.value) : r.reference(e.value);
            });
          }

          _subFormula(e, s) {
            const n = this.settings.functions[s];
            if ("function" != typeof n) throw new Error("Formula contains unknown function ".concat(s));
            let a = [];

            if (e) {
              let t = "",
                  n = 0,
                  i = !1;

              const o = () => {
                if (!t) throw new Error("Formula contains function ".concat(s, " with invalid arguments ").concat(e));
                a.push(t), t = "";
              };

              for (let s = 0; s < e.length; ++s) {
                const a = e[s];
                i ? (t += a, a === i && (i = !1)) : a in r.literals && !n ? (t += a, i = r.literals[a]) : "," !== a || n ? (t += a, "(" === a ? ++n : ")" === a && --n) : o();
              }

              o();
            }

            return a = a.map(e => new t.Parser(e, this.settings)), function (e) {
              const t = [];

              for (const r of a) t.push(r.evaluate(e));

              return n.call(e, ...t);
            };
          }

          evaluate(e) {
            const t = this._parts.slice();

            for (let s = t.length - 2; s >= 0; --s) {
              const n = t[s];

              if (n && "operator" === n.type) {
                const a = t[s + 1];
                t.splice(s + 1, 1);
                const i = r.evaluate(a, e);
                t[s] = r.single(n.value, i);
              }
            }

            return r.operatorsOrder.forEach(s => {
              for (let n = 1; n < t.length - 1;) if (s.includes(t[n])) {
                const s = t[n],
                      a = r.evaluate(t[n - 1], e),
                      i = r.evaluate(t[n + 1], e);
                t.splice(n, 2);
                const o = r.calculate(s, a, i);
                t[n - 1] = 0 === o ? 0 : o;
              } else n += 2;
            }), r.evaluate(t[0], e);
          }

        }, t.Parser.prototype[r.symbol] = !0, r.reference = function (e) {
          return function (t) {
            return t && void 0 !== t[e] ? t[e] : null;
          };
        }, r.evaluate = function (e, t) {
          return null === e ? null : "function" == typeof e ? e(t) : e[r.symbol] ? e.evaluate(t) : e;
        }, r.single = function (e, t) {
          if ("!" === e) return !t;
          const r = -t;
          return 0 === r ? 0 : r;
        }, r.calculate = function (e, t, s) {
          if ("??" === e) return r.exists(t) ? t : s;

          if ("string" == typeof t || "string" == typeof s) {
            if ("+" === e) return (t = r.exists(t) ? t : "") + (r.exists(s) ? s : "");
          } else switch (e) {
            case "^":
              return Math.pow(t, s);

            case "*":
              return t * s;

            case "/":
              return t / s;

            case "%":
              return t % s;

            case "+":
              return t + s;

            case "-":
              return t - s;
          }

          switch (e) {
            case "<":
              return t < s;

            case "<=":
              return t <= s;

            case ">":
              return t > s;

            case ">=":
              return t >= s;

            case "==":
              return t === s;

            case "!=":
              return t !== s;

            case "&&":
              return t && s;

            case "||":
              return t || s;
          }

          return null;
        }, r.exists = function (e) {
          return null != e;
        };
      },
      9926: () => {},
      5688: () => {},
      9708: () => {},
      1152: () => {},
      443: () => {},
      9848: () => {},
      5934: e => {

        e.exports = {
          version: "17.9.2"
        };
      }
    }, t = {}, function r(s) {
      var n = t[s];
      if (void 0 !== n) return n.exports;
      var a = t[s] = {
        exports: {}
      };
      return e[s](a, a.exports, r), a.exports;
    }(5107);
    var e, t;
  });
});
joiBrowser_min.joi;

var moment = createCommonjsModule(function (module, exports) {

  (function (global, factory) {
    module.exports = factory() ;
  })(commonjsGlobal, function () {

    var hookCallback;

    function hooks() {
      return hookCallback.apply(null, arguments);
    } // This is done to register the method called with moment()
    // without creating circular dependencies.


    function setHookCallback(callback) {
      hookCallback = callback;
    }

    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
      // IE8 will treat undefined and null as object if it wasn't for
      // input != null
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;

        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }

        return true;
      }
    }

    function isUndefined(input) {
      return input === void 0;
    }

    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
      var res = [],
          i,
          arrLen = arr.length;

      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }

      return res;
    }

    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }

      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }

      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }

      return a;
    }

    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
      // We need to deep clone this object.
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }

    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }

      return m._pf;
    }

    var some;

    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this),
            len = t.length >>> 0,
            i;

        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }

        return false;
      };
    }

    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
            parsedParts = some.call(flags.parsedDateParts, function (i) {
          return i != null;
        }),
            isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }

      return m._isValid;
    }

    function createInvalid(flags) {
      var m = createUTC(NaN);

      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }

      return m;
    } // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.


    var momentProperties = hooks.momentProperties = [],
        updateInProgress = false;

    function copyConfig(to, from) {
      var i,
          prop,
          val,
          momentPropertiesLen = momentProperties.length;

      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }

      if (!isUndefined(from._i)) {
        to._i = from._i;
      }

      if (!isUndefined(from._f)) {
        to._f = from._f;
      }

      if (!isUndefined(from._l)) {
        to._l = from._l;
      }

      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }

      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }

      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }

      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }

      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }

      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }

      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from[prop];

          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }

      return to;
    } // Moment prototype object


    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);

      if (!this.isValid()) {
        this._d = new Date(NaN);
      } // Prevent infinite loop in case updateOffset creates new moment
      // objects.


      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }

    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }

    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }

        if (firstTime) {
          var args = [],
              arg,
              i,
              key,
              argLen = arguments.length;

          for (i = 0; i < argLen; i++) {
            arg = '';

            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';

              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }

              arg = arg.slice(0, -2); // Remove trailing comma and space
            } else {
              arg = arguments[i];
            }

            args.push(arg);
          }

          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }

        return fn.apply(this, arguments);
      }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }

      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
      var prop, i;

      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];

          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }

      this._config = config; // Lenient ordinal parsing accepts just a number in addition to
      // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
      // TODO: Remove "ordinalParse" fallback in next major release.

      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
          prop;

      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }

      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          // make sure changes to properties don't modify parent config
          res[prop] = extend({}, res[prop]);
        }
      }

      return res;
    }

    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }

    var keys;

    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
            res = [];

        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }

        return res;
      };
    }

    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };

    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
          zerosToFill = targetLength - absNumber.length,
          sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {}; // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }

    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;

      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }

      if (token) {
        formatTokenFunctions[token] = func;
      }

      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }

      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }

    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }

      return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
          i,
          length;

      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }

      return function (mom) {
        var output = '',
            i;

        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }

        return output;
      };
    } // format date using native date object


    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }

      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
      var i = 5;

      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }

      localFormattingTokens.lastIndex = 0;

      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }

      return format;
    }

    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
      var format = this._longDateFormat[key],
          formatUpper = this._longDateFormat[key.toUpperCase()];

      if (format || !formatUpper) {
        return format;
      }

      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }

        return tok;
      }).join('');
      return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
      return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
          normalizedProp,
          prop;

      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);

          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }

      return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
      var units = [],
          u;

      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }

      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }

    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }

    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
          value = 0;

      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }

      return value;
    }

    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }

    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);

          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    } // MOMENTS


    function stringGet(units) {
      units = normalizeUnits(units);

      if (isFunction(this[units])) {
        return this[units]();
      }

      return this;
    }

    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
            i,
            prioritizedLen = prioritized.length;

        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);

        if (isFunction(this[units])) {
          return this[units](value);
        }
      }

      return this;
    }

    var match1 = /\d/,
        //       0 - 9
    match2 = /\d\d/,
        //      00 - 99
    match3 = /\d{3}/,
        //     000 - 999
    match4 = /\d{4}/,
        //    0000 - 9999
    match6 = /[+-]?\d{6}/,
        // -999999 - 999999
    match1to2 = /\d\d?/,
        //       0 - 99
    match3to4 = /\d\d\d\d?/,
        //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/,
        //   99999 - 999999
    match1to3 = /\d{1,3}/,
        //       0 - 999
    match1to4 = /\d{1,4}/,
        //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/,
        // -999999 - 999999
    matchUnsigned = /\d+/,
        //       0 - inf
    matchSigned = /[+-]?\d+/,
        //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi,
        // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
        // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
        // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;
    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }

    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }

      return regexes[token](config._strict, config._locale);
    } // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript


    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }

    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
      var i,
          func = callback,
          tokenLen;

      if (typeof token === 'string') {
        token = [token];
      }

      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }

      tokenLen = token.length;

      for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
      }
    }

    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }

    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
      return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        // I know
        var i;

        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }

        return -1;
      };
    }

    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }

      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    } // FORMATTING


    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    }); // ALIASES

    addUnitAlias('month', 'M'); // PRIORITY

    addUnitPriority('month', 8); // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict); // if we didn't find a month name, mark the date as invalid.


      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    }); // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }

      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }

      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
      var i,
          ii,
          mom,
          llc = monthName.toLocaleLowerCase();

      if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];

        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;

      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }

      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      } // TODO: add sorting
      // Sorting makes sure if one month (or abbr) is a prefix of another
      // see sorting in computeMonthsParse


      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);

        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }

        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    } // MOMENTS


    function setMonth(mom, value) {
      var dayOfMonth;

      if (!mom.isValid()) {
        // No op
        return mom;
      }

      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value); // TODO: Another silent failure?

          if (!isNumber(value)) {
            return mom;
          }
        }
      }

      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));

      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);

      return mom;
    }

    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }

    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }

        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }

    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }

        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }

        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }

    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom;

      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      } // Sorting makes sure if one month (or abbr) is a prefix of another it
      // will match the longer piece.


      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);

      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }

      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    } // FORMATTING


    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year'); // ALIASES

    addUnitAlias('year', 'y'); // PRIORITIES

    addUnitPriority('year', 1); // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    }); // HELPERS

    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    } // HOOKS


    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    }; // MOMENTS


    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
      return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
      // can't just apply() to create a date:
      // https://stackoverflow.com/q/181348
      var date; // the date constructor remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);

        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }

      return date;
    }

    function createUTCDate(y) {
      var date, args; // the Date.UTC function remaps years 0-99 to 1900-1999

      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments); // preserve leap years using a full 400 year cycle, then reset

        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));

        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }

      return date;
    } // start-of-first-week - start-of-year


    function firstWeekOffset(year, dow, doy) {
      var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      fwd = 7 + dow - doy,
          // first-week day local weekday -- which local weekday is fwd
      fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    } // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday


    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
          weekOffset = firstWeekOffset(year, dow, doy),
          dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
          resYear,
          resDayOfYear;

      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }

      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }

    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
          week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
          resWeek,
          resYear;

      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }

      return {
        week: resWeek,
        year: resYear
      };
    }

    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
          weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    } // FORMATTING


    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek'); // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W'); // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5); // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    }); // HELPERS
    // LOCALES

    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6 // The week that contains Jan 6th is the first week of the year.

    };

    function localeFirstDayOfWeek() {
      return this._week.dow;
    }

    function localeFirstDayOfYear() {
      return this._week.doy;
    } // MOMENTS


    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    } // FORMATTING


    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday'); // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E'); // PRIORITY

    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11); // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict); // if we didn't get a weekday name, mark the date as invalid


      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    }); // HELPERS

    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }

      if (!isNaN(input)) {
        return parseInt(input, 10);
      }

      input = locale.weekdaysParse(input);

      if (typeof input === 'number') {
        return input;
      }

      return null;
    }

    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }

      return isNaN(input) ? null : input;
    } // LOCALES


    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
          ii,
          mom,
          llc = weekdayName.toLocaleLowerCase();

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._weekdaysParse, llc);

          if (ii !== -1) {
            return ii;
          }

          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;

      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);

        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }

        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        } // test the regex


        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    } // MOMENTS


    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();

      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }

    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      } // behaves the same as moment#day except
      // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
      // as a setter, sunday should belong to the previous week.


      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }

    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }

        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }

    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }

        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }

    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }

        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }

        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }

    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var minPieces = [],
          shortPieces = [],
          longPieces = [],
          mixedPieces = [],
          i,
          mom,
          minp,
          shortp,
          longp;

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      } // Sorting makes sure if one weekday (or abbr) is a prefix of another it
      // will match the longer piece.


      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    } // FORMATTING


    function hFormat() {
      return this.hours() % 12 || 12;
    }

    function kFormat() {
      return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }

    meridiem('a', true);
    meridiem('A', false); // ALIASES

    addUnitAlias('hour', 'h'); // PRIORITY

    addUnitPriority('hour', 13); // PARSING

    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
          pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
          pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    }); // LOCALES

    function localeIsPM(input) {
      // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
      // Using charAt should be more compatible.
      return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }

    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    }; // internal storage for locale config files

    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
      var i,
          minl = Math.min(arr1.length, arr2.length);

      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }

      return minl;
    }

    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    } // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root


    function chooseLocale(names) {
      var i = 0,
          j,
          next,
          locale,
          split;

      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;

        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));

          if (locale) {
            return locale;
          }

          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            //the next array item is better than a shallower substring of this one
            break;
          }

          j--;
        }

        i++;
      }

      return globalLocale;
    }

    function isLocaleNameSane(name) {
      // Prevent names that look like filesystem paths, i.e contain '/' or '\'
      return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
      var oldLocale = null,
          aliasedRequire; // TODO: Find a better way to register and load all the locales in Node

      if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          // mark as not found to avoid repeating expensive file require call causing high CPU
          // when trying to find en-US, en_US, en-us for every format call
          locales[name] = null; // null means not found
        }
      }

      return locales[name];
    } // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.


    function getSetGlobalLocale(key, values) {
      var data;

      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }

        if (data) {
          // moment.duration._locale = moment._locale = data;
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }

      return globalLocale._abbr;
    }

    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
            parentConfig = baseConfig;
        config.abbr = name;

        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);

            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }

              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }

        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        } // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.


        getSetGlobalLocale(name);
        return locales[name];
      } else {
        // useful for testing
        delete locales[name];
        return null;
      }
    }

    function updateLocale(name, config) {
      if (config != null) {
        var locale,
            tmpLocale,
            parentConfig = baseConfig;

        if (locales[name] != null && locales[name].parentLocale != null) {
          // Update existing child locale in-place to avoid memory-leaks
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          // MERGE
          tmpLocale = loadLocale(name);

          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }

          config = mergeConfigs(parentConfig, config);

          if (tmpLocale == null) {
            // updateLocale is called for creating a new locale
            // Set abbr so it will have a name (getters return
            // undefined otherwise).
            config.abbr = name;
          }

          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        } // backwards compat for now: also set the locale


        getSetGlobalLocale(name);
      } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;

            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }

      return locales[name];
    } // returns locale data


    function getLocale(key) {
      var locale;

      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }

      if (!key) {
        return globalLocale;
      }

      if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);

        if (locale) {
          return locale;
        }

        key = [key];
      }

      return chooseLocale(key);
    }

    function listLocales() {
      return keys(locales);
    }

    function checkOverflow(m) {
      var overflow,
          a = m._a;

      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }

        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }

        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
      }

      return m;
    } // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)


    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
        // iso time formats and regexes
    isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    }; // date from iso format

    function configFromISO(config) {
      var i,
          l,
          string = config._i,
          match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
          allowTime,
          dateFormat,
          timeFormat,
          tzFormat,
          isoDatesLen = isoDates.length,
          isoTimesLen = isoTimes.length;

      if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }

        if (dateFormat == null) {
          config._isValid = false;
          return;
        }

        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              // match[2] should be 'T' or space
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }

          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }

        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }

        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }

        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }

      return result;
    }

    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);

      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }

      return year;
    }

    function preprocessRFC2822(s) {
      // Remove comments and folding whitespace and replace multiple-spaces with a single space
      return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();

        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }

      return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
            m = hm % 100,
            h = (hm - m) / 100;
        return h * 60 + m;
      }
    } // date and time from ref 2822 format


    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
          parsedArray;

      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);

        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);

        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    } // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict


    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);

      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }

      configFromISO(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }

      configFromRFC2822(config);

      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }

      if (config._strict) {
        config._isValid = false;
      } else {
        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
      }
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }); // Pick the first defined of two or three arguments.

    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }

      if (b != null) {
        return b;
      }

      return c;
    }

    function currentDateArray(config) {
      // hooks is actually the exported moment object
      var nowValue = new Date(hooks.now());

      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }

      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    } // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]


    function configFromArray(config) {
      var i,
          date,
          input = [],
          currentDate,
          expectedWeekday,
          yearToUse;

      if (config._d) {
        return;
      }

      currentDate = currentDateArray(config); //compute day of the year from weeks and weekdays

      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      } //if the day of the year is set, figure out what it is


      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      } // Default to current date.
      // * if no year, month, day of month are given, default to today
      // * if day of month is given, default month and year
      // * if month is given, default only year
      // * if year is given, don't default anything


      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      } // Zero out whatever was not defaulted, including time


      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      } // Check for 24:00:00.000


      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }

      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay(); // Apply timezone offset from input. The actual utcOffset can be changed
      // with parseZone.

      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }

      if (config._nextDay) {
        config._a[HOUR] = 24;
      } // check for mismatching day of week


      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }

    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;

      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4; // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).

        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);

        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year); // Default to current week.

        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
          // weekday -- low day numbers are considered next week
          weekday = w.d;

          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          // local weekday -- counting starts from beginning of week
          weekday = w.e + dow;

          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          // default to beginning of week
          weekday = dow;
        }
      }

      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    } // constant that refers to the ISO standard


    hooks.ISO_8601 = function () {}; // constant that refers to the RFC 2822 form


    hooks.RFC_2822 = function () {}; // date from string and format string


    function configFromStringAndFormat(config) {
      // TODO: Move this to another part of the creation flow to prevent circular deps
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }

      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }

      config._a = [];
      getParsingFlags(config).empty = true; // This array is used to make a Date, either with `new Date` or `Date.UTC`

      var string = '' + config._i,
          i,
          parsedInput,
          tokens,
          token,
          skipped,
          stringLength = string.length,
          totalParsedInputLength = 0,
          era,
          tokenLen;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens.length;

      for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];

        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));

          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }

          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        } // don't parse if it's not a known token


        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }

          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      } // add remaining unparsed input length to the string


      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;

      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      } // clear _12h flag if hour is <= 12


      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }

      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem; // handle meridiem

      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem); // handle era

      era = getParsingFlags(config).era;

      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }

      configFromArray(config);
      checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;

      if (meridiem == null) {
        // nothing to do
        return hour;
      }

      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);

        if (isPm && hour < 12) {
          hour += 12;
        }

        if (!isPm && hour === 12) {
          hour = 0;
        }

        return hour;
      } else {
        // this is not supposed to happen
        return hour;
      }
    } // date from string and array of format strings


    function configFromStringAndArray(config) {
      var tempConfig,
          bestMoment,
          scoreToBeat,
          i,
          currentScore,
          validFormatFound,
          bestFormatIsValid = false,
          configfLen = config._f.length;

      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }

      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);

        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }

        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (isValid(tempConfig)) {
          validFormatFound = true;
        } // if there is any input that was not parsed add a penalty for that format


        currentScore += getParsingFlags(tempConfig).charsLeftOver; //or tokens

        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;

        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;

            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }

      extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
      if (config._d) {
        return;
      }

      var i = normalizeObjectUnits(config._i),
          dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }

    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));

      if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
      }

      return res;
    }

    function prepareConfig(config) {
      var input = config._i,
          format = config._f;
      config._locale = config._locale || getLocale(config._l);

      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }

      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }

      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }

      if (!isValid(config)) {
        config._d = null;
      }

      return config;
    }

    function configFromInput(config) {
      var input = config._i;

      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};

      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }

      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }

      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      } // object construction must be done this way.
      // https://github.com/moment/moment/issues/1423


      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return createInvalid();
      }
    }),
        prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);

      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return createInvalid();
      }
    }); // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.

    function pickBy(fn, moments) {
      var res, i;

      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }

      if (!moments.length) {
        return createLocal();
      }

      res = moments[0];

      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }

      return res;
    } // TODO: Use [].sort instead?


    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }

    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }

    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
      var key,
          unitHasDecimal = false,
          i,
          orderLen = ordering.length;

      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }

      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false; // only allow non-integers for smallest unit
          }

          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }

      return true;
    }

    function isValid$1() {
      return this._isValid;
    }

    function createInvalid$1() {
      return createDuration(NaN);
    }

    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
          years = normalizedInput.year || 0,
          quarters = normalizedInput.quarter || 0,
          months = normalizedInput.month || 0,
          weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
          days = normalizedInput.day || 0,
          hours = normalizedInput.hour || 0,
          minutes = normalizedInput.minute || 0,
          seconds = normalizedInput.second || 0,
          milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput); // representation for dateAddRemove

      this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
      minutes * 6e4 + // 1000 * 60
      hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
      // Because of dateAddRemove treats 24 hours as different from a
      // day when working around DST, we need to store them separately

      this._days = +days + weeks * 7; // It is impossible to translate months into days without knowing
      // which months you are are talking about, so we have to store
      // it separately.

      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();

      this._bubble();
    }

    function isDuration(obj) {
      return obj instanceof Duration;
    }

    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    } // compare two arrays, return the number of differences


    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
          lengthDiff = Math.abs(array1.length - array2.length),
          diffs = 0,
          i;

      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }

      return diffs + lengthDiff;
    } // FORMATTING


    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
            sign = '+';

        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }

        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }

    offset('Z', ':');
    offset('ZZ', ''); // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    }); // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']

    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
          chunk,
          parts,
          minutes;

      if (matches === null) {
        return null;
      }

      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    } // Return a moment from input, that is local/utc/zone equivalent to model.


    function cloneWithOffset(input, model) {
      var res, diff;

      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf(); // Use low-level api, because this fn is low-level api.

        res._d.setTime(res._d.valueOf() + diff);

        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }

    function getDateOffset(m) {
      // On Firefox.24 Date#getTimezoneOffset returns a floating point.
      // https://github.com/moment/moment/pull/1871
      return -Math.round(m._d.getTimezoneOffset());
    } // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.


    hooks.updateOffset = function () {}; // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.


    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
          localAdjust;

      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);

          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }

        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }

        this._offset = input;
        this._isUTC = true;

        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }

        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }

        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }

    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }

        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }

    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }

      return this;
    }

    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);

        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }

      return this;
    }

    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }

      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }

      var c = {},
          other;
      copyConfig(c, this);
      c = prepareConfig(c);

      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }

      return this._isDSTShifted;
    }

    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    } // ASP.NET json date format regex


    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
      var duration = input,
          // matching against regexp is expensive, do it on demand
      match = null,
          sign,
          ret,
          diffRes;

      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};

        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match

        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        // checks for null or undefined
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }

      ret = new Duration(duration);

      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }

      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }

      return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
      // We'd normally use ~~inp for this, but unfortunately it also
      // converts floats to ints.
      // inp may be undefined, so careful calling replace on it.
      var res = inp && parseFloat(inp.replace(',', '.')); // apply sign while we're at it

      return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;

      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }

      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }

    function momentsDifference(base, other) {
      var res;

      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }

      other = cloneWithOffset(other, base);

      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }

      return res;
    } // TODO: remove 'name' arg after deprecation is removed


    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp; //invert the arguments, but complain about it

        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }

        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
          days = absRound(duration._days),
          months = absRound(duration._months);

      if (!mom.isValid()) {
        // No op
        return;
      }

      updateOffset = updateOffset == null ? true : updateOffset;

      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }

      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }

      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }

      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    } // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined


    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }

    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
          propertyTest = false,
          properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
          i,
          property,
          propertyLen = properties.length;

      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }

      return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
          dataTypeTest = false;

      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }

      return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
          propertyTest = false,
          properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
          i,
          property;

      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }

      return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
      // Support for single parameter, formats only overload to the calendar function
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined;
          formats = undefined;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      } // We want to compare the start of today, vs this.
      // Getting start-of-today depends on whether we're local/utc/offset or not.


      var now = time || createLocal(),
          sod = cloneWithOffset(now, this).startOf('day'),
          format = hooks.calendarFormat(this, sod) || 'sameElse',
          output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
      return new Moment(this);
    }

    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }

    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }

    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
          localTo = isMoment(to) ? to : createLocal(to);

      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }

      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
          inputMs;

      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }

      units = normalizeUnits(units) || 'millisecond';

      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }

    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
      var that, zoneDelta, output;

      if (!this.isValid()) {
        return NaN;
      }

      that = cloneWithOffset(input, this);

      if (!that.isValid()) {
        return NaN;
      }

      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);

      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;

        case 'month':
          output = monthDiff(this, that);
          break;

        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;

        case 'second':
          output = (this - that) / 1e3;
          break;
        // 1000

        case 'minute':
          output = (this - that) / 6e4;
          break;
        // 1000 * 60

        case 'hour':
          output = (this - that) / 36e5;
          break;
        // 1000 * 60 * 60

        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        // 1000 * 60 * 60 * 24, negate dst

        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        // 1000 * 60 * 60 * 24 * 7, negate dst

        default:
          output = this - that;
      }

      return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
      } // difference in months


      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
          // b is in (anchor - 1 month, anchor + 1 month)
      anchor = a.clone().add(wholeMonthDiff, 'months'),
          anchor2,
          adjust;

      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months'); // linear across the month

        adjust = (b - anchor) / (anchor2 - anchor);
      } //check for negative zero, return zero if negative zero


      return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }

      var utc = keepOffset !== true,
          m = utc ? this.clone().utc() : this;

      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }

      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }

      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */


    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }

      var func = 'moment',
          zone = '',
          prefix,
          year,
          datetime,
          suffix;

      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }

      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }

      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    } // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.


    function locale(key) {
      var newLocaleData;

      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);

        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }

        return this;
      }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });

    function localeData() {
      return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR; // actual modulo - handles negative numbers (for dates before 1970):

    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }

    function utcStartOfDate(y, m, d) {
      // Date.UTC remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }

    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;

        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;

        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;

        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;

        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);

      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }

      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;

        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;

        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;

        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;

        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;

        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;

        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;

        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;

        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }

      this._d.setTime(time);

      hooks.updateOffset(this, true);
      return this;
    }

    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
      return new Date(this.valueOf());
    }

    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }

    function toJSON() {
      // new Date(NaN).toJSON() === null
      return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
      return isValid(this);
    }

    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
      return getParsingFlags(this).overflow;
    }

    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);

      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;

      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }

      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });

    function localeEras(m, format) {
      var i,
          l,
          date,
          eras = this._eras || getLocale('en')._eras;

      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            // truncate time
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }

        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;

          case 'string':
            // truncate time
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }

      return eras;
    }

    function localeErasParse(eraName, format, strict) {
      var i,
          l,
          eras = this.eras(),
          name,
          abbr,
          narrow;
      eraName = eraName.toUpperCase();

      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();

        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }

              break;

            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }

              break;

            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }

              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }

    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;

      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }

    function getEraName() {
      var i,
          l,
          val,
          eras = this.localeData().eras();

      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }

        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }

      return '';
    }

    function getEraNarrow() {
      var i,
          l,
          val,
          eras = this.localeData().eras();

      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }

        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }

      return '';
    }

    function getEraAbbr() {
      var i,
          l,
          val,
          eras = this.localeData().eras();

      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }

        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }

      return '';
    }

    function getEraYear() {
      var i,
          l,
          dir,
          val,
          eras = this.localeData().eras();

      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1; // truncate time

        val = this.clone().startOf('day').valueOf();

        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }

      return this.year();
    }

    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }

      return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }

      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }

      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
      var abbrPieces = [],
          namePieces = [],
          narrowPieces = [],
          mixedPieces = [],
          i,
          l,
          eras = this.eras();

      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }

      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    } // FORMATTING


    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear'); // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG'); // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1); // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    }); // MOMENTS

    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;

      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;

      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;

      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);

        if (week > weeksTarget) {
          week = weeksTarget;
        }

        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
          date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    } // FORMATTING


    addFormatToken('Q', 0, 'Qo', 'quarter'); // ALIASES

    addUnitAlias('quarter', 'Q'); // PRIORITY

    addUnitPriority('quarter', 7); // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    }); // MOMENTS

    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    } // FORMATTING


    addFormatToken('D', ['DD', 2], 'Do', 'date'); // ALIASES

    addUnitAlias('date', 'D'); // PRIORITY

    addUnitPriority('date', 9); // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      // TODO: Remove "ordinalParse" fallback in next major release.
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    }); // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true); // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear'); // ALIASES

    addUnitAlias('dayOfYear', 'DDD'); // PRIORITY

    addUnitPriority('dayOfYear', 4); // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    }); // HELPERS
    // MOMENTS

    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    } // FORMATTING


    addFormatToken('m', ['mm', 2], 0, 'minute'); // ALIASES

    addUnitAlias('minute', 'm'); // PRIORITY

    addUnitPriority('minute', 14); // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE); // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false); // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second'); // ALIASES

    addUnitAlias('second', 's'); // PRIORITY

    addUnitPriority('second', 15); // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND); // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false); // FORMATTING

    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    }); // ALIASES

    addUnitAlias('millisecond', 'ms'); // PRIORITY

    addUnitPriority('millisecond', 16); // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;

    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false); // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName'); // MOMENTS

    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;

    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
      proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }

    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
      return createLocal(input * 1000);
    }

    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
      return string;
    }

    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
      var locale = getLocale(),
          utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || '';

      if (index != null) {
        return get$1(format, index, field, 'month');
      }

      var i,
          out = [];

      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }

      return out;
    } // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)


    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || '';
      }

      var locale = getLocale(),
          shift = localeSorted ? locale._week.dow : 0,
          i,
          out = [];

      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }

      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }

      return out;
    }

    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
            output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    }); // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;

    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }

    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    } // supports only 2.0-style add(1, 's') or add(duration)


    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    } // supports only 2.0-style subtract(1, 's') or subtract(duration)


    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }

    function bubble() {
      var milliseconds = this._milliseconds,
          days = this._days,
          months = this._months,
          data = this._data,
          seconds,
          minutes,
          hours,
          years,
          monthsFromDays; // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166

      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      } // The following code bubbles up values, see the tests for
      // examples of what that means.


      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24); // convert days to months

      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays)); // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }

    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return days * 4800 / 146097;
    }

    function monthsToDays(months) {
      // the reverse of daysToMonths
      return months * 146097 / 4800;
    }

    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }

      var days,
          months,
          milliseconds = this._milliseconds;
      units = normalizeUnits(units);

      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);

        switch (units) {
          case 'month':
            return months;

          case 'quarter':
            return months / 3;

          case 'year':
            return months / 12;
        }
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));

        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;

          case 'day':
            return days + milliseconds / 864e5;

          case 'hour':
            return days * 24 + milliseconds / 36e5;

          case 'minute':
            return days * 1440 + milliseconds / 6e4;

          case 'second':
            return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here

          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;

          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    } // TODO: Use this.as('ms')?


    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }

      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
      return createDuration(this);
    }

    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
      return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month/week
      w: null,
      // weeks to month
      M: 11 // months to year

    }; // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize

    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
          seconds = round(duration.as('s')),
          minutes = round(duration.as('m')),
          hours = round(duration.as('h')),
          days = round(duration.as('d')),
          months = round(duration.as('M')),
          weeks = round(duration.as('w')),
          years = round(duration.as('y')),
          a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }

      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    } // This function allows you to set the rounding function for relative time strings


    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }

      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }

      return false;
    } // This function allows you to set a threshold for relative time strings


    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }

      if (limit === undefined) {
        return thresholds[threshold];
      }

      thresholds[threshold] = limit;

      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }

      return true;
    }

    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var withSuffix = false,
          th = thresholds,
          locale,
          output;

      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }

      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }

      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);

        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }

      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);

      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }

      return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
      // for ISO strings we do not use the normal bubbling rules:
      //  * milliseconds bubble up until they become hours
      //  * days do not bubble at all
      //  * months bubble up until they become years
      // This is because there is no context-free conversion between hours and days
      // (think of clock changes)
      // and also not between days and months (28-31 days per month)
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var seconds = abs$1(this._milliseconds) / 1000,
          days = abs$1(this._days),
          months = abs$1(this._months),
          minutes,
          hours,
          years,
          s,
          total = this.asSeconds(),
          totalSign,
          ymSign,
          daysSign,
          hmsSign;

      if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
      } // 3600 seconds -> 60 minutes -> 1 hour


      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60; // 12 months -> 1 year

      years = absFloor(months / 12);
      months %= 12; // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js

      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang; // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf'); // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    }); //! moment.js

    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto; // currently HTML5 input type only supports 24-hour formats

    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      // <input type="datetime-local" step="0.001" />
      DATE: 'YYYY-MM-DD',
      // <input type="date" />
      TIME: 'HH:mm',
      // <input type="time" />
      TIME_SECONDS: 'HH:mm:ss',
      // <input type="time" step="1" />
      TIME_MS: 'HH:mm:ss.SSS',
      // <input type="time" step="0.001" />
      WEEK: 'GGGG-[W]WW',
      // <input type="week" />
      MONTH: 'YYYY-MM' // <input type="month" />

    };
    return hooks;
  });
});

var lib = joi => {
  const args = {
    format: joi.alternatives([joi.string(), joi.array().items(joi.string().invalid('iso', 'javascript', 'unix'))])
  };
  return {
    type: 'date',
    base: joi.date(),
    coerce: {
      from: 'string',
      method: function method(value, _ref) {
        let {
          schema
        } = _ref;
        const format = schema.$_getFlag('format');

        if (!format) {
          return;
        }

        const date = schema.$_getFlag('utc') ? moment.utc(value, format, true) : moment(value, format, true);

        if (date.isValid()) {
          return {
            value: date.toDate()
          };
        }
      }
    },
    rules: {
      utc: {
        method: function method() {
          let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          return this.$_setFlag('utc', enabled);
        }
      }
    },
    overrides: {
      format: function format(_format) {
        joi.attempt(_format, args.format, 'Invalid format');

        if (['iso', 'javascript', 'unix'].includes(_format)) {
          return this.$_super.format(_format);
        }

        return this.$_setFlag('format', _format);
      }
    }
  };
};

const MAX_STATIC_ASSORTMENT_SIZE = 2000;
const MAX_LABELS_SIZE = 6;
const MAX_DATEONLY = 21001131;
const UNCATEGORIZED_PILLAR = 'Uncategorized';
const STATUSES = ['A', 'R', 'O'];
const PRODUCT_TYPES = ['Footwear', 'Apparel', 'POP'];
const INTERNAL_STATES = ['Unpublished', 'Published', 'Deleted'];
const REGULAR_STATES = ['Unpublished', 'Published', 'Archived', 'Deleted'];
const STATES = ['Unpublished', 'Published', 'Archived', 'Deleted'];
const SEASONS2 = ['Fall/Winter', 'Spring/Summer'];
const SEASONS3 = ['Spring', 'Summer', 'Fall/Winter'];
const SEASONS4 = ['Spring', 'Summer', 'Fall', 'Winter'];
const YEARS = ['2025', '2024', '2023', '2022', '2021', '2020', '2019', '2018'];
const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];
const RETAIL_LIFE_CYCLE = ['Core', 'Q1 2022', 'Q2 2022', 'Q3 2022', 'Q4 2022', 'Q1 2023', 'Q2 2023', 'Q3 2023', 'Q4 2023', 'Q1 2024', 'Q2 2024', 'Q3 2024', 'Q4 2024', 'Q1 2025', 'Q2 2025', 'Q3 2025', 'Q4 2025'];
const RETAIL_STORE_TYPES = [{
  name: 'All Concept',
  abbreviation: 'CON',
  group: 'all'
}, {
  name: 'All Factory Outlet',
  abbreviation: 'OUT',
  group: 'all'
}, {
  name: 'All Big Box',
  abbreviation: 'BB',
  group: 'all'
}, {
  name: 'All Warehouse',
  abbreviation: 'WHS',
  group: 'all'
}, {
  name: 'Select Concept',
  abbreviation: 'CON',
  group: 'select'
}, {
  name: 'Select Factory Outlet',
  abbreviation: 'OUT',
  group: 'select'
}, {
  name: 'Select Big Box',
  abbreviation: 'BB',
  group: 'select'
}, {
  name: 'Select Warehouse',
  abbreviation: 'WHS',
  group: 'select'
}, {
  name: 'Web In-Store',
  abbreviation: 'In-Store',
  group: 'web'
}, {
  name: 'Web Exclusive',
  abbreviation: 'Exclusive',
  group: 'web'
}];
const EXPORT_STATUSES = ['In Progress', 'Final'];
const ORG_TYPES = ['Regular', 'Internal'];
const METHODS = ['Static', 'Dynamic'];
const ENTITIES = ['Domestic', 'Subsidiary', 'Franchisee', 'Joint Venture'];
const REGIONS = ['Domestic', 'International', 'Europe'];
const GENDERS = ['Mens', 'Womens', 'Boys', 'Girls', 'Kids', 'Unisex', 'No Gender'];
const CHANNELS = ['Wholesale', 'Retail'];
const INTERNATIONAL_WHOLESALE_REGIONS = ['Europe', 'International'];
const INTERNATIONAL_RETAIL_REGIONS = ['International'];
const DOMESTIC_WHOLESALE_REGIONS = ['Domestic'];
const DOMESTIC_RETAIL_REGIONS = ['Domestic'];
const WHOLESALE_SAMPLES = ['Full', 'Regional', 'Showroom'];
const RETAIL_SAMPLES = ['Not Ordered', 'Ordered', 'Received'];
const RUSH_SAMPLES = ['Yes', 'No'];
const FOCUS_STYLES = ['Yes', 'No'];
const RETAIL_CARRYOVER = ['Yes', 'No'];
const ALERT_UPDATES = ['Mismatched', 'Dropped', 'Removed'];
const LINKAGE_TYPES = ['linkageId', 'linkageObject'];

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MAX_STATIC_ASSORTMENT_SIZE: MAX_STATIC_ASSORTMENT_SIZE,
  MAX_LABELS_SIZE: MAX_LABELS_SIZE,
  MAX_DATEONLY: MAX_DATEONLY,
  UNCATEGORIZED_PILLAR: UNCATEGORIZED_PILLAR,
  STATUSES: STATUSES,
  PRODUCT_TYPES: PRODUCT_TYPES,
  INTERNAL_STATES: INTERNAL_STATES,
  REGULAR_STATES: REGULAR_STATES,
  STATES: STATES,
  SEASONS2: SEASONS2,
  SEASONS3: SEASONS3,
  SEASONS4: SEASONS4,
  YEARS: YEARS,
  QUARTERS: QUARTERS,
  RETAIL_LIFE_CYCLE: RETAIL_LIFE_CYCLE,
  RETAIL_STORE_TYPES: RETAIL_STORE_TYPES,
  EXPORT_STATUSES: EXPORT_STATUSES,
  ORG_TYPES: ORG_TYPES,
  METHODS: METHODS,
  ENTITIES: ENTITIES,
  REGIONS: REGIONS,
  GENDERS: GENDERS,
  CHANNELS: CHANNELS,
  INTERNATIONAL_WHOLESALE_REGIONS: INTERNATIONAL_WHOLESALE_REGIONS,
  INTERNATIONAL_RETAIL_REGIONS: INTERNATIONAL_RETAIL_REGIONS,
  DOMESTIC_WHOLESALE_REGIONS: DOMESTIC_WHOLESALE_REGIONS,
  DOMESTIC_RETAIL_REGIONS: DOMESTIC_RETAIL_REGIONS,
  WHOLESALE_SAMPLES: WHOLESALE_SAMPLES,
  RETAIL_SAMPLES: RETAIL_SAMPLES,
  RUSH_SAMPLES: RUSH_SAMPLES,
  FOCUS_STYLES: FOCUS_STYLES,
  RETAIL_CARRYOVER: RETAIL_CARRYOVER,
  ALERT_UPDATES: ALERT_UPDATES,
  LINKAGE_TYPES: LINKAGE_TYPES
});

// We extend Joi with some new types that get used in our validations
const capitalizeEachWord = function capitalizeEachWord(str) {
  if (typeof str !== 'string') {
    if (str) throw new Error('Must be a string or falsy');else return;
  }

  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}; // set up our custom extensions for Joi

let Joi = joiBrowser_min;
const extensions = [lib, joi => ({
  // noop do nothing extension to support conditionals below
  // for clarity
  type: 'noop',
  base: joi.any()
}), joi => ({
  // for FE: allow empty string and null,
  type: 'allowEmptyStringOrNull',
  base: joi.string().trim().allow('').allow(null)
}), joi => ({
  // for BE: replace empty string or null with undefined
  // NOTE! Multiple empty statements do not work together! Use one with a comprehensive schema like this
  type: 'allowEmptyStringOrNullToUndefined',
  base: joi.string().trim().allow('').allow(null).empty(Joi.string().valid('', null))
}), joi => ({
  type: 'numberAllowEmptyStringOrNullTo0',
  base: joi.number().empty(['', null]).default(0)
}), joi => ({
  type: 'capitalizedAllowEmptyStringOrNull',
  base: joi.allowEmptyStringOrNull().insensitive(),
  messages: {
    'stringOrEmpty': '{{#label}} must be an a string or empty'
  },
  coerce: function coerce(value, helpers) {
    try {
      return {
        value: capitalizeEachWord(value)
      };
    } catch (err) {
      return {
        errors: helpers.error('stringOrEmpty')
      };
    }
  }
}), joi => ({
  type: 'capitalizedAllowEmptyStringOrNullToUndefined',
  base: joi.allowEmptyStringOrNullToUndefined().insensitive(),
  messages: {
    'stringOrEmpty': '{{#label}} must be an a string or empty'
  },
  coerce: function coerce(value, helpers) {
    try {
      return {
        value: capitalizeEachWord(value)
      };
    } catch (err) {
      return {
        errors: helpers.error('stringOrEmpty')
      };
    }
  }
}), joi => ({
  // basic support for DateOnly format
  type: 'dateOnly',
  base: joi.number().max(MAX_DATEONLY)
}), joi => ({
  // ObjectId in string format
  type: 'objectIdString',
  base: joi.allowEmptyStringOrNullToUndefined().trim().hex().length(24)
}), joi => ({
  // super dumbed down validation of objectId. We had problems when we use .instance(ObjectId)
  type: 'objectIdObject',
  base: joi.object(),
  messages: {
    'objectId': '{{#label}} must be an instance of ObjectID'
  },

  validate(value, helpers) {
    if (!['ObjectId', 'ObjectID'].includes(value && value.constructor && value.constructor.name)) {
      return {
        value,
        error: helpers.error('objectId')
      };
    } else {
      return {
        value
      };
    }
  }

}), joi => ({
  // objectId as string or constructed object
  type: 'objectId',
  base: joi.alternatives(Joi.objectIdString(), Joi.objectIdObject())
}), joi => ({
  type: 'compactedArray',
  base: joi.array(),
  messages: {
    'compactedArray': '{{#label}} must be an array'
  },
  coerce: function coerce(value, helpers) {
    try {
      return {
        value: value.filter(v => v !== undefined && v !== null && v !== '')
      };
    } catch (err) {
      return {
        errors: helpers.error('compactedArray')
      };
    }
  }
})];

for (const extension of extensions) {
  Joi = Joi.extend(extension);
} // export our extended Joi for use elsewhere


var Joi$1 = Joi;

const checkConfig = config => {
  if (!config.variant || !['server', 'browser'].includes(config.variant)) throw new Error('Generating Joi Schema requires variant');
};

// Should be using this as our string type everywhere instead of Joi.string().trim(), etc.

function generateVariantStringType(config) {
  checkConfig(config);
  const isServer = config.variant === 'server';
  const variantStringType = Joi$1[isServer ? 'allowEmptyStringOrNullToUndefined' : 'allowEmptyStringOrNull']();
  return variantStringType;
} // capitalized version

function generateCapitalizedVariantStringType(config) {
  checkConfig(config);
  const isServer = config.variant === 'server';
  const capitalizedVariantStringType = Joi$1[isServer ? 'capitalizedAllowEmptyStringOrNullToUndefined' : 'capitalizedAllowEmptyStringOrNull']();
  return capitalizedVariantStringType;
}
const generateDateOnlySchema = config => {
  checkConfig(config);
  generateVariantStringType(config);
  return Joi$1.dateOnly();
};
const generateArrayQuerySchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);

  if (config.variant === 'server') {
    return Joi$1.object({
      $in: Joi$1.compactedArray().items(variantStringType),
      $and: Joi$1.compactedArray().items(variantStringType)
    }).xor('$in', '$and');
  } else return Joi$1.array().items(variantStringType);
};
const generateNumberDateOffsetSchema = config => {
  checkConfig(config);
  return Joi$1.number().integer().min(-30).max(366);
};
const generateDateStringFormatSchema = config => {
  checkConfig(config);
  return Joi$1.date().format('YYYY-MM-DD');
};
const generateArrayStringAlternative = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const arrayQuerySchema = generateArrayQuerySchema(config);
  return Joi$1.alternatives(arrayQuerySchema, variantStringType);
};
const generateDateObjectSchema = config => {
  checkConfig(config);
  const dateStringFormatSchema = generateDateStringFormatSchema(config);
  const numDateOffsetSchema = generateNumberDateOffsetSchema(config);
  return Joi$1.object({
    beginDate: dateStringFormatSchema,
    endDate: dateStringFormatSchema,
    beginOffset: numDateOffsetSchema,
    endOffset: numDateOffsetSchema
  }).or('beginDate', 'endDate', 'beginOffset', 'endOffset');
};
const generatePriceObject = config => {
  checkConfig(config);
  return Joi$1.object({
    $gte: Joi$1.number(),
    $lte: Joi$1.number()
  }).or('$gte', '$lte');
};
const generateCollectionObject = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return Joi$1.array().items(Joi$1.object({
    style: variantStringType.required(),
    color: variantStringType.required(),
    selected: Joi$1.boolean().required()
  }));
};

var variantSchemas = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateVariantStringType: generateVariantStringType,
  generateCapitalizedVariantStringType: generateCapitalizedVariantStringType,
  generateDateOnlySchema: generateDateOnlySchema,
  generateArrayQuerySchema: generateArrayQuerySchema,
  generateNumberDateOffsetSchema: generateNumberDateOffsetSchema,
  generateDateStringFormatSchema: generateDateStringFormatSchema,
  generateArrayStringAlternative: generateArrayStringAlternative,
  generateDateObjectSchema: generateDateObjectSchema,
  generatePriceObject: generatePriceObject,
  generateCollectionObject: generateCollectionObject
});

const generateJoiProductSchema = function generateJoiProductSchema(config) {
  checkConfig(config); // const computeOptional = prop => config?.makeOptional?.includes(prop) ? 'optional' : 'required'

  const isServer = config.variant === 'server';
  const isPatch = config.operation === 'patch';
  const variantStringType = generateVariantStringType(config);
  const capitalizedVariantStringType = generateCapitalizedVariantStringType(config);
  return Joi$1.object({
    style: variantStringType.required().uppercase().meta({
      show: true,
      canEdit: false,
      order: 'A00'
    }),
    color: variantStringType.required().uppercase().meta({
      show: true,
      canEdit: false,
      order: 'A01'
    }),
    pillar: variantStringType.uppercase().meta({
      show: true,
      canEdit: true,
      order: 'A02'
    }),
    displayGroup: variantStringType,
    thumbnail: variantStringType.meta({
      show: true,
      canEdit: false,
      controlType: 'image',
      order: 'A03'
    }),
    printImage: variantStringType,
    styleNote: variantStringType.meta({
      show: true,
      canEdit: true,
      order: 'F00'
    }),
    colorNote: variantStringType.meta({
      show: true,
      canEdit: true,
      order: 'F01'
    }),
    label: variantStringType.meta({
      show: true,
      canEdit: true,
      controlType: 'label',
      order: 'F04'
    }),
    // conditional product props now
    modifiedDate: Joi$1.date().default(() => new Date()).strip(isPatch),
    properties: Joi$1.object().optional(),
    // regular static
    // we do this because browser handles products outside of scope of assortments
    cost: (isServer ? Joi$1.when(Joi$1.ref('/orgType'), {
      is: 'Regular',
      then: Joi$1.numberAllowEmptyStringOrNullTo0(),
      otherwise: Joi$1.any().strip()
    }) : Joi$1.numberAllowEmptyStringOrNullTo0()).meta({
      show: true,
      canEdit: true,
      order: 'D01',
      group: 'Prices'
    }),
    netCost: (isServer ? Joi$1.when(Joi$1.ref('/orgType'), {
      is: 'Regular',
      then: Joi$1.numberAllowEmptyStringOrNullTo0(),
      otherwise: Joi$1.any().strip()
    }) : Joi$1.numberAllowEmptyStringOrNullTo0()).meta({
      show: true,
      canEdit: true,
      order: 'D04',
      group: 'Prices'
    }),
    suggestedRetail: (isServer ? Joi$1.when(Joi$1.ref('/orgType'), {
      is: 'Regular',
      then: Joi$1.numberAllowEmptyStringOrNullTo0(),
      otherwise: Joi$1.any().strip()
    }) : Joi$1.numberAllowEmptyStringOrNullTo0()).meta({
      show: true,
      canEdit: false,
      order: 'D05',
      group: 'Prices'
    }),
    quantity: (isServer ? Joi$1.when(Joi$1.ref('/orgType'), {
      is: 'Regular',
      then: Joi$1.numberAllowEmptyStringOrNullTo0(),
      otherwise: Joi$1.any().strip()
    }) : Joi$1.numberAllowEmptyStringOrNullTo0()).meta({
      show: true,
      canEdit: false,
      order: 'E00',
      group: 'Quantities'
    }),
    quantityOnHand: (isServer ? Joi$1.when(Joi$1.ref('/orgType'), {
      is: 'Regular',
      then: Joi$1.numberAllowEmptyStringOrNullTo0(),
      otherwise: Joi$1.any().strip()
    }) : Joi$1.numberAllowEmptyStringOrNullTo0()).meta({
      show: true,
      canEdit: false,
      order: 'E01',
      group: 'Quantities'
    }),
    // for internal
    // this section is verbose and maybe there is a simpler way to do all these props, but other experiments with when at a higher level did not work
    // wholesale
    focusStyle: Joi$1.when(Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        channel: variantStringType.required().valid('Wholesale')
      }),
      then: capitalizedVariantStringType.default('No').valid(...FOCUS_STYLES),
      otherwise: Joi$1.any().strip()
    }).meta({
      show: true,
      canEdit: true,
      controlType: 'switch',
      order: 'B03',
      group: 'Channel Info',
      include: [{
        channel: 'Wholesale'
      }]
    }),
    // wholesale and retail, but different
    samples: Joi$1.when(Joi$1.ref('/'), {
      switch: [{
        is: Joi$1.object().keys({
          orgType: 'Regular'
        }),
        then: Joi$1.any().strip()
      }, {
        is: Joi$1.object().keys({
          region: variantStringType.required().valid('International', 'Europe'),
          channel: 'Wholesale'
        }),
        then: capitalizedVariantStringType.valid(...WHOLESALE_SAMPLES)
      }, {
        is: Joi$1.object().keys({
          channel: 'Retail'
        }),
        then: capitalizedVariantStringType.valid(...RETAIL_SAMPLES),
        otherwise: Joi$1.any().strip()
      }]
    }).meta({
      show: true,
      canEdit: true,
      order: 'B04',
      group: 'Channel Info',
      include: [{
        channel: 'Wholesale',
        region: 'International'
      }, {
        channel: 'Wholesale',
        region: 'Europe'
      }]
    }),
    // international wholesale
    rushSamples: Joi$1.when(Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        region: variantStringType.required().valid('International', 'Europe'),
        channel: variantStringType.required().valid('Wholesale')
      }),
      then: capitalizedVariantStringType.default('No').valid(...RUSH_SAMPLES),
      otherwise: Joi$1.any().strip()
    }).meta({
      show: true,
      canEdit: true,
      order: 'B05',
      controlType: 'select',
      group: 'Channel Info',
      include: [{
        channel: 'Wholesale',
        region: 'International'
      }, {
        channel: 'Wholesale',
        region: 'Europe'
      }]
    }),
    // retail
    carryover: Joi$1.when(Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        channel: variantStringType.required().valid('Retail')
      }),
      then: capitalizedVariantStringType.default('No').valid(...RETAIL_CARRYOVER),
      otherwise: Joi$1.any().strip()
    }).meta({
      show: true,
      canEdit: true,
      order: 'B06',
      controlType: 'switch',
      group: 'Channel Info',
      include: [{
        channel: 'Retail'
      }]
    }),
    lifeCycle: Joi$1.when(Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        channel: variantStringType.required().valid('Retail')
      }),
      then: variantStringType.valid(...RETAIL_LIFE_CYCLE),
      otherwise: Joi$1.any().strip()
    }).meta({
      show: true,
      canEdit: true,
      order: 'B07',
      controlType: 'select',
      group: 'Channel Info',
      include: [{
        channel: 'Retail'
      }]
    }),
    dueDate: Joi$1.when(Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        channel: variantStringType.required().valid('Retail')
      }),
      then: Joi$1.dateOnly(),
      otherwise: Joi$1.any().strip()
    }).meta({
      show: true,
      canEdit: true,
      order: 'B08',
      controlType: 'date',
      group: 'Channel Info',
      include: [{
        channel: 'Retail'
      }]
    }),
    storeType: Joi$1.when(Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        channel: variantStringType.required().valid('Retail')
      }),
      then: Joi$1.array().default([]).items(capitalizedVariantStringType.valid(...RETAIL_STORE_TYPES.map(s => s.name))),
      otherwise: Joi$1.any().strip()
    }).meta({
      show: true,
      canEdit: true,
      order: 'B09',
      controlType: 'chips',
      group: 'Channel Info',
      include: [{
        channel: 'Retail'
      }]
    })
  }).unknown(false);
};

// Use below as examples of how to do things
// Do not combine required with default. Just use default in that case. Use one or the other.
// Use object().keys() when extending, but not base objects. ref: https://stackoverflow.com/questions/58811509/what-is-the-difference-between-joi-object-and-joi-object-keys
// When referencing ancestors from an array, array counts as an ancestor
// For when conditionals when using a schema object, make sure the is object uses the object().keys() format.
// AND make sure to specify fully and not just use shorthand value. Use like Joi.string().required().valid('Wholesale') to be precise. That has the desired result.
// NOTE! If you update this, please also see if you need to update products/prepPipeline/validateQuery

const generateJoiSchema = function generateJoiSchema(config) {
  checkConfig(config);
  const isServer = config.variant === 'server';
  const isPatch = config.operation === 'patch';
  const variantStringType = generateVariantStringType(config);
  const productSchema = generateJoiProductSchema(config);
  const schemaSpecification = {
    productType: variantStringType.valid(...PRODUCT_TYPES)[isPatch ? 'optional' : 'required'](),
    orgType: variantStringType.valid(...ORG_TYPES)[isPatch ? 'optional' : 'required'](),
    method: variantStringType.valid(...METHODS)[isPatch ? 'optional' : 'required'](),
    entity: variantStringType.valid(...ENTITIES),
    hierarchy: Joi$1.array()
    /* .default([]) */
    .optional().items(variantStringType.min(1)),
    title: variantStringType[isPatch ? 'optional' : 'required'](),
    subTitle: variantStringType,
    logo: variantStringType,
    starred: Joi$1.boolean(),
    createdDate: Joi$1.date()[isPatch ? 'optional' : 'default'](() => new Date()),
    modifiedDate: Joi$1.date()[isPatch ? 'optional' : 'default'](() => new Date()),
    sortOrder: Joi$1.number(),
    state: variantStringType[isPatch ? 'optional' : 'required']().when('orgType', {
      is: 'Internal',
      then: variantStringType.valid(...INTERNAL_STATES),
      otherwise: variantStringType.valid(...REGULAR_STATES)
    }),
    customContent: Joi$1.array()[isPatch ? 'optional' : 'default']([]).items(Joi$1.object({
      displayGroup: variantStringType.required(),
      sourceFile: variantStringType,
      previewJpg: variantStringType,
      html: variantStringType
    }).unknown(false)),
    // UI / Frontend settings
    uiSettings: Joi$1.object({
      // formalize this?
      filterBar: Joi$1.any(),
      // for group/sort stage UI requirements
      groupSettings: Joi$1.object({
        groupBy: Joi$1.object({
          name: variantStringType.required(),
          value: variantStringType.required()
        }),
        autoSort: Joi$1.any()
      }),
      digitalShowroomSettings: Joi$1.object({
        originalCost: Joi$1.boolean(),
        cost: Joi$1.boolean(),
        netCost: Joi$1.boolean(),
        suggestedRetail: Joi$1.boolean(),
        futureWholesalePrice: Joi$1.boolean(),
        futureSuggestedRetail: Joi$1.boolean(),
        futureEffectiveDate: Joi$1.boolean(),
        initialMarkup: Joi$1.boolean(),
        styleSellThru: Joi$1.boolean(),
        colorSellThru: Joi$1.boolean(),
        availability: Joi$1.boolean(),
        quantity: Joi$1.boolean(),
        seasonCodes: Joi$1.boolean(),
        inventory: Joi$1.boolean(),
        percentage: Joi$1.boolean(),
        division: Joi$1.boolean(),
        dutyCode: Joi$1.boolean(),
        boxCategory: Joi$1.boolean(),
        sizeRange: Joi$1.boolean(),
        sizeScale: Joi$1.boolean(),
        nrf: Joi$1.boolean(),
        features: Joi$1.boolean(),
        marketingDescription: Joi$1.boolean(),
        pillar: Joi$1.boolean(),
        assortmentStatusOnly: Joi$1.boolean(),
        locationId: variantStringType.uppercase(),
        coverPage: Joi$1.boolean(),
        otherSpecialWidths: Joi$1.boolean(),
        displayGroupPage: Joi$1.boolean(),
        popCategory: Joi$1.boolean(),
        materials: Joi$1.boolean(),
        usage: Joi$1.boolean(),
        capacityUnit: Joi$1.boolean(),
        units: Joi$1.boolean(),
        relationships: Joi$1.boolean(),
        expirationDate: Joi$1.boolean(),
        viewerNotes: Joi$1.boolean(),
        manualHeroSelection: Joi$1.boolean(),
        startScreen: Joi$1.boolean(),
        cadOnly: Joi$1.boolean()
      }),
      gridSettings: Joi$1.object({
        // if empty it is manual sort mode (or default sort for dynamic)
        sortOrder: Joi$1.array().items(Joi$1.object({
          colId: variantStringType.required(),
          sort: variantStringType.required().valid('asc', 'desc')
        }).unknown(false)),
        groupIsEnabled: Joi$1.boolean(),
        // formalize this?
        customSort: Joi$1.any()
      })
    }),
    // Regular Assortments
    locationId: variantStringType.min(2).max(3)[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Regular',
      then: variantStringType.required(),
      otherwise: Joi$1.any().strip()
    }),
    status: variantStringType[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Regular',
      then: variantStringType.valid(...STATUSES).required(),
      otherwise: Joi$1.any().strip()
    }),
    user: Joi$1.objectId()[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Regular',
      then: Joi$1.objectId().required(),
      otherwise: Joi$1.any().strip()
    }),
    account: variantStringType[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Regular',
      then: variantStringType.optional(),
      otherwise: Joi$1.any().strip()
    }),
    accountName: variantStringType[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Regular',
      then: variantStringType.optional(),
      otherwise: Joi$1.any().strip()
    }),
    accountSubOffice: variantStringType[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Regular',
      then: variantStringType.optional(),
      otherwise: Joi$1.any().strip()
    }),
    // Internal Assortments
    channel: variantStringType.valid(...CHANNELS)[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Internal',
      then: variantStringType.required(),
      otherwise: Joi$1.any().strip()
    }),
    region: variantStringType.valid(...REGIONS)[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Internal',
      then: variantStringType.required(),
      otherwise: Joi$1.any().strip()
    }),
    // gender required for internal, but not POP
    gender: variantStringType.valid(...GENDERS)[isPatch ? 'optional' : 'when'](Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        orgType: variantStringType.required().valid('Internal'),
        productType: variantStringType.required().invalid('POP')
      }),
      then: variantStringType.required(),
      otherwise: Joi$1.any().strip()
    }),
    season: variantStringType[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Internal',
      then: variantStringType.required().when('channel', {
        is: 'Retail',
        then: variantStringType.valid(...SEASONS3).required(),
        otherwise: variantStringType.valid(...SEASONS2).required()
      }),
      otherwise: Joi$1.any().strip()
    }),
    year: variantStringType.length(4)[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Internal',
      then: variantStringType.required(),
      otherwise: Joi$1.any().strip()
    }),
    lastEditedByUser: variantStringType[isPatch ? 'optional' : 'when']('orgType', {
      is: 'Internal',
      then: variantStringType.optional(),
      otherwise: Joi$1.any().strip()
    }),
    // Static Assortments
    products: Joi$1.array()[isPatch ? 'optional' : 'when']('method', {
      is: 'Static',
      then: Joi$1.array().default([]).max(MAX_STATIC_ASSORTMENT_SIZE).items(productSchema).required(),
      otherwise: Joi$1.any().strip()
    }),
    alerts: Joi$1.array().items(Joi$1.object({
      style: variantStringType.required().min(1),
      color: variantStringType.required().min(1),
      update: variantStringType.valid(...ALERT_UPDATES),
      updateDate: Joi$1.date().default(() => new Date())
    }).unknown(false))[isPatch ? 'optional' : 'when']('method', {
      is: 'Static',
      then: Joi$1.array().default([]),
      otherwise: Joi$1.any().strip()
    }),
    labels: Joi$1.array().items(Joi$1.object({
      // special case for these values: keep '' empty string values
      color: Joi$1.string().allow('').default(''),
      name: Joi$1.string().allow('').default('')
    }).unknown(false).required()).length(MAX_LABELS_SIZE)[isPatch ? 'optional' : 'when']('method', {
      is: 'Static',
      then: Joi$1.array().required().default(Array.from({
        length: MAX_LABELS_SIZE
      }, (v, i) => ({
        color: '',
        name: ''
      }))),
      otherwise: Joi$1.any().strip()
    }),
    // Dynamic Assortments
    query: Joi$1.alternatives(Joi$1.object().required().min(1), variantStringType.required())[isPatch ? 'optional' : 'when']('method', {
      is: 'Dynamic',
      then: Joi$1.alternatives().required(),
      otherwise: Joi$1.any().strip()
    }),
    // Internal Wholesale Assortments
    // dateonly format
    carryoverDate: Joi$1.dateOnly()[isPatch ? 'optional' : 'when'](Joi$1.ref('/'), {
      is: Joi$1.object().keys({
        orgType: variantStringType.required().valid('Internal'),
        channel: variantStringType.required().valid('Wholesale')
      }),
      then: Joi$1.dateOnly().required(),
      otherwise: Joi$1.any().strip()
    })
  };
  if (isServer) schemaSpecification._id = Joi$1.objectId();
  if (isServer) schemaSpecification.__v = Joi$1.number();
  return Joi$1.object(schemaSpecification).unknown(false);
};

function generateAssortmentsQuerySchema(config) {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return Joi$1.object({
    _id: Joi$1.objectId(),
    $or: Joi$1.array().items(Joi$1.object()),
    user: Joi$1.when('orgType', {
      is: 'Regular',
      // objectId or actual user object if populated
      then: Joi$1.alternatives(Joi$1.objectId(), Joi$1.object())
    }),
    state: variantStringType.valid(...STATES),
    starred: Joi$1.boolean(),
    title: Joi$1.alternatives(variantStringType.min(1), Joi$1.array().items(variantStringType.min(1))),
    orgType: variantStringType.valid(...ORG_TYPES).required(),
    method: variantStringType.valid(...METHODS).required(),
    productType: variantStringType.valid(...PRODUCT_TYPES).required(),
    region: variantStringType.valid(...REGIONS).when('orgType', {
      is: 'Internal',
      then: variantStringType.required()
    }),
    channel: variantStringType.valid(...CHANNELS).when('orgType', {
      is: 'Internal',
      then: variantStringType.required()
    }),
    gender: variantStringType.valid(...GENDERS),
    season: Joi$1.when('orgType', {
      is: 'Internal',
      then: variantStringType.required().when('channel', {
        is: 'Retail',
        then: variantStringType.valid(...SEASONS3),
        otherwise: variantStringType.valid(...SEASONS2)
      }),
      otherwise: variantStringType.valid(...SEASONS3.concat(SEASONS2))
    }),
    year: variantStringType.length(4).when('orgType', {
      is: 'Internal',
      then: variantStringType.required()
    })
  });
}

const generateCollectionQuerySchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const assortmentsQuerySchema = generateAssortmentsQuerySchema(config);
  return Joi$1.object({
    name: variantStringType.default('Default'),
    linkageType: variantStringType.valid(...LINKAGE_TYPES).required(),
    linkageId: Joi$1.when('linkageType', {
      is: 'linkageId',
      then: Joi$1.objectId(),
      otherwise: Joi$1.any().forbidden()
    }),
    linkageObject: Joi$1.when('linkageType', {
      is: 'linkageObject',
      then: assortmentsQuerySchema,
      otherwise: Joi$1.any().forbidden()
    }),
    linkageModel: variantStringType.required()
  });
};

var collectionQuery = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateCollectionQuerySchema: generateCollectionQuerySchema
});

const generateAssortmentCloneSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return Joi$1.object({
    assortments: generateArrayQuerySchema(config),
    bccRecipients: generateArrayQuerySchema(config),
    locationId: variantStringType.required(),
    message: variantStringType.optional(),
    recipients: generateArrayQuerySchema(config)
  });
};

var assortmentClone = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateAssortmentCloneSchema: generateAssortmentCloneSchema
});

const generateAssortmentGroupSortBatchSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const BASE_ITEM_MOVE_SCHEMA = Joi$1.array().items(Joi$1.object({
    item: variantStringType.required(),
    beforeItem: variantStringType.required(),
    style: variantStringType.optional()
  }));
  return Joi$1.array().items(Joi$1.object({
    moveDisplayGroup: BASE_ITEM_MOVE_SCHEMA,
    moveStyle: BASE_ITEM_MOVE_SCHEMA,
    moveColor: BASE_ITEM_MOVE_SCHEMA,
    sortStyles: Joi$1.array().items(Joi$1.string())
  }));
};

var assortmentGroupSortBatch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateAssortmentGroupSortBatchSchema: generateAssortmentGroupSortBatchSchema
});

const generateProductsBatchScema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const PRODUCT_SCHEMA = generateJoiProductSchema({
    variant: config.variant,
    operation: 'patch'
  });
  return Joi$1.array().items(Joi$1.object({
    addProducts: Joi$1.array().items({
      data: PRODUCT_SCHEMA
    }),
    updateProducts: Joi$1.array().items(PRODUCT_SCHEMA),
    deleteProducts: Joi$1.array().items(Joi$1.object({
      style: variantStringType.required().uppercase(),
      color: variantStringType.required().uppercase()
    })),
    patch: Joi$1.object({
      customContent: Joi$1.array().optional(),
      query: Joi$1.object().optional(),
      uiSettings: Joi$1.object().optional()
    })
  }));
};

var assortmentProductsBatch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateProductsBatchScema: generateProductsBatchScema
});

const generateQueryOptionsSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const assortmentsQuerySchema = generateAssortmentsQuerySchema(config);
  const collectionsQuerySchema = generateCollectionQuerySchema(config);
  const dateOnlySchema = generateDateOnlySchema(config);
  return Joi$1.object({
    user: Joi$1.alternatives(Joi$1.objectId(), Joi$1.object()),
    sort: Joi$1.object().pattern(variantStringType, Joi$1.number().valid(-1, 0, 1)),
    skip: Joi$1.number(),
    limit: Joi$1.number(),
    project: Joi$1.object().pattern(variantStringType, Joi$1.number().valid(-1, 0, 1)),
    finalProject: Joi$1.object().pattern(variantStringType, Joi$1.number().valid(-1, 0, 1)),
    totalCount: Joi$1.boolean(),
    justArray: Joi$1.boolean(),
    styleLevel: Joi$1.alternatives(Joi$1.boolean(), Joi$1.object({
      colorSort: Joi$1.object().pattern(variantStringType, Joi$1.number().valid(-1, 0, 1))
    })),
    preserveNullAndEmptyArrays: Joi$1.boolean(),
    frontendOptions: Joi$1.object(),
    popColors: Joi$1.array().items(variantStringType),
    includeCustomContent: Joi$1.boolean(),
    productDataFormat: Joi$1.alternatives(Joi$1.boolean(), Joi$1.object({
      withPricing: Joi$1.boolean(),
      location: variantStringType.min(2).max(3)
    })),
    includeEcomData: Joi$1.boolean(),
    includeImageData: Joi$1.boolean(),
    streaming: Joi$1.boolean(),
    assortmentsQuery: assortmentsQuerySchema,
    markInAssortmentsQuery: assortmentsQuerySchema,
    includeAssortmentsDataQuery: assortmentsQuerySchema,
    assortmentsQueryPreserveNull: Joi$1.boolean(),
    collectionsQuery: collectionsQuerySchema,
    markInCollectionsQuery: collectionsQuerySchema,
    includeCollectionsDataQuery: collectionsQuerySchema,
    collectionsQueryPreserveNull: Joi$1.boolean(),
    region: variantStringType.valid(...REGIONS),
    carryoverDate: dateOnlySchema,
    otherLocations: Joi$1.array().items(variantStringType.min(2).max(3))
  });
};

var queryOptions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateQueryOptionsSchema: generateQueryOptionsSchema
});

const generateProductQuerySchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const singleOrArrayQuerySchema = generateArrayStringAlternative(config);
  const queryOptionsSchema = generateQueryOptionsSchema(config);
  return Joi$1.object({
    id: singleOrArrayQuerySchema,
    style: singleOrArrayQuerySchema,
    color: singleOrArrayQuerySchema,
    keyInitiative: singleOrArrayQuerySchema,
    styleSuffix: singleOrArrayQuerySchema,
    productType: singleOrArrayQuerySchema,
    name: singleOrArrayQuerySchema,
    description: singleOrArrayQuerySchema,
    materials: singleOrArrayQuerySchema,
    popType: singleOrArrayQuerySchema,
    popGender: singleOrArrayQuerySchema,
    outsole: singleOrArrayQuerySchema,
    upper: singleOrArrayQuerySchema,
    features: singleOrArrayQuerySchema,
    division: singleOrArrayQuerySchema,
    gender: singleOrArrayQuerySchema,
    seasonCodes: singleOrArrayQuerySchema,
    pillar: singleOrArrayQuerySchema,
    boughtStatus: singleOrArrayQuerySchema,
    carryover: Joi$1.number().valid(0, 1),
    usage: singleOrArrayQuerySchema,
    popCategory: singleOrArrayQuerySchema,
    '_style.boughtStatus': singleOrArrayQuerySchema,
    '_style.carryover': Joi$1.number().valid(0, 1),
    'components.color1': singleOrArrayQuerySchema,
    'components.color2': singleOrArrayQuerySchema,
    'components.color3': singleOrArrayQuerySchema,
    'components.material1': singleOrArrayQuerySchema,
    'components.material2': singleOrArrayQuerySchema,
    'components.material3': singleOrArrayQuerySchema,
    'categories.type': singleOrArrayQuerySchema,
    'categories.height': singleOrArrayQuerySchema,
    'categories.shape': singleOrArrayQuerySchema,
    'categories.closure': singleOrArrayQuerySchema,
    'categories.sport': singleOrArrayQuerySchema,
    'categories.lighted': singleOrArrayQuerySchema,
    'categories.vegan': singleOrArrayQuerySchema,
    'categories.width': singleOrArrayQuerySchema,
    'categories.apparelType': singleOrArrayQuerySchema,
    'categories.apparelSubType': singleOrArrayQuerySchema,
    'categories.accessory': singleOrArrayQuerySchema,
    dueDate: Joi$1.alternatives(Joi$1.date(), Joi$1.object({
      beginDate: Joi$1.date(),
      endDate: Joi$1.date(),
      beginOffset: Joi$1.number(),
      endOffset: Joi$1.number
    }).min(1)),
    samples: singleOrArrayQuerySchema,
    rushSamples: singleOrArrayQuerySchema,
    storeType: singleOrArrayQuerySchema,
    lifeCycle: singleOrArrayQuerySchema,
    cost: Joi$1.alternatives(Joi$1.number().min(0), Joi$1.object({
      $gte: Joi$1.number().min(0),
      $lte: Joi$1.number().min(0),
      $gt: Joi$1.number().min(0),
      $lt: Joi$1.number().min(0)
    }).min(1)),
    suggestedRetail: Joi$1.alternatives(Joi$1.number().min(0), Joi$1.object({
      $gte: Joi$1.number().min(0),
      $lte: Joi$1.number().min(0),
      $gt: Joi$1.number().min(0),
      $lt: Joi$1.number().min(0)
    }).min(1)),
    'locations.code': Joi$1.alternatives(variantStringType.min(2).max(3), variantStringType.valid('___ALL___')),
    'locations.lineStatus': singleOrArrayQuerySchema,
    availabilityDate: Joi$1.alternatives(Joi$1.date(), Joi$1.object({
      beginDate: Joi$1.date(),
      endDate: Joi$1.date(),
      beginOffset: Joi$1.number(),
      endOffset: Joi$1.number(),
      size: Joi$1.string()
    }).min(1)),
    'locations.lastProdDate': Joi$1.alternatives(Joi$1.date(), Joi$1.object({
      beginDate: Joi$1.date(),
      endDate: Joi$1.date(),
      beginOffset: Joi$1.number(),
      endOffset: Joi$1.number()
    }).min(1)),
    'locations.wholesalePrice': Joi$1.alternatives(Joi$1.number().min(0), Joi$1.object({
      $gte: Joi$1.number().min(0),
      $lte: Joi$1.number().min(0),
      $gt: Joi$1.number().min(0),
      $lt: Joi$1.number().min(0)
    }).min(1)),
    'locations.suggestedRetail': Joi$1.alternatives(Joi$1.number().min(0), Joi$1.object({
      $gte: Joi$1.number().min(0),
      $lte: Joi$1.number().min(0),
      $gt: Joi$1.number().min(0),
      $lt: Joi$1.number().min(0)
    }).min(1)),
    $or: Joi$1.array().items(Joi$1.object()),
    _options: queryOptionsSchema,
    _uiOptions: queryOptionsSchema
  });
};

var productsQuery = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateProductQuerySchema: generateProductQuerySchema
});

const generateAssortmentProductFetchSchema = config => {
  checkConfig(config);
  return generateProductQuerySchema(config);
};

var assortmentProductsFetch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateAssortmentProductFetchSchema: generateAssortmentProductFetchSchema
});

const generateCollectionUpdate = config => {
  checkConfig(config);
  return Joi$1.array().items(Joi$1.object({
    addProducts: generateCollectionObject(config),
    updateProducts: generateCollectionObject(config),
    deleteProducts: generateCollectionObject(config)
  }));
};

var collectionUpdate = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateCollectionUpdate: generateCollectionUpdate
});

const generateAssortmentDocumentSettingsSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return Joi$1.object({
    assortmentDate: Joi$1.boolean(),
    assortmentSelectsOnly: Joi$1.boolean(),
    assortmentStatusOnly: Joi$1.boolean(),
    author: Joi$1.boolean(),
    availability: Joi$1.boolean(),
    boxCategory: Joi$1.boolean(),
    colorSellThru: Joi$1.boolean(),
    cost: Joi$1.boolean(),
    coverPage: Joi$1.boolean(),
    displayGroupPage: Joi$1.boolean(),
    displayGroupPageBreaks: Joi$1.boolean(),
    division: Joi$1.boolean(),
    dutyCode: Joi$1.boolean(),
    features: Joi$1.boolean(),
    hideSpillover: Joi$1.boolean(),
    initialMarkup: Joi$1.boolean(),
    locationId: variantStringType,
    lineStatus: variantStringType,
    exportStatus: variantStringType.valid(...EXPORT_STATUSES),
    manualHeroSelection: Joi$1.boolean(),
    netCost: Joi$1.boolean(),
    nrf: Joi$1.boolean(),
    originalCost: Joi$1.boolean(),
    otherSpecialWidths: Joi$1.boolean(),
    pageNumbers: Joi$1.boolean(),
    percentage: Joi$1.boolean(),
    pillar: Joi$1.boolean(),
    priceDisclaimer: Joi$1.boolean(),
    printResolution: Joi$1.boolean(),
    quantity: Joi$1.boolean(),
    sizeLegend: Joi$1.boolean(),
    sizeRange: Joi$1.boolean(),
    sizeScale: Joi$1.boolean(),
    sortNumber: Joi$1.boolean(),
    styleSellThru: Joi$1.boolean(),
    suggestedRetail: Joi$1.boolean(),
    viewerNotes: Joi$1.boolean(),
    season: variantStringType,
    year: variantStringType,
    account: variantStringType,
    accountName: variantStringType,
    accountSubOffice: variantStringType,
    cadOnly: Joi$1.boolean(),
    cost: Joi$1.boolean(),
    inventory: Joi$1.boolean(),
    colorLastProdDate: Joi$1.boolean(),
    styleLastProdDate: Joi$1.boolean(),
    seasonCodes: Joi$1.boolean(),
    dimensions: Joi$1.boolean(),
    popCategory: Joi$1.boolean(),
    materials: Joi$1.boolean(),
    usage: Joi$1.boolean(),
    wholesalePrice: Joi$1.boolean(),
    units: Joi$1.boolean(),
    capacityUnit: Joi$1.boolean(),
    relationships: Joi$1.boolean(),
    expirationDate: Joi$1.boolean(),
    units: Joi$1.boolean(),
    marketingDescription: Joi$1.boolean(),
    startScreen: Joi$1.boolean(),
    kiCoverPage: Joi$1.boolean(),
    sectionBreaks: Joi$1.boolean(),
    landscape: Joi$1.boolean(),
    sectionBreaks: Joi$1.boolean(),
    includeImages: Joi$1.boolean(),
    productFilteringQuery: Joi$1.object(),
    samples: Joi$1.boolean(),
    rushSamples: Joi$1.boolean(),
    boughtStatus: Joi$1.boolean(),
    carryover: Joi$1.boolean(),
    futureSuggestedRetail: Joi$1.boolean(),
    futureWholesalePrice: Joi$1.boolean(),
    futureEffectiveDate: Joi$1.boolean()
  });
};

var documentSettings = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateAssortmentDocumentSettingsSchema: generateAssortmentDocumentSettingsSchema
});

const generateAssortmentDocumentSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const documentSettings = generateAssortmentDocumentSettingsSchema(config);
  const assortmentsQuerySchema = generateAssortmentsQuerySchema(config);
  return Joi$1.object({
    user: Joi$1.alternatives(Joi$1.object(), Joi$1.objectId())[config.variant === 'server ' ? 'required' : 'forbidden'](),
    assortment: Joi$1.alternatives(Joi$1.object(), Joi$1.objectId()),
    assortmentsQuery: assortmentsQuerySchema,
    documentType: Joi$1.object({
      type: variantStringType.required(),
      subType: variantStringType.optional()
    }),
    filename: variantStringType.required(),
    createdDate: Joi$1.date(),
    modifiedDate: Joi$1.date(),
    settings: documentSettings
  }).xor('assortment', 'assortmentsQuery');
};

var document = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateAssortmentDocumentSchema: generateAssortmentDocumentSchema
});

// import Joi from '../../Joi'
const generateDocumentCreateSchema = config => {
  checkConfig(config);
  return generateAssortmentDocumentSchema(config);
};

var documentCreate = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateDocumentCreateSchema: generateDocumentCreateSchema
});

const generateDocumentShareSchema = config => {
  checkConfig(config);
  return generateAssortmentDocumentSchema(config);
};

var documentShare = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateDocumentShareSchema: generateDocumentShareSchema
});

const generateDynamicOptionsFetchSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  const productsQuerySchema = generateProductQuerySchema(config);
  return Joi$1.object({
    query: productsQuerySchema,
    requestedOptions: Joi$1.array().items(variantStringType)
  });
};

var dynamicOptions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateDynamicOptionsFetchSchema: generateDynamicOptionsFetchSchema
});

const generateInternalAssortmentTOCFetchSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return Joi$1.object({
    channel: variantStringType.required(),
    method: variantStringType.required(),
    orgType: variantStringType.required(),
    productType: variantStringType.required(),
    region: variantStringType.required(),
    season: variantStringType.required(),
    state: variantStringType.valid(...STATES),
    year: variantStringType.required(),
    _options: Joi$1.object(),
    _uiOptions: {
      sort: Joi$1.object()
    }
  });
};

var internalAssortmentTOCFetch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateInternalAssortmentTOCFetchSchema: generateInternalAssortmentTOCFetchSchema
});

const generateProductSearchSchema = config => {
  checkConfig(config);
  return generateProductQuerySchema(config);
};

var productSearch = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateProductSearchSchema: generateProductSearchSchema
});

var api = /*#__PURE__*/Object.freeze({
  __proto__: null,
  assortmentClone: assortmentClone,
  assortmentGroupSortBatch: assortmentGroupSortBatch,
  assortmentProductsBatch: assortmentProductsBatch,
  assortmentCassortmentProductsFetchone: assortmentProductsFetch,
  collectionUpdate: collectionUpdate,
  documentCreate: documentCreate,
  documentShare: documentShare,
  dynamicOptions: dynamicOptions,
  internalAssortmentTOCFetch: internalAssortmentTOCFetch,
  productSearch: productSearch
});

const retailStoreTypesMap = {};

for (const st of RETAIL_STORE_TYPES) {
  retailStoreTypesMap[st.name] = st;
}

var index$5 = {
  MAX_STATIC_ASSORTMENT_SIZE,
  MAX_LABELS_SIZE,
  MAX_DATEONLY,
  UNCATEGORIZED_PILLAR,
  statuses: STATUSES,
  productTypes: PRODUCT_TYPES,
  internalStates: INTERNAL_STATES,
  regularStates: REGULAR_STATES,
  seasons2: SEASONS2,
  seasons3: SEASONS3,
  seasons4: SEASONS4,
  years: YEARS,
  quarters: QUARTERS,
  retailLifeCycle: RETAIL_LIFE_CYCLE,
  retailStoreTypes: RETAIL_STORE_TYPES,
  retailStoreTypesMap,
  orgTypes: ORG_TYPES,
  methods: METHODS,
  entities: ENTITIES,
  regions: REGIONS,
  genders: GENDERS,
  channels: CHANNELS,
  internationalWholesaleRegions: INTERNATIONAL_WHOLESALE_REGIONS,
  internationalRetailRegions: INTERNATIONAL_RETAIL_REGIONS,
  domesticWholesaleRegions: DOMESTIC_WHOLESALE_REGIONS,
  domesticRetailRegions: DOMESTIC_RETAIL_REGIONS,
  wholesaleSamples: WHOLESALE_SAMPLES,
  retailSamples: RETAIL_SAMPLES,
  rushSamples: RUSH_SAMPLES,
  focusStyles: FOCUS_STYLES,
  retailCarryover: RETAIL_CARRYOVER,
  alertUpdates: ALERT_UPDATES,
  api,
  generateDateOnlySchema,
  generateJoiSchema,
  generateJoiProductSchema,
  generateVariantStringType,
  generateCapitalizedVariantStringType,
  generateAssortmentsQuerySchema,
  generateCollectionQuerySchema,
  Joi: Joi$1
};

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  document: document,
  documentSettings: documentSettings
});

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  collectionsQuery: collectionQuery
});

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  productsQuery: productsQuery,
  queryOptions: queryOptions
});

const generateSampleInventoryBatchProduct = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return joiBrowser_min.object({
    style: variantStringType,
    aisle: variantStringType.optional(),
    gender: variantStringType.optional(),
    direction: variantStringType.optional(),
    division: variantStringType.optional(),
    color: variantStringType.optional(),
    status: variantStringType.optional(),
    level: variantStringType.optional(),
    moldNum: variantStringType.optional(),
    moldDate: joiBrowser_min.number().optional(),
    region: variantStringType.optional(),
    size: variantStringType.optional(),
    side: variantStringType.optional(),
    // quantity: Joi.optional(),
    totalQty: joiBrowser_min.number().optional(),
    onHandQty: joiBrowser_min.number().optional(),
    bin: variantStringType.optional()
  });
};

const generateSampleInventoryBatchSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return joiBrowser_min.array().items(joiBrowser_min.object({
    _id: variantStringType,
    add: generateSampleInventoryBatchProduct(config),
    patch: generateSampleInventoryBatchProduct(config)
  }));
};
const generateSampleInventoryDeleteSchema = config => {
  checkConfig(config);
  const variantStringType = generateVariantStringType(config);
  return joiBrowser_min.array().items(joiBrowser_min.object({
    _id: variantStringType,
    delete: joiBrowser_min.boolean()
  }));
};
const generateSampleInventoryValidateSchema = config => {
  checkConfig(config);
  return joiBrowser_min.array().items(joiBrowser_min.object({
    rowNumber: joiBrowser_min.number(),
    sample: generateSampleInventoryBatchProduct(config)
  }));
};

var sampleInventory = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateSampleInventoryBatchSchema: generateSampleInventoryBatchSchema,
  generateSampleInventoryDeleteSchema: generateSampleInventoryDeleteSchema,
  generateSampleInventoryValidateSchema: generateSampleInventoryValidateSchema
});

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sampleInventory: sampleInventory
});

var validation = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Joi: Joi$1,
  assortment: index$5,
  assortmentDocument: index$4,
  collection: index$3,
  product: index$2,
  constants: constants,
  variantSchemas: variantSchemas,
  sampleInventory: index$1
});

var bignumber = createCommonjsModule(function (module) {

  (function (globalObject) {
    /*
     *      bignumber.js v9.0.2
     *      A JavaScript library for arbitrary-precision arithmetic.
     *      https://github.com/MikeMcl/bignumber.js
     *      Copyright (c) 2021 Michael Mclaughlin <M8ch88l@gmail.com>
     *      MIT Licensed.
     *
     *      BigNumber.prototype methods     |  BigNumber methods
     *                                      |
     *      absoluteValue            abs    |  clone
     *      comparedTo                      |  config               set
     *      decimalPlaces            dp     |      DECIMAL_PLACES
     *      dividedBy                div    |      ROUNDING_MODE
     *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
     *      exponentiatedBy          pow    |      RANGE
     *      integerValue                    |      CRYPTO
     *      isEqualTo                eq     |      MODULO_MODE
     *      isFinite                        |      POW_PRECISION
     *      isGreaterThan            gt     |      FORMAT
     *      isGreaterThanOrEqualTo   gte    |      ALPHABET
     *      isInteger                       |  isBigNumber
     *      isLessThan               lt     |  maximum              max
     *      isLessThanOrEqualTo      lte    |  minimum              min
     *      isNaN                           |  random
     *      isNegative                      |  sum
     *      isPositive                      |
     *      isZero                          |
     *      minus                           |
     *      modulo                   mod    |
     *      multipliedBy             times  |
     *      negated                         |
     *      plus                            |
     *      precision                sd     |
     *      shiftedBy                       |
     *      squareRoot               sqrt   |
     *      toExponential                   |
     *      toFixed                         |
     *      toFormat                        |
     *      toFraction                      |
     *      toJSON                          |
     *      toNumber                        |
     *      toPrecision                     |
     *      toString                        |
     *      valueOf                         |
     *
     */

    var BigNumber,
        isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
        mathceil = Math.ceil,
        mathfloor = Math.floor,
        bignumberError = '[BigNumber Error] ',
        tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',
        BASE = 1e14,
        LOG_BASE = 14,
        MAX_SAFE_INTEGER = 0x1fffffffffffff,
        // 2^53 - 1
    // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
        SQRT_BASE = 1e7,
        // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32

    /*
     * Create and return a BigNumber constructor.
     */

    function clone(configObject) {
      var div,
          convertBase,
          parseNumeric,
          P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
      },
          ONE = new BigNumber(1),
          //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
      // The default values below must be integers within the inclusive ranges stated.
      // The values can also be changed at run-time using BigNumber.set.
      // The maximum number of decimal places for operations involving division.
      DECIMAL_PLACES = 20,
          // 0 to MAX
      // The rounding mode used when rounding to the above decimal places, and when using
      // toExponential, toFixed, toFormat and toPrecision, and round (default value).
      // UP         0 Away from zero.
      // DOWN       1 Towards zero.
      // CEIL       2 Towards +Infinity.
      // FLOOR      3 Towards -Infinity.
      // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      ROUNDING_MODE = 4,
          // 0 to 8
      // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
      // The exponent value at and beneath which toString returns exponential notation.
      // Number type: -7
      TO_EXP_NEG = -7,
          // 0 to -MAX
      // The exponent value at and above which toString returns exponential notation.
      // Number type: 21
      TO_EXP_POS = 21,
          // 0 to MAX
      // RANGE : [MIN_EXP, MAX_EXP]
      // The minimum exponent value, beneath which underflow to zero occurs.
      // Number type: -324  (5e-324)
      MIN_EXP = -1e7,
          // -1 to -MAX
      // The maximum exponent value, above which overflow to Infinity occurs.
      // Number type:  308  (1.7976931348623157e+308)
      // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
      MAX_EXP = 1e7,
          // 1 to MAX
      // Whether to use cryptographically-secure random number generation, if available.
      CRYPTO = false,
          // true or false
      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP        0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN      1 The remainder has the same sign as the dividend.
      //             This modulo mode is commonly known as 'truncated division' and is
      //             equivalent to (a % n) in JavaScript.
      // FLOOR     3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
      // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
      //             The remainder is always positive.
      //
      // The truncated division, floored division, Euclidian division and IEEE 754 remainder
      // modes are commonly used for the modulus operation.
      // Although the other rounding modes can also be used, they may not give useful results.
      MODULO_MODE = 1,
          // 0 to 9
      // The maximum number of significant digits of the result of the exponentiatedBy operation.
      // If POW_PRECISION is 0, there will be unlimited significant digits.
      POW_PRECISION = 0,
          // 0 to MAX
      // The format specification used by the BigNumber.prototype.toFormat method.
      FORMAT = {
        prefix: '',
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ',',
        decimalSeparator: '.',
        fractionGroupSize: 0,
        fractionGroupSeparator: '\xA0',
        // non-breaking space
        suffix: ''
      },
          // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
      // '-', '.', whitespace, or repeated character.
      // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
      ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz',
          alphabetHasNormalDecimalDigits = true; //------------------------------------------------------------------------------------------
      // CONSTRUCTOR

      /*
       * The BigNumber constructor and exported function.
       * Create and return a new instance of a BigNumber object.
       *
       * v {number|string|BigNumber} A numeric value.
       * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
       */

      function BigNumber(v, b) {
        var alphabet,
            c,
            caseChanged,
            e,
            i,
            isNum,
            len,
            str,
            x = this; // Enable constructor call without `new`.

        if (!(x instanceof BigNumber)) return new BigNumber(v, b);

        if (b == null) {
          if (v && v._isBigNumber === true) {
            x.s = v.s;

            if (!v.c || v.e > MAX_EXP) {
              x.c = x.e = null;
            } else if (v.e < MIN_EXP) {
              x.c = [x.e = 0];
            } else {
              x.e = v.e;
              x.c = v.c.slice();
            }

            return;
          }

          if ((isNum = typeof v == 'number') && v * 0 == 0) {
            // Use `1 / n` to handle minus zero also.
            x.s = 1 / v < 0 ? (v = -v, -1) : 1; // Fast path for integers, where n < 2147483648 (2**31).

            if (v === ~~v) {
              for (e = 0, i = v; i >= 10; i /= 10, e++);

              if (e > MAX_EXP) {
                x.c = x.e = null;
              } else {
                x.e = e;
                x.c = [v];
              }

              return;
            }

            str = String(v);
          } else {
            if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
            x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
          } // Decimal point?


          if ((e = str.indexOf('.')) > -1) str = str.replace('.', ''); // Exponential form?

          if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
          } else if (e < 0) {
            // Integer.
            e = str.length;
          }
        } else {
          // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
          intCheck(b, 2, ALPHABET.length, 'Base'); // Allow exponential notation to be used with base 10 argument, while
          // also rounding to DECIMAL_PLACES as with other bases.

          if (b == 10 && alphabetHasNormalDecimalDigits) {
            x = new BigNumber(v);
            return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
          }

          str = String(v);

          if (isNum = typeof v == 'number') {
            // Avoid potential interpretation of Infinity and NaN as base 44+ values.
            if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
            x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1; // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'

            if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) {
              throw Error(tooManyDigits + v);
            }
          } else {
            x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
          }

          alphabet = ALPHABET.slice(0, b);
          e = i = 0; // Check that str is a valid base b number.
          // Don't use RegExp, so alphabet can contain special characters.

          for (len = str.length; i < len; i++) {
            if (alphabet.indexOf(c = str.charAt(i)) < 0) {
              if (c == '.') {
                // If '.' is not the first character and it has not be found before.
                if (i > e) {
                  e = len;
                  continue;
                }
              } else if (!caseChanged) {
                // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                  caseChanged = true;
                  i = -1;
                  e = 0;
                  continue;
                }
              }

              return parseNumeric(x, String(v), isNum, b);
            }
          } // Prevent later check for length on converted number.


          isNum = false;
          str = convertBase(str, b, 10, x.s); // Decimal point?

          if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');else e = str.length;
        } // Determine leading zeros.


        for (i = 0; str.charCodeAt(i) === 48; i++); // Determine trailing zeros.


        for (len = str.length; str.charCodeAt(--len) === 48;);

        if (str = str.slice(i, ++len)) {
          len -= i; // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'

          if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) {
            throw Error(tooManyDigits + x.s * v);
          } // Overflow?


          if ((e = e - i - 1) > MAX_EXP) {
            // Infinity.
            x.c = x.e = null; // Underflow?
          } else if (e < MIN_EXP) {
            // Zero.
            x.c = [x.e = 0];
          } else {
            x.e = e;
            x.c = []; // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first element of the coefficient array.

            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE; // i < 1

            if (i < len) {
              if (i) x.c.push(+str.slice(0, i));

              for (len -= LOG_BASE; i < len;) {
                x.c.push(+str.slice(i, i += LOG_BASE));
              }

              i = LOG_BASE - (str = str.slice(i)).length;
            } else {
              i -= len;
            }

            for (; i--; str += '0');

            x.c.push(+str);
          }
        } else {
          // Zero.
          x.c = [x.e = 0];
        }
      } // CONSTRUCTOR PROPERTIES


      BigNumber.clone = clone;
      BigNumber.ROUND_UP = 0;
      BigNumber.ROUND_DOWN = 1;
      BigNumber.ROUND_CEIL = 2;
      BigNumber.ROUND_FLOOR = 3;
      BigNumber.ROUND_HALF_UP = 4;
      BigNumber.ROUND_HALF_DOWN = 5;
      BigNumber.ROUND_HALF_EVEN = 6;
      BigNumber.ROUND_HALF_CEIL = 7;
      BigNumber.ROUND_HALF_FLOOR = 8;
      BigNumber.EUCLID = 9;
      /*
       * Configure infrequently-changing library-wide settings.
       *
       * Accept an object with the following optional properties (if the value of a property is
       * a number, it must be an integer within the inclusive range stated):
       *
       *   DECIMAL_PLACES   {number}           0 to MAX
       *   ROUNDING_MODE    {number}           0 to 8
       *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
       *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
       *   CRYPTO           {boolean}          true or false
       *   MODULO_MODE      {number}           0 to 9
       *   POW_PRECISION       {number}           0 to MAX
       *   ALPHABET         {string}           A string of two or more unique characters which does
       *                                       not contain '.'.
       *   FORMAT           {object}           An object with some of the following properties:
       *     prefix                 {string}
       *     groupSize              {number}
       *     secondaryGroupSize     {number}
       *     groupSeparator         {string}
       *     decimalSeparator       {string}
       *     fractionGroupSize      {number}
       *     fractionGroupSeparator {string}
       *     suffix                 {string}
       *
       * (The values assigned to the above FORMAT object properties are not checked for validity.)
       *
       * E.g.
       * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
       *
       * Ignore properties/parameters set to null or undefined, except for ALPHABET.
       *
       * Return an object with the properties current values.
       */

      BigNumber.config = BigNumber.set = function (obj) {
        var p, v;

        if (obj != null) {
          if (typeof obj == 'object') {
            // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
            // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
            if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
              v = obj[p];
              intCheck(v, 0, MAX, p);
              DECIMAL_PLACES = v;
            } // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
            // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'


            if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
              v = obj[p];
              intCheck(v, 0, 8, p);
              ROUNDING_MODE = v;
            } // EXPONENTIAL_AT {number|number[]}
            // Integer, -MAX to MAX inclusive or
            // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
            // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'


            if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
              v = obj[p];

              if (v && v.pop) {
                intCheck(v[0], -MAX, 0, p);
                intCheck(v[1], 0, MAX, p);
                TO_EXP_NEG = v[0];
                TO_EXP_POS = v[1];
              } else {
                intCheck(v, -MAX, MAX, p);
                TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
              }
            } // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
            // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
            // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'


            if (obj.hasOwnProperty(p = 'RANGE')) {
              v = obj[p];

              if (v && v.pop) {
                intCheck(v[0], -MAX, -1, p);
                intCheck(v[1], 1, MAX, p);
                MIN_EXP = v[0];
                MAX_EXP = v[1];
              } else {
                intCheck(v, -MAX, MAX, p);

                if (v) {
                  MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                } else {
                  throw Error(bignumberError + p + ' cannot be zero: ' + v);
                }
              }
            } // CRYPTO {boolean} true or false.
            // '[BigNumber Error] CRYPTO not true or false: {v}'
            // '[BigNumber Error] crypto unavailable'


            if (obj.hasOwnProperty(p = 'CRYPTO')) {
              v = obj[p];

              if (v === !!v) {
                if (v) {
                  if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
                    CRYPTO = v;
                  } else {
                    CRYPTO = !v;
                    throw Error(bignumberError + 'crypto unavailable');
                  }
                } else {
                  CRYPTO = v;
                }
              } else {
                throw Error(bignumberError + p + ' not true or false: ' + v);
              }
            } // MODULO_MODE {number} Integer, 0 to 9 inclusive.
            // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'


            if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
              v = obj[p];
              intCheck(v, 0, 9, p);
              MODULO_MODE = v;
            } // POW_PRECISION {number} Integer, 0 to MAX inclusive.
            // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'


            if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
              v = obj[p];
              intCheck(v, 0, MAX, p);
              POW_PRECISION = v;
            } // FORMAT {object}
            // '[BigNumber Error] FORMAT not an object: {v}'


            if (obj.hasOwnProperty(p = 'FORMAT')) {
              v = obj[p];
              if (typeof v == 'object') FORMAT = v;else throw Error(bignumberError + p + ' not an object: ' + v);
            } // ALPHABET {string}
            // '[BigNumber Error] ALPHABET invalid: {v}'


            if (obj.hasOwnProperty(p = 'ALPHABET')) {
              v = obj[p]; // Disallow if less than two characters,
              // or if it contains '+', '-', '.', whitespace, or a repeated character.

              if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                ALPHABET = v;
              } else {
                throw Error(bignumberError + p + ' invalid: ' + v);
              }
            }
          } else {
            // '[BigNumber Error] Object expected: {v}'
            throw Error(bignumberError + 'Object expected: ' + obj);
          }
        }

        return {
          DECIMAL_PLACES: DECIMAL_PLACES,
          ROUNDING_MODE: ROUNDING_MODE,
          EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
          RANGE: [MIN_EXP, MAX_EXP],
          CRYPTO: CRYPTO,
          MODULO_MODE: MODULO_MODE,
          POW_PRECISION: POW_PRECISION,
          FORMAT: FORMAT,
          ALPHABET: ALPHABET
        };
      };
      /*
       * Return true if v is a BigNumber instance, otherwise return false.
       *
       * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
       *
       * v {any}
       *
       * '[BigNumber Error] Invalid BigNumber: {v}'
       */


      BigNumber.isBigNumber = function (v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i,
            n,
            c = v.c,
            e = v.e,
            s = v.s;

        out: if ({}.toString.call(c) == '[object Array]') {
          if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
            // If the first element is zero, the BigNumber value must be zero.
            if (c[0] === 0) {
              if (e === 0 && c.length === 1) return true;
              break out;
            } // Calculate number of digits that c[0] should have, based on the exponent.


            i = (e + 1) % LOG_BASE;
            if (i < 1) i += LOG_BASE; // Calculate number of digits of c[0].
            //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {

            if (String(c[0]).length == i) {
              for (i = 0; i < c.length; i++) {
                n = c[i];
                if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
              } // Last element cannot be zero, unless it is the only element.


              if (n !== 0) return true;
            }
          } // Infinity/NaN

        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) {
          return true;
        }

        throw Error(bignumberError + 'Invalid BigNumber: ' + v);
      };
      /*
       * Return a new BigNumber whose value is the maximum of the arguments.
       *
       * arguments {number|string|BigNumber}
       */


      BigNumber.maximum = BigNumber.max = function () {
        return maxOrMin(arguments, P.lt);
      };
      /*
       * Return a new BigNumber whose value is the minimum of the arguments.
       *
       * arguments {number|string|BigNumber}
       */


      BigNumber.minimum = BigNumber.min = function () {
        return maxOrMin(arguments, P.gt);
      };
      /*
       * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
       * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
       * zeros are produced).
       *
       * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
       * '[BigNumber Error] crypto unavailable'
       */


      BigNumber.random = function () {
        var pow2_53 = 0x20000000000000; // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.

        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function () {
          return mathfloor(Math.random() * pow2_53);
        } : function () {
          return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function (dp) {
          var a,
              b,
              e,
              k,
              v,
              i = 0,
              c = [],
              rand = new BigNumber(ONE);
          if (dp == null) dp = DECIMAL_PLACES;else intCheck(dp, 0, MAX);
          k = mathceil(dp / LOG_BASE);

          if (CRYPTO) {
            // Browsers supporting crypto.getRandomValues.
            if (crypto.getRandomValues) {
              a = crypto.getRandomValues(new Uint32Array(k *= 2));

              for (; i < k;) {
                // 53 bits:
                // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                //                                     11111 11111111 11111111
                // 0x20000 is 2^21.
                v = a[i] * 0x20000 + (a[i + 1] >>> 11); // Rejection sampling:
                // 0 <= v < 9007199254740992
                // Probability that v >= 9e15, is
                // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251

                if (v >= 9e15) {
                  b = crypto.getRandomValues(new Uint32Array(2));
                  a[i] = b[0];
                  a[i + 1] = b[1];
                } else {
                  // 0 <= v <= 8999999999999999
                  // 0 <= (v % 1e14) <= 99999999999999
                  c.push(v % 1e14);
                  i += 2;
                }
              }

              i = k / 2; // Node.js supporting crypto.randomBytes.
            } else if (crypto.randomBytes) {
              // buffer
              a = crypto.randomBytes(k *= 7);

              for (; i < k;) {
                // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                // 0x100000000 is 2^32, 0x1000000 is 2^24
                // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                // 0 <= v < 9007199254740992
                v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];

                if (v >= 9e15) {
                  crypto.randomBytes(7).copy(a, i);
                } else {
                  // 0 <= (v % 1e14) <= 99999999999999
                  c.push(v % 1e14);
                  i += 7;
                }
              }

              i = k / 7;
            } else {
              CRYPTO = false;
              throw Error(bignumberError + 'crypto unavailable');
            }
          } // Use Math.random.


          if (!CRYPTO) {
            for (; i < k;) {
              v = random53bitInt();
              if (v < 9e15) c[i++] = v % 1e14;
            }
          }

          k = c[--i];
          dp %= LOG_BASE; // Convert trailing digits to zeros according to dp.

          if (k && dp) {
            v = POWS_TEN[LOG_BASE - dp];
            c[i] = mathfloor(k / v) * v;
          } // Remove trailing elements which are zero.


          for (; c[i] === 0; c.pop(), i--); // Zero?


          if (i < 0) {
            c = [e = 0];
          } else {
            // Remove leading elements which are zero and adjust exponent accordingly.
            for (e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE); // Count the digits of the first element of c to determine leading zeros, and...


            for (i = 1, v = c[0]; v >= 10; v /= 10, i++); // adjust the exponent accordingly.


            if (i < LOG_BASE) e -= LOG_BASE - i;
          }

          rand.e = e;
          rand.c = c;
          return rand;
        };
      }();
      /*
       * Return a BigNumber whose value is the sum of the arguments.
       *
       * arguments {number|string|BigNumber}
       */


      BigNumber.sum = function () {
        var i = 1,
            args = arguments,
            sum = new BigNumber(args[0]);

        for (; i < args.length;) sum = sum.plus(args[i++]);

        return sum;
      }; // PRIVATE FUNCTIONS
      // Called by BigNumber and BigNumber.prototype.toString.


      convertBase = function () {
        var decimal = '0123456789';
        /*
         * Convert string of baseIn to an array of numbers of baseOut.
         * Eg. toBaseOut('255', 10, 16) returns [15, 15].
         * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
         */

        function toBaseOut(str, baseIn, baseOut, alphabet) {
          var j,
              arr = [0],
              arrL,
              i = 0,
              len = str.length;

          for (; i < len;) {
            for (arrL = arr.length; arrL--; arr[arrL] *= baseIn);

            arr[0] += alphabet.indexOf(str.charAt(i++));

            for (j = 0; j < arr.length; j++) {
              if (arr[j] > baseOut - 1) {
                if (arr[j + 1] == null) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
              }
            }
          }

          return arr.reverse();
        } // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.


        return function (str, baseIn, baseOut, sign, callerIsToString) {
          var alphabet,
              d,
              e,
              k,
              r,
              x,
              xc,
              y,
              i = str.indexOf('.'),
              dp = DECIMAL_PLACES,
              rm = ROUNDING_MODE; // Non-integer.

          if (i >= 0) {
            k = POW_PRECISION; // Unlimited precision.

            POW_PRECISION = 0;
            str = str.replace('.', '');
            y = new BigNumber(baseIn);
            x = y.pow(str.length - i);
            POW_PRECISION = k; // Convert str as if an integer, then restore the fraction part by dividing the
            // result by its base raised to a power.

            y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
            y.e = y.c.length;
          } // Convert the number as integer.


          xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET)); // xc now represents str as an integer and converted to baseOut. e is the exponent.

          e = k = xc.length; // Remove trailing zeros.

          for (; xc[--k] == 0; xc.pop()); // Zero?


          if (!xc[0]) return alphabet.charAt(0); // Does str represent an integer? If so, no need for the division.

          if (i < 0) {
            --e;
          } else {
            x.c = xc;
            x.e = e; // The sign is needed for correct rounding.

            x.s = sign;
            x = div(x, y, dp, rm, baseOut);
            xc = x.c;
            r = x.r;
            e = x.e;
          } // xc now represents str converted to baseOut.
          // THe index of the rounding digit.


          d = e + dp + 1; // The rounding digit: the digit to the right of the digit that may be rounded up.

          i = xc[d]; // Look at the rounding digits and mode to determine whether to round up.

          k = baseOut / 2;
          r = r || d < 0 || xc[d + 1] != null;
          r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7)); // If the index of the rounding digit is not greater than zero, or xc represents
          // zero, then the result of the base conversion is zero or, if rounding up, a value
          // such as 0.00001.

          if (d < 1 || !xc[0]) {
            // 1^-dp or 0
            str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
          } else {
            // Truncate xc to the required number of decimal places.
            xc.length = d; // Round up?

            if (r) {
              // Rounding up may mean the previous digit has to be rounded up and so on.
              for (--baseOut; ++xc[--d] > baseOut;) {
                xc[d] = 0;

                if (!d) {
                  ++e;
                  xc = [1].concat(xc);
                }
              }
            } // Determine trailing zeros.


            for (k = xc.length; !xc[--k];); // E.g. [4, 11, 15] becomes 4bf.


            for (i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++])); // Add leading zeros, decimal point and trailing zeros as required.


            str = toFixedPoint(str, e, alphabet.charAt(0));
          } // The caller will add the sign.


          return str;
        };
      }(); // Perform division in the specified base. Called by div and convertBase.


      div = function () {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
          var m,
              temp,
              xlo,
              xhi,
              carry = 0,
              i = x.length,
              klo = k % SQRT_BASE,
              khi = k / SQRT_BASE | 0;

          for (x = x.slice(); i--;) {
            xlo = x[i] % SQRT_BASE;
            xhi = x[i] / SQRT_BASE | 0;
            m = khi * xlo + xhi * klo;
            temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
            carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
            x[i] = temp % base;
          }

          if (carry) x = [carry].concat(x);
          return x;
        }

        function compare(a, b, aL, bL) {
          var i, cmp;

          if (aL != bL) {
            cmp = aL > bL ? 1 : -1;
          } else {
            for (i = cmp = 0; i < aL; i++) {
              if (a[i] != b[i]) {
                cmp = a[i] > b[i] ? 1 : -1;
                break;
              }
            }
          }

          return cmp;
        }

        function subtract(a, b, aL, base) {
          var i = 0; // Subtract b from a.

          for (; aL--;) {
            a[aL] -= i;
            i = a[aL] < b[aL] ? 1 : 0;
            a[aL] = i * base + a[aL] - b[aL];
          } // Remove leading zeros.


          for (; !a[0] && a.length > 1; a.splice(0, 1));
        } // x: dividend, y: divisor.


        return function (x, y, dp, rm, base) {
          var cmp,
              e,
              i,
              more,
              n,
              prod,
              prodL,
              q,
              qc,
              rem,
              remL,
              rem0,
              xi,
              xL,
              yc0,
              yL,
              yz,
              s = x.s == y.s ? 1 : -1,
              xc = x.c,
              yc = y.c; // Either NaN, Infinity or 0?

          if (!xc || !xc[0] || !yc || !yc[0]) {
            return new BigNumber( // Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
          }

          q = new BigNumber(s);
          qc = q.c = [];
          e = x.e - y.e;
          s = dp + e + 1;

          if (!base) {
            base = BASE;
            e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
            s = s / LOG_BASE | 0;
          } // Result exponent may be one less then the current value of e.
          // The coefficients of the BigNumbers from convertBase may have trailing zeros.


          for (i = 0; yc[i] == (xc[i] || 0); i++);

          if (yc[i] > (xc[i] || 0)) e--;

          if (s < 0) {
            qc.push(1);
            more = true;
          } else {
            xL = xc.length;
            yL = yc.length;
            i = 0;
            s += 2; // Normalise xc and yc so highest order digit of yc is >= base / 2.

            n = mathfloor(base / (yc[0] + 1)); // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
            // if (n > 1 || n++ == 1 && yc[0] < base / 2) {

            if (n > 1) {
              yc = multiply(yc, n, base);
              xc = multiply(xc, n, base);
              yL = yc.length;
              xL = xc.length;
            }

            xi = yL;
            rem = xc.slice(0, yL);
            remL = rem.length; // Add zeros to make remainder as long as divisor.

            for (; remL < yL; rem[remL++] = 0);

            yz = yc.slice();
            yz = [0].concat(yz);
            yc0 = yc[0];
            if (yc[1] >= base / 2) yc0++; // Not necessary, but to prevent trial digit n > base, when using base 3.
            // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;

            do {
              n = 0; // Compare divisor and remainder.

              cmp = compare(yc, rem, yL, remL); // If divisor < remainder.

              if (cmp < 0) {
                // Calculate trial digit, n.
                rem0 = rem[0];
                if (yL != remL) rem0 = rem0 * base + (rem[1] || 0); // n is how many times the divisor goes into the current remainder.

                n = mathfloor(rem0 / yc0); //  Algorithm:
                //  product = divisor multiplied by trial digit (n).
                //  Compare product and remainder.
                //  If product is greater than remainder:
                //    Subtract divisor from product, decrement trial digit.
                //  Subtract product from remainder.
                //  If product was less than remainder at the last compare:
                //    Compare new remainder and divisor.
                //    If remainder is greater than divisor:
                //      Subtract divisor from remainder, increment trial digit.

                if (n > 1) {
                  // n may be > base only when base is 3.
                  if (n >= base) n = base - 1; // product = divisor * trial digit.

                  prod = multiply(yc, n, base);
                  prodL = prod.length;
                  remL = rem.length; // Compare product and remainder.
                  // If product > remainder then trial digit n too high.
                  // n is 1 too high about 5% of the time, and is not known to have
                  // ever been more than 1 too high.

                  while (compare(prod, rem, prodL, remL) == 1) {
                    n--; // Subtract divisor from product.

                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                    prodL = prod.length;
                    cmp = 1;
                  }
                } else {
                  // n is 0 or 1, cmp is -1.
                  // If n is 0, there is no need to compare yc and rem again below,
                  // so change cmp to 1 to avoid it.
                  // If n is 1, leave cmp as -1, so yc and rem are compared again.
                  if (n == 0) {
                    // divisor < remainder, so n must be at least 1.
                    cmp = n = 1;
                  } // product = divisor


                  prod = yc.slice();
                  prodL = prod.length;
                }

                if (prodL < remL) prod = [0].concat(prod); // Subtract product from remainder.

                subtract(rem, prod, remL, base);
                remL = rem.length; // If product was < remainder.

                if (cmp == -1) {
                  // Compare divisor and new remainder.
                  // If divisor < new remainder, subtract divisor from remainder.
                  // Trial digit n too low.
                  // n is 1 too low about 5% of the time, and very rarely 2 too low.
                  while (compare(yc, rem, yL, remL) < 1) {
                    n++; // Subtract divisor from remainder.

                    subtract(rem, yL < remL ? yz : yc, remL, base);
                    remL = rem.length;
                  }
                }
              } else if (cmp === 0) {
                n++;
                rem = [0];
              } // else cmp === 1 and n will be 0
              // Add the next digit, n, to the result array.


              qc[i++] = n; // Update the remainder.

              if (rem[0]) {
                rem[remL++] = xc[xi] || 0;
              } else {
                rem = [xc[xi]];
                remL = 1;
              }
            } while ((xi++ < xL || rem[0] != null) && s--);

            more = rem[0] != null; // Leading zero?

            if (!qc[0]) qc.splice(0, 1);
          }

          if (base == BASE) {
            // To calculate q.e, first get the number of digits of qc[0].
            for (i = 1, s = qc[0]; s >= 10; s /= 10, i++);

            round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more); // Caller is convertBase.
          } else {
            q.e = e;
            q.r = +more;
          }

          return q;
        };
      }();
      /*
       * Return a string representing the value of BigNumber n in fixed-point or exponential
       * notation rounded to the specified decimal places or significant digits.
       *
       * n: a BigNumber.
       * i: the index of the last digit required (i.e. the digit that may be rounded up).
       * rm: the rounding mode.
       * id: 1 (toExponential) or 2 (toPrecision).
       */


      function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;else intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;

        if (i == null) {
          str = coeffToString(n.c);
          str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
        } else {
          n = round(new BigNumber(n), i, rm); // n.e may have changed if the value was rounded up.

          e = n.e;
          str = coeffToString(n.c);
          len = str.length; // toPrecision returns exponential notation if the number of significant digits
          // specified is less than the number of digits necessary to represent the integer
          // part of the value in fixed-point notation.
          // Exponential notation.

          if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
            // Append zeros?
            for (; len < i; str += '0', len++);

            str = toExponential(str, e); // Fixed-point notation.
          } else {
            i -= ne;
            str = toFixedPoint(str, e, '0'); // Append zeros?

            if (e + 1 > len) {
              if (--i > 0) for (str += '.'; i--; str += '0');
            } else {
              i += e - len;

              if (i > 0) {
                if (e + 1 == len) str += '.';

                for (; i--; str += '0');
              }
            }
          }
        }

        return n.s < 0 && c0 ? '-' + str : str;
      } // Handle BigNumber.max and BigNumber.min.


      function maxOrMin(args, method) {
        var n,
            i = 1,
            m = new BigNumber(args[0]);

        for (; i < args.length; i++) {
          n = new BigNumber(args[i]); // If any number is NaN, return NaN.

          if (!n.s) {
            m = n;
            break;
          } else if (method.call(m, n)) {
            m = n;
          }
        }

        return m;
      }
      /*
       * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
       * Called by minus, plus and times.
       */


      function normalise(n, c, e) {
        var i = 1,
            j = c.length; // Remove trailing zeros.

        for (; !c[--j]; c.pop()); // Calculate the base 10 exponent. First get the number of digits of c[0].


        for (j = c[0]; j >= 10; j /= 10, i++); // Overflow?


        if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {
          // Infinity.
          n.c = n.e = null; // Underflow?
        } else if (e < MIN_EXP) {
          // Zero.
          n.c = [n.e = 0];
        } else {
          n.e = e;
          n.c = c;
        }

        return n;
      } // Handle values that fail the validity test in BigNumber.


      parseNumeric = function () {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
            dotAfter = /^([^.]+)\.$/,
            dotBefore = /^\.([^.]+)$/,
            isInfinityOrNaN = /^-?(Infinity|NaN)$/,
            whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function (x, str, isNum, b) {
          var base,
              s = isNum ? str : str.replace(whitespaceOrPlus, ''); // No exception on ±Infinity or NaN.

          if (isInfinityOrNaN.test(s)) {
            x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
          } else {
            if (!isNum) {
              // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
              s = s.replace(basePrefix, function (m, p1, p2) {
                base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                return !b || b == base ? p1 : m;
              });

              if (b) {
                base = b; // E.g. '1.' to '1', '.1' to '0.1'

                s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
              }

              if (str != s) return new BigNumber(s, base);
            } // '[BigNumber Error] Not a number: {n}'
            // '[BigNumber Error] Not a base {b} number: {n}'


            if (BigNumber.DEBUG) {
              throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
            } // NaN


            x.s = null;
          }

          x.c = x.e = null;
        };
      }();
      /*
       * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
       * If r is truthy, it is known that there are more digits after the rounding digit.
       */


      function round(x, sd, rm, r) {
        var d,
            i,
            j,
            k,
            n,
            ni,
            rd,
            xc = x.c,
            pows10 = POWS_TEN; // if x is not Infinity or NaN...

        if (xc) {
          // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
          // n is a base 1e14 number, the value of the element of array x.c containing rd.
          // ni is the index of n within x.c.
          // d is the number of digits of n.
          // i is the index of rd within n including leading zeros.
          // j is the actual index of rd within n (if < 0, rd is a leading zero).
          out: {
            // Get the number of digits of the first element of xc.
            for (d = 1, k = xc[0]; k >= 10; k /= 10, d++);

            i = sd - d; // If the rounding digit is in the first element of xc...

            if (i < 0) {
              i += LOG_BASE;
              j = sd;
              n = xc[ni = 0]; // Get the rounding digit at index j of n.

              rd = n / pows10[d - j - 1] % 10 | 0;
            } else {
              ni = mathceil((i + 1) / LOG_BASE);

              if (ni >= xc.length) {
                if (r) {
                  // Needed by sqrt.
                  for (; xc.length <= ni; xc.push(0));

                  n = rd = 0;
                  d = 1;
                  i %= LOG_BASE;
                  j = i - LOG_BASE + 1;
                } else {
                  break out;
                }
              } else {
                n = k = xc[ni]; // Get the number of digits of n.

                for (d = 1; k >= 10; k /= 10, d++); // Get the index of rd within n.


                i %= LOG_BASE; // Get the index of rd within n, adjusted for leading zeros.
                // The number of leading zeros of n is given by LOG_BASE - d.

                j = i - LOG_BASE + d; // Get the rounding digit at index j of n.

                rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
              }
            }

            r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
            // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
            // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
            xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
            r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
            (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));

            if (sd < 1 || !xc[0]) {
              xc.length = 0;

              if (r) {
                // Convert sd to decimal places.
                sd -= x.e + 1; // 1, 0.1, 0.01, 0.001, 0.0001 etc.

                xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                x.e = -sd || 0;
              } else {
                // Zero.
                xc[0] = x.e = 0;
              }

              return x;
            } // Remove excess digits.


            if (i == 0) {
              xc.length = ni;
              k = 1;
              ni--;
            } else {
              xc.length = ni + 1;
              k = pows10[LOG_BASE - i]; // E.g. 56700 becomes 56000 if 7 is the rounding digit.
              // j > 0 means i > number of leading zeros of n.

              xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
            } // Round up?


            if (r) {
              for (;;) {
                // If the digit to be rounded up is in the first element of xc...
                if (ni == 0) {
                  // i will be the length of xc[0] before k is added.
                  for (i = 1, j = xc[0]; j >= 10; j /= 10, i++);

                  j = xc[0] += k;

                  for (k = 1; j >= 10; j /= 10, k++); // if i != k the length has increased.


                  if (i != k) {
                    x.e++;
                    if (xc[0] == BASE) xc[0] = 1;
                  }

                  break;
                } else {
                  xc[ni] += k;
                  if (xc[ni] != BASE) break;
                  xc[ni--] = 0;
                  k = 1;
                }
              }
            } // Remove trailing zeros.


            for (i = xc.length; xc[--i] === 0; xc.pop());
          } // Overflow? Infinity.


          if (x.e > MAX_EXP) {
            x.c = x.e = null; // Underflow? Zero.
          } else if (x.e < MIN_EXP) {
            x.c = [x.e = 0];
          }
        }

        return x;
      }

      function valueOf(n) {
        var str,
            e = n.e;
        if (e === null) return n.toString();
        str = coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
        return n.s < 0 ? '-' + str : str;
      } // PROTOTYPE/INSTANCE METHODS

      /*
       * Return a new BigNumber whose value is the absolute value of this BigNumber.
       */


      P.absoluteValue = P.abs = function () {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
      };
      /*
       * Return
       *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
       *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
       *   0 if they have the same value,
       *   or null if the value of either is NaN.
       */


      P.comparedTo = function (y, b) {
        return compare(this, new BigNumber(y, b));
      };
      /*
       * If dp is undefined or null or true or false, return the number of decimal places of the
       * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
       *
       * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
       * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
       * ROUNDING_MODE if rm is omitted.
       *
       * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
       * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
       */


      P.decimalPlaces = P.dp = function (dp, rm) {
        var c,
            n,
            v,
            x = this;

        if (dp != null) {
          intCheck(dp, 0, MAX);
          if (rm == null) rm = ROUNDING_MODE;else intCheck(rm, 0, 8);
          return round(new BigNumber(x), dp + x.e + 1, rm);
        }

        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE; // Subtract the number of trailing zeros of the last number.

        if (v = c[v]) for (; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
      };
      /*
       *  n / 0 = I
       *  n / N = N
       *  n / I = 0
       *  0 / n = 0
       *  0 / 0 = N
       *  0 / N = N
       *  0 / I = 0
       *  N / n = N
       *  N / 0 = N
       *  N / N = N
       *  N / I = N
       *  I / n = I
       *  I / 0 = I
       *  I / N = N
       *  I / I = N
       *
       * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
       * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
       */


      P.dividedBy = P.div = function (y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
      };
      /*
       * Return a new BigNumber whose value is the integer part of dividing the value of this
       * BigNumber by the value of BigNumber(y, b).
       */


      P.dividedToIntegerBy = P.idiv = function (y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
      };
      /*
       * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
       *
       * If m is present, return the result modulo m.
       * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
       * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
       *
       * The modular power operation works efficiently when x, n, and m are integers, otherwise it
       * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
       *
       * n {number|string|BigNumber} The exponent. An integer.
       * [m] {number|string|BigNumber} The modulus.
       *
       * '[BigNumber Error] Exponent not an integer: {n}'
       */


      P.exponentiatedBy = P.pow = function (n, m) {
        var half,
            isModExp,
            i,
            k,
            more,
            nIsBig,
            nIsNeg,
            nIsOdd,
            y,
            x = this;
        n = new BigNumber(n); // Allow NaN and ±Infinity, but not other non-integers.

        if (n.c && !n.isInteger()) {
          throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
        }

        if (m != null) m = new BigNumber(m); // Exponent of MAX_SAFE_INTEGER is 15.

        nIsBig = n.e > 14; // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.

        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
          // The sign of the result of pow when x is negative depends on the evenness of n.
          // If +n overflows to ±Infinity, the evenness of n would be not be known.
          y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? 2 - isOdd(n) : +valueOf(n)));
          return m ? y.mod(m) : y;
        }

        nIsNeg = n.s < 0;

        if (m) {
          // x % m returns NaN if abs(m) is zero, or m is NaN.
          if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
          isModExp = !nIsNeg && x.isInteger() && m.isInteger();
          if (isModExp) x = x.mod(m); // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
          // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 // [1, 240000000]
        ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 // [80000000000000]  [99999750000000]
        : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
          // If x is negative and n is odd, k = -0, else k = 0.
          k = x.s < 0 && isOdd(n) ? -0 : 0; // If x >= 1, k = ±Infinity.

          if (x.e > -1) k = 1 / k; // If n is negative return ±0, else return ±Infinity.

          return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) {
          // Truncating each coefficient array to a length of k after each multiplication
          // equates to truncating significant digits to POW_PRECISION + [28, 41],
          // i.e. there will be a minimum of 28 guard digits retained.
          k = mathceil(POW_PRECISION / LOG_BASE + 2);
        }

        if (nIsBig) {
          half = new BigNumber(0.5);
          if (nIsNeg) n.s = 1;
          nIsOdd = isOdd(n);
        } else {
          i = Math.abs(+valueOf(n));
          nIsOdd = i % 2;
        }

        y = new BigNumber(ONE); // Performs 54 loop iterations for n of 9007199254740991.

        for (;;) {
          if (nIsOdd) {
            y = y.times(x);
            if (!y.c) break;

            if (k) {
              if (y.c.length > k) y.c.length = k;
            } else if (isModExp) {
              y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
          }

          if (i) {
            i = mathfloor(i / 2);
            if (i === 0) break;
            nIsOdd = i % 2;
          } else {
            n = n.times(half);
            round(n, n.e + 1, 1);

            if (n.e > 14) {
              nIsOdd = isOdd(n);
            } else {
              i = +valueOf(n);
              if (i === 0) break;
              nIsOdd = i % 2;
            }
          }

          x = x.times(x);

          if (k) {
            if (x.c && x.c.length > k) x.c.length = k;
          } else if (isModExp) {
            x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
          }
        }

        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
      };
      /*
       * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
       * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
       *
       * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
       */


      P.integerValue = function (rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;else intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
      };
      /*
       * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
       * otherwise return false.
       */


      P.isEqualTo = P.eq = function (y, b) {
        return compare(this, new BigNumber(y, b)) === 0;
      };
      /*
       * Return true if the value of this BigNumber is a finite number, otherwise return false.
       */


      P.isFinite = function () {
        return !!this.c;
      };
      /*
       * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
       * otherwise return false.
       */


      P.isGreaterThan = P.gt = function (y, b) {
        return compare(this, new BigNumber(y, b)) > 0;
      };
      /*
       * Return true if the value of this BigNumber is greater than or equal to the value of
       * BigNumber(y, b), otherwise return false.
       */


      P.isGreaterThanOrEqualTo = P.gte = function (y, b) {
        return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
      };
      /*
       * Return true if the value of this BigNumber is an integer, otherwise return false.
       */


      P.isInteger = function () {
        return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
      };
      /*
       * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
       * otherwise return false.
       */


      P.isLessThan = P.lt = function (y, b) {
        return compare(this, new BigNumber(y, b)) < 0;
      };
      /*
       * Return true if the value of this BigNumber is less than or equal to the value of
       * BigNumber(y, b), otherwise return false.
       */


      P.isLessThanOrEqualTo = P.lte = function (y, b) {
        return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
      };
      /*
       * Return true if the value of this BigNumber is NaN, otherwise return false.
       */


      P.isNaN = function () {
        return !this.s;
      };
      /*
       * Return true if the value of this BigNumber is negative, otherwise return false.
       */


      P.isNegative = function () {
        return this.s < 0;
      };
      /*
       * Return true if the value of this BigNumber is positive, otherwise return false.
       */


      P.isPositive = function () {
        return this.s > 0;
      };
      /*
       * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
       */


      P.isZero = function () {
        return !!this.c && this.c[0] == 0;
      };
      /*
       *  n - 0 = n
       *  n - N = N
       *  n - I = -I
       *  0 - n = -n
       *  0 - 0 = 0
       *  0 - N = N
       *  0 - I = -I
       *  N - n = N
       *  N - 0 = N
       *  N - N = N
       *  N - I = N
       *  I - n = I
       *  I - 0 = I
       *  I - N = N
       *  I - I = N
       *
       * Return a new BigNumber whose value is the value of this BigNumber minus the value of
       * BigNumber(y, b).
       */


      P.minus = function (y, b) {
        var i,
            j,
            t,
            xLTy,
            x = this,
            a = x.s;
        y = new BigNumber(y, b);
        b = y.s; // Either NaN?

        if (!a || !b) return new BigNumber(NaN); // Signs differ?

        if (a != b) {
          y.s = -b;
          return x.plus(y);
        }

        var xe = x.e / LOG_BASE,
            ye = y.e / LOG_BASE,
            xc = x.c,
            yc = y.c;

        if (!xe || !ye) {
          // Either Infinity?
          if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN); // Either zero?

          if (!xc[0] || !yc[0]) {
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
          }
        }

        xe = bitFloor(xe);
        ye = bitFloor(ye);
        xc = xc.slice(); // Determine which is the bigger number.

        if (a = xe - ye) {
          if (xLTy = a < 0) {
            a = -a;
            t = xc;
          } else {
            ye = xe;
            t = yc;
          }

          t.reverse(); // Prepend zeros to equalise exponents.

          for (b = a; b--; t.push(0));

          t.reverse();
        } else {
          // Exponents equal. Check digit by digit.
          j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;

          for (a = b = 0; b < j; b++) {
            if (xc[b] != yc[b]) {
              xLTy = xc[b] < yc[b];
              break;
            }
          }
        } // x < y? Point xc to the array of the bigger number.


        if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
        b = (j = yc.length) - (i = xc.length); // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.

        if (b > 0) for (; b--; xc[i++] = 0);
        b = BASE - 1; // Subtract yc from xc.

        for (; j > a;) {
          if (xc[--j] < yc[j]) {
            for (i = j; i && !xc[--i]; xc[i] = b);

            --xc[i];
            xc[j] += BASE;
          }

          xc[j] -= yc[j];
        } // Remove leading zeros and adjust exponent accordingly.


        for (; xc[0] == 0; xc.splice(0, 1), --ye); // Zero?


        if (!xc[0]) {
          // Following IEEE 754 (2008) 6.3,
          // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
          y.s = ROUNDING_MODE == 3 ? -1 : 1;
          y.c = [y.e = 0];
          return y;
        } // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.


        return normalise(y, xc, ye);
      };
      /*
       *   n % 0 =  N
       *   n % N =  N
       *   n % I =  n
       *   0 % n =  0
       *  -0 % n = -0
       *   0 % 0 =  N
       *   0 % N =  N
       *   0 % I =  0
       *   N % n =  N
       *   N % 0 =  N
       *   N % N =  N
       *   N % I =  N
       *   I % n =  N
       *   I % 0 =  N
       *   I % N =  N
       *   I % I =  N
       *
       * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
       * BigNumber(y, b). The result depends on the value of MODULO_MODE.
       */


      P.modulo = P.mod = function (y, b) {
        var q,
            s,
            x = this;
        y = new BigNumber(y, b); // Return NaN if x is Infinity or NaN, or y is NaN or zero.

        if (!x.c || !y.s || y.c && !y.c[0]) {
          return new BigNumber(NaN); // Return x if y is Infinity or x is zero.
        } else if (!y.c || x.c && !x.c[0]) {
          return new BigNumber(x);
        }

        if (MODULO_MODE == 9) {
          // Euclidian division: q = sign(y) * floor(x / abs(y))
          // r = x - qy    where  0 <= r < abs(y)
          s = y.s;
          y.s = 1;
          q = div(x, y, 0, 3);
          y.s = s;
          q.s *= s;
        } else {
          q = div(x, y, 0, MODULO_MODE);
        }

        y = x.minus(q.times(y)); // To match JavaScript %, ensure sign of zero is sign of dividend.

        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
      };
      /*
       *  n * 0 = 0
       *  n * N = N
       *  n * I = I
       *  0 * n = 0
       *  0 * 0 = 0
       *  0 * N = N
       *  0 * I = N
       *  N * n = N
       *  N * 0 = N
       *  N * N = N
       *  N * I = N
       *  I * n = I
       *  I * 0 = N
       *  I * N = N
       *  I * I = I
       *
       * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
       * of BigNumber(y, b).
       */


      P.multipliedBy = P.times = function (y, b) {
        var c,
            e,
            i,
            j,
            k,
            m,
            xcL,
            xlo,
            xhi,
            ycL,
            ylo,
            yhi,
            zc,
            base,
            sqrtBase,
            x = this,
            xc = x.c,
            yc = (y = new BigNumber(y, b)).c; // Either NaN, ±Infinity or ±0?

        if (!xc || !yc || !xc[0] || !yc[0]) {
          // Return NaN if either is NaN, or one is 0 and the other is Infinity.
          if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
            y.c = y.e = y.s = null;
          } else {
            y.s *= x.s; // Return ±Infinity if either is ±Infinity.

            if (!xc || !yc) {
              y.c = y.e = null; // Return ±0 if either is ±0.
            } else {
              y.c = [0];
              y.e = 0;
            }
          }

          return y;
        }

        e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length; // Ensure xc points to longer array and xcL to its length.

        if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i; // Initialise the result array with zeros.

        for (i = xcL + ycL, zc = []; i--; zc.push(0));

        base = BASE;
        sqrtBase = SQRT_BASE;

        for (i = ycL; --i >= 0;) {
          c = 0;
          ylo = yc[i] % sqrtBase;
          yhi = yc[i] / sqrtBase | 0;

          for (k = xcL, j = i + k; j > i;) {
            xlo = xc[--k] % sqrtBase;
            xhi = xc[k] / sqrtBase | 0;
            m = yhi * xlo + xhi * ylo;
            xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
            c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
            zc[j--] = xlo % base;
          }

          zc[j] = c;
        }

        if (c) {
          ++e;
        } else {
          zc.splice(0, 1);
        }

        return normalise(y, zc, e);
      };
      /*
       * Return a new BigNumber whose value is the value of this BigNumber negated,
       * i.e. multiplied by -1.
       */


      P.negated = function () {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
      };
      /*
       *  n + 0 = n
       *  n + N = N
       *  n + I = I
       *  0 + n = n
       *  0 + 0 = 0
       *  0 + N = N
       *  0 + I = I
       *  N + n = N
       *  N + 0 = N
       *  N + N = N
       *  N + I = N
       *  I + n = I
       *  I + 0 = I
       *  I + N = N
       *  I + I = I
       *
       * Return a new BigNumber whose value is the value of this BigNumber plus the value of
       * BigNumber(y, b).
       */


      P.plus = function (y, b) {
        var t,
            x = this,
            a = x.s;
        y = new BigNumber(y, b);
        b = y.s; // Either NaN?

        if (!a || !b) return new BigNumber(NaN); // Signs differ?

        if (a != b) {
          y.s = -b;
          return x.minus(y);
        }

        var xe = x.e / LOG_BASE,
            ye = y.e / LOG_BASE,
            xc = x.c,
            yc = y.c;

        if (!xe || !ye) {
          // Return ±Infinity if either ±Infinity.
          if (!xc || !yc) return new BigNumber(a / 0); // Either zero?
          // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.

          if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }

        xe = bitFloor(xe);
        ye = bitFloor(ye);
        xc = xc.slice(); // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.

        if (a = xe - ye) {
          if (a > 0) {
            ye = xe;
            t = yc;
          } else {
            a = -a;
            t = xc;
          }

          t.reverse();

          for (; a--; t.push(0));

          t.reverse();
        }

        a = xc.length;
        b = yc.length; // Point xc to the longer array, and b to the shorter length.

        if (a - b < 0) t = yc, yc = xc, xc = t, b = a; // Only start adding at yc.length - 1 as the further digits of xc can be ignored.

        for (a = 0; b;) {
          a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
          xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
        }

        if (a) {
          xc = [a].concat(xc);
          ++ye;
        } // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible


        return normalise(y, xc, ye);
      };
      /*
       * If sd is undefined or null or true or false, return the number of significant digits of
       * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
       * If sd is true include integer-part trailing zeros in the count.
       *
       * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
       * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
       * ROUNDING_MODE if rm is omitted.
       *
       * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
       *                     boolean: whether to count integer-part trailing zeros: true or false.
       * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
       */


      P.precision = P.sd = function (sd, rm) {
        var c,
            n,
            v,
            x = this;

        if (sd != null && sd !== !!sd) {
          intCheck(sd, 1, MAX);
          if (rm == null) rm = ROUNDING_MODE;else intCheck(rm, 0, 8);
          return round(new BigNumber(x), sd, rm);
        }

        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * LOG_BASE + 1;

        if (v = c[v]) {
          // Subtract the number of trailing zeros of the last element.
          for (; v % 10 == 0; v /= 10, n--); // Add the number of digits of the first element.


          for (v = c[0]; v >= 10; v /= 10, n++);
        }

        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
      };
      /*
       * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
       * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
       *
       * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
       */


      P.shiftedBy = function (k) {
        intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
        return this.times('1e' + k);
      };
      /*
       *  sqrt(-n) =  N
       *  sqrt(N) =  N
       *  sqrt(-I) =  N
       *  sqrt(I) =  I
       *  sqrt(0) =  0
       *  sqrt(-0) = -0
       *
       * Return a new BigNumber whose value is the square root of the value of this BigNumber,
       * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
       */


      P.squareRoot = P.sqrt = function () {
        var m,
            n,
            r,
            rep,
            t,
            x = this,
            c = x.c,
            s = x.s,
            e = x.e,
            dp = DECIMAL_PLACES + 4,
            half = new BigNumber('0.5'); // Negative/NaN/Infinity/zero?

        if (s !== 1 || !c || !c[0]) {
          return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        } // Initial estimate.


        s = Math.sqrt(+valueOf(x)); // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.

        if (s == 0 || s == 1 / 0) {
          n = coeffToString(c);
          if ((n.length + e) % 2 == 0) n += '0';
          s = Math.sqrt(+n);
          e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);

          if (s == 1 / 0) {
            n = '5e' + e;
          } else {
            n = s.toExponential();
            n = n.slice(0, n.indexOf('e') + 1) + e;
          }

          r = new BigNumber(n);
        } else {
          r = new BigNumber(s + '');
        } // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.


        if (r.c[0]) {
          e = r.e;
          s = e + dp;
          if (s < 3) s = 0; // Newton-Raphson iteration.

          for (;;) {
            t = r;
            r = half.times(t.plus(div(x, t, dp, 1)));

            if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
              // The exponent of r may here be one less than the final result exponent,
              // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
              // are indexed correctly.
              if (r.e < e) --s;
              n = n.slice(s - 3, s + 1); // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
              // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
              // iteration.

              if (n == '9999' || !rep && n == '4999') {
                // On the first iteration only, check to see if rounding up gives the
                // exact result as the nines may infinitely repeat.
                if (!rep) {
                  round(t, t.e + DECIMAL_PLACES + 2, 0);

                  if (t.times(t).eq(x)) {
                    r = t;
                    break;
                  }
                }

                dp += 4;
                s += 4;
                rep = 1;
              } else {
                // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                // result. If not, then there are further digits and m will be truthy.
                if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                  // Truncate to the first rounding digit.
                  round(r, r.e + DECIMAL_PLACES + 2, 1);
                  m = !r.times(r).eq(x);
                }

                break;
              }
            }
          }
        }

        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
      };
      /*
       * Return a string representing the value of this BigNumber in exponential notation and
       * rounded using ROUNDING_MODE to dp fixed decimal places.
       *
       * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
       * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
       */


      P.toExponential = function (dp, rm) {
        if (dp != null) {
          intCheck(dp, 0, MAX);
          dp++;
        }

        return format(this, dp, rm, 1);
      };
      /*
       * Return a string representing the value of this BigNumber in fixed-point notation rounding
       * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
       *
       * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
       * but e.g. (-0.00001).toFixed(0) is '-0'.
       *
       * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
       * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
       */


      P.toFixed = function (dp, rm) {
        if (dp != null) {
          intCheck(dp, 0, MAX);
          dp = dp + this.e + 1;
        }

        return format(this, dp, rm);
      };
      /*
       * Return a string representing the value of this BigNumber in fixed-point notation rounded
       * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
       * of the format or FORMAT object (see BigNumber.set).
       *
       * The formatting object may contain some or all of the properties shown below.
       *
       * FORMAT = {
       *   prefix: '',
       *   groupSize: 3,
       *   secondaryGroupSize: 0,
       *   groupSeparator: ',',
       *   decimalSeparator: '.',
       *   fractionGroupSize: 0,
       *   fractionGroupSeparator: '\xA0',      // non-breaking space
       *   suffix: ''
       * };
       *
       * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
       * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
       * [format] {object} Formatting options. See FORMAT pbject above.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
       * '[BigNumber Error] Argument not an object: {format}'
       */


      P.toFormat = function (dp, rm, format) {
        var str,
            x = this;

        if (format == null) {
          if (dp != null && rm && typeof rm == 'object') {
            format = rm;
            rm = null;
          } else if (dp && typeof dp == 'object') {
            format = dp;
            dp = rm = null;
          } else {
            format = FORMAT;
          }
        } else if (typeof format != 'object') {
          throw Error(bignumberError + 'Argument not an object: ' + format);
        }

        str = x.toFixed(dp, rm);

        if (x.c) {
          var i,
              arr = str.split('.'),
              g1 = +format.groupSize,
              g2 = +format.secondaryGroupSize,
              groupSeparator = format.groupSeparator || '',
              intPart = arr[0],
              fractionPart = arr[1],
              isNeg = x.s < 0,
              intDigits = isNeg ? intPart.slice(1) : intPart,
              len = intDigits.length;
          if (g2) i = g1, g1 = g2, g2 = i, len -= i;

          if (g1 > 0 && len > 0) {
            i = len % g1 || g1;
            intPart = intDigits.substr(0, i);

            for (; i < len; i += g1) intPart += groupSeparator + intDigits.substr(i, g1);

            if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
            if (isNeg) intPart = '-' + intPart;
          }

          str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
        }

        return (format.prefix || '') + str + (format.suffix || '');
      };
      /*
       * Return an array of two BigNumbers representing the value of this BigNumber as a simple
       * fraction with an integer numerator and an integer denominator.
       * The denominator will be a positive non-zero value less than or equal to the specified
       * maximum denominator. If a maximum denominator is not specified, the denominator will be
       * the lowest value necessary to represent the number exactly.
       *
       * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
       *
       * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
       */


      P.toFraction = function (md) {
        var d,
            d0,
            d1,
            d2,
            e,
            exp,
            n,
            n0,
            n1,
            q,
            r,
            s,
            x = this,
            xc = x.c;

        if (md != null) {
          n = new BigNumber(md); // Throw if md is less than one or is not an integer, unless it is Infinity.

          if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
            throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
          }
        }

        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = coeffToString(xc); // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.

        e = d.e = s.length - x.e - 1;
        d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s); // n0 = d1 = 0

        n0.c[0] = 0;

        for (;;) {
          q = div(n, d, 0, 1);
          d2 = d0.plus(q.times(d1));
          if (d2.comparedTo(md) == 1) break;
          d0 = d1;
          d1 = d2;
          n1 = n0.plus(q.times(d2 = n1));
          n0 = d2;
          d = n.minus(q.times(d2 = d));
          n = d2;
        }

        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2; // Determine which fraction is closer to x, n0/d0 or n1/d1

        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];
        MAX_EXP = exp;
        return r;
      };
      /*
       * Return the value of this BigNumber converted to a number primitive.
       */


      P.toNumber = function () {
        return +valueOf(this);
      };
      /*
       * Return a string representing the value of this BigNumber rounded to sd significant digits
       * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
       * necessary to represent the integer part of the value in fixed-point notation, then use
       * exponential notation.
       *
       * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
       * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
       *
       * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
       */


      P.toPrecision = function (sd, rm) {
        if (sd != null) intCheck(sd, 1, MAX);
        return format(this, sd, rm, 2);
      };
      /*
       * Return a string representing the value of this BigNumber in base b, or base 10 if b is
       * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
       * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
       * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
       * TO_EXP_NEG, return exponential notation.
       *
       * [b] {number} Integer, 2 to ALPHABET.length inclusive.
       *
       * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
       */


      P.toString = function (b) {
        var str,
            n = this,
            s = n.s,
            e = n.e; // Infinity or NaN?

        if (e === null) {
          if (s) {
            str = 'Infinity';
            if (s < 0) str = '-' + str;
          } else {
            str = 'NaN';
          }
        } else {
          if (b == null) {
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
          } else if (b === 10 && alphabetHasNormalDecimalDigits) {
            n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
            str = toFixedPoint(coeffToString(n.c), n.e, '0');
          } else {
            intCheck(b, 2, ALPHABET.length, 'Base');
            str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
          }

          if (s < 0 && n.c[0]) str = '-' + str;
        }

        return str;
      };
      /*
       * Return as toString, but do not accept a base argument, and include the minus sign for
       * negative zero.
       */


      P.valueOf = P.toJSON = function () {
        return valueOf(this);
      };

      P._isBigNumber = true;
      if (configObject != null) BigNumber.set(configObject);
      return BigNumber;
    } // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.


    function bitFloor(n) {
      var i = n | 0;
      return n > 0 || n === i ? i : i - 1;
    } // Return a coefficient array as a string of base 10 digits.


    function coeffToString(a) {
      var s,
          z,
          i = 1,
          j = a.length,
          r = a[0] + '';

      for (; i < j;) {
        s = a[i++] + '';
        z = LOG_BASE - s.length;

        for (; z--; s = '0' + s);

        r += s;
      } // Determine trailing zeros.


      for (j = r.length; r.charCodeAt(--j) === 48;);

      return r.slice(0, j + 1 || 1);
    } // Compare the value of BigNumbers x and y.


    function compare(x, y) {
      var a,
          b,
          xc = x.c,
          yc = y.c,
          i = x.s,
          j = y.s,
          k = x.e,
          l = y.e; // Either NaN?

      if (!i || !j) return null;
      a = xc && !xc[0];
      b = yc && !yc[0]; // Either zero?

      if (a || b) return a ? b ? 0 : -j : i; // Signs differ?

      if (i != j) return i;
      a = i < 0;
      b = k == l; // Either Infinity?

      if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1; // Compare exponents.

      if (!b) return k > l ^ a ? 1 : -1;
      j = (k = xc.length) < (l = yc.length) ? k : l; // Compare digit by digit.

      for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1; // Compare lengths.


      return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
     * Check that n is a primitive number, an integer, and in range, otherwise throw.
     */


    function intCheck(n, min, max, name) {
      if (n < min || n > max || n !== mathfloor(n)) {
        throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
      }
    } // Assumes finite n.


    function isOdd(n) {
      var k = n.c.length - 1;
      return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }

    function toExponential(str, e) {
      return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }

    function toFixedPoint(str, e, z) {
      var len, zs; // Negative exponent?

      if (e < 0) {
        // Prepend zeros.
        for (zs = z + '.'; ++e; zs += z);

        str = zs + str; // Positive exponent
      } else {
        len = str.length; // Append zeros.

        if (++e > len) {
          for (zs = z, e -= len; --e; zs += z);

          str += zs;
        } else if (e < len) {
          str = str.slice(0, e) + '.' + str.slice(e);
        }
      }

      return str;
    } // EXPORT


    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber; // AMD.

    if (module.exports) {
      module.exports = BigNumber; // Browser.
    } else {
      if (!globalObject) {
        globalObject = typeof self != 'undefined' && self ? self : window;
      }

      globalObject.BigNumber = BigNumber;
    }
  })(commonjsGlobal);
});

// all function parameters are expected to be numbers, not strings
// returns false for anything that is impossible, e.g. divide by 0
// returns a fixed precision value (a string) with the desired number of decimals
// all percentages are assumed to be a number between 0 and 100, not a true fractional percent
// see tests in the tests folder
// NOTE! negative decimals do not convert toFixed and leave the return as a floating point BigNumber
// This is intentional and needed in some places

const netCostFromDiscountPercentage = function netCostFromDiscountPercentage(cost, discountPercent) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  const val = bignumber(cost).minus(bignumber(cost).times(discountPercent).dividedBy(100));
  return decimals >= 0 ? val.toFixed(decimals) : val;
};
const netCostFromDiscountAmount = function netCostFromDiscountAmount(cost, netCost) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  const val = bignumber(cost || 0).minus(netCost || 0);
  return decimals >= 0 ? val.toFixed(decimals) : val;
}; // This returns discountPercent as a number between 0 and 100, not a true fractional percent

const discountPercentageFromCosts = function discountPercentageFromCosts(cost, netCost) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (!cost) {
    return false;
  } else {
    const val = bignumber(cost || 0).minus(netCost).dividedBy(cost).times(100);
    return decimals >= 0 ? val.toFixed(decimals) : val;
  }
}; // pass decimals of -1 to skip

const discountAmountFromCosts = function discountAmountFromCosts(cost, netCost) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  const val = bignumber(cost).minus(netCost);
  return decimals >= 0 ? val.toFixed(decimals) : val;
}; // pass decimals of -1 to skip

const initialMarkup = function initialMarkup(netCost, suggestedRetail) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (!suggestedRetail) {
    return false;
  } else {
    const val = bignumber(suggestedRetail).minus(netCost).multipliedBy(100).dividedBy(suggestedRetail);
    return decimals >= 0 ? val.toFixed(decimals) : val;
  }
};
const sellThrough = function sellThrough(quantity, quantityOnHand) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (!quantityOnHand) {
    return false;
  } else {
    const val = bignumber(quantity || 0).multipliedBy(100).dividedBy(bignumber(quantity || 0).plus(quantityOnHand));
    return decimals >= 0 ? val.toFixed(decimals) : val;
  }
};
const percentage = function percentage(colorQuantity, styleQuantity) {
  let decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

  if (!styleQuantity) {
    return false;
  } else {
    const val = bignumber(colorQuantity || 0).dividedBy(styleQuantity).multipliedBy(100);
    return decimals >= 0 ? val.toFixed(decimals) : val;
  }
}; // if a value is true/false or 1/0, show as Yes/No

const showTrueFalseAsYesNo = function showTrueFalseAsYesNo(val) {
  let ret = '';

  if (val === true || val === 1 || val === 'Yes') {
    ret = 'Yes';
  } else if (val === false || val === 0 || val === 'No') {
    ret = 'No';
  }

  return ret;
}; // pass in a row of assortment data, format it for front end
// used in 1) AG Grid Assortment Manager, 2) Excel Exports from AG Grid

const prepAssortmentDetailDataFromBackend = function prepAssortmentDetailDataFromBackend(obj) {
  let decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // make an ID!
  obj.styleColorId = obj.style + '-' + obj.color;

  if (!obj.id) {
    obj.id = obj.styleColorId + '--' + Math.random();
  } // init default placeholders


  if (!obj.locations) {
    obj.locations = {};
    obj.locations.lineStatus = '-'; // show dash for blank line status
  }

  if (!obj.thumbnail) {
    obj.thumbnail = '';
  } //pillar


  if (!obj.pillar) {
    obj.pillar = '';
  } // suggestedRetail


  if (!obj.suggestedRetail) {
    obj.suggestedRetail = 0;
  }

  if (obj.suggestedRetail === 0) {
    if (obj.locations.suggestedRetail) {
      obj.suggestedRetail = obj.locations.suggestedRetail;
    }
  } // originalCost


  if (!obj.locations.originalCost) {
    obj.locations.originalCost = 0;
  }

  if (obj.locations.originalCost === 0) {
    if (obj.locations.lastInLineWholesalePrice) {
      obj.locations.originalCost = obj.locations.lastInLineWholesalePrice;
    } else if (obj.locations.wholesalePrice) {
      obj.locations.originalCost = obj.locations.wholesalePrice;
    }
  } // cost


  if (!obj.hasOwnProperty('cost') || obj.cost === '') {
    if (obj.locations.wholesalePrice) {
      obj.cost = obj.locations.wholesalePrice;
    }
  }

  if (!obj.cost) {
    obj.cost = 0;
  } // netCost


  if (!obj.hasOwnProperty('netCost') || obj.netCost === '') {
    obj.netCost = obj.cost;
  } // SET RESET VALUES


  if (obj.locations.suggestedRetail) {
    obj.suggestedRetailResetValue = obj.locations.suggestedRetail;
  } else {
    obj.suggestedRetailResetValue = 0;
  }

  if (obj.locations.wholesalePrice) {
    obj.costResetValue = obj.locations.wholesalePrice;
  } else {
    obj.costResetValue = 0;
  } //kill extraneous formatting fluff


  obj.locations.originalCost = numberRemoveExtraneous(obj.locations.originalCost);
  obj.locations.wholesalePrice = numberRemoveExtraneous(obj.locations.wholesalePrice);
  obj.netCost = numberRemoveExtraneous(obj.netCost);
  obj.cost = numberRemoveExtraneous(obj.cost);
  obj.costResetValue = numberRemoveExtraneous(obj.costResetValue);
  obj.suggestedRetail = numberRemoveExtraneous(obj.suggestedRetail);
  obj.suggestedRetailResetValue = numberRemoveExtraneous(obj.suggestedRetailResetValue); // set discountAmount && discountPercent based on cost and netCost

  obj.discountAmount = discountAmountFromCosts(obj.cost, obj.netCost, decimals);
  obj.discountPercent = discountPercentageFromCosts(obj.cost, obj.netCost, decimals);

  if (!obj.discountPercent) {
    obj.discountPercent = 'N/A';
  } // key initiatives specific data - Rush samples


  if (options.isInternalAssortment) {
    if (!obj.rushSamples) {
      obj.rushSamples = 'No';
    }
  } // segment / displaygroup rule


  if (options.assortment && options.properties) {
    obj.displayGroup = getDisplayGroupValueFromSegment(obj, options.assortment, options.properties);
  }

  return obj;
}; //apply the segment display group rule to a product object

const getDisplayGroupValueFromSegment = function getDisplayGroupValueFromSegment(obj, assortment, properties) {
  var _assortment$uiSetting, _assortment$uiSetting2, _assortment$uiSetting3, _assortment$uiSetting4, _assortment$uiSetting5, _assortment$uiSetting6;

  // check groupBy value from uiSettings
  let propertyKey = (_assortment$uiSetting = assortment.uiSettings) !== null && _assortment$uiSetting !== void 0 && (_assortment$uiSetting2 = _assortment$uiSetting.groupSettings) !== null && _assortment$uiSetting2 !== void 0 && (_assortment$uiSetting3 = _assortment$uiSetting2.groupBy) !== null && _assortment$uiSetting3 !== void 0 && _assortment$uiSetting3.value ? (_assortment$uiSetting4 = assortment.uiSettings) === null || _assortment$uiSetting4 === void 0 ? void 0 : (_assortment$uiSetting5 = _assortment$uiSetting4.groupSettings) === null || _assortment$uiSetting5 === void 0 ? void 0 : (_assortment$uiSetting6 = _assortment$uiSetting5.groupBy) === null || _assortment$uiSetting6 === void 0 ? void 0 : _assortment$uiSetting6.value : ''; //if blank, groupSettings has not yet been set - so check from properties default (Matt: for internal only? why?)

  if (propertyKey === '') {
    if ((assortment === null || assortment === void 0 ? void 0 : assortment.orgType) === 'Internal') {
      var _properties$state, _properties$state$dat, _properties$state$dat2, _properties$state$dat3, _properties$state$dat4, _properties$state2, _properties$state2$da, _properties$state2$da2, _properties$state2$da3, _properties$state2$da4;

      propertyKey = (_properties$state = properties.state) !== null && _properties$state !== void 0 && (_properties$state$dat = _properties$state.data) !== null && _properties$state$dat !== void 0 && (_properties$state$dat2 = _properties$state$dat.GroupSort) !== null && _properties$state$dat2 !== void 0 && (_properties$state$dat3 = _properties$state$dat2.Internal) !== null && _properties$state$dat3 !== void 0 && (_properties$state$dat4 = _properties$state$dat3.groupBy) !== null && _properties$state$dat4 !== void 0 && _properties$state$dat4.value ? (_properties$state2 = properties.state) === null || _properties$state2 === void 0 ? void 0 : (_properties$state2$da = _properties$state2.data) === null || _properties$state2$da === void 0 ? void 0 : (_properties$state2$da2 = _properties$state2$da.GroupSort) === null || _properties$state2$da2 === void 0 ? void 0 : (_properties$state2$da3 = _properties$state2$da2.Internal) === null || _properties$state2$da3 === void 0 ? void 0 : (_properties$state2$da4 = _properties$state2$da3.groupBy) === null || _properties$state2$da4 === void 0 ? void 0 : _properties$state2$da4.value : '';
    }
  } // if none, make null
  // if segment, pull segment value


  let newValue = propertyKey;

  if (propertyKey === "none") {
    newValue = null;
  } else if (propertyKey !== '') {
    newValue = obj[propertyKey]; //return division long name from division - don't do this anymore, just use code

    /*
    if (newValue && propertyKey === 'division') {
       newValue = export const getDivisionLongNameFromCode(obj[propertyKey], properties)
    }
     */

    if (!newValue) {
      newValue = "Uncategorized";
    }
  }

  return newValue;
};
const getDivisionLongNameFromCode = function getDivisionLongNameFromCode(divisionCode, properties) {
  var _properties$state3, _properties$state3$da, _properties$state3$da2, _properties$state3$da3, _properties$state3$da4, _properties$state3$da5;

  let ret = divisionCode;
  let label = (_properties$state3 = properties.state) === null || _properties$state3 === void 0 ? void 0 : (_properties$state3$da = _properties$state3.data) === null || _properties$state3$da === void 0 ? void 0 : (_properties$state3$da2 = _properties$state3$da.Product) === null || _properties$state3$da2 === void 0 ? void 0 : (_properties$state3$da3 = _properties$state3$da2.properties) === null || _properties$state3$da3 === void 0 ? void 0 : (_properties$state3$da4 = _properties$state3$da3.division) === null || _properties$state3$da4 === void 0 ? void 0 : (_properties$state3$da5 = _properties$state3$da4.options) === null || _properties$state3$da5 === void 0 ? void 0 : _properties$state3$da5.filter(x => x['value'] === divisionCode);

  if (label.length > 0) {
    ret = label[0].label;
  }

  return ret;
}; // internal utility function

const numberRemoveExtraneous = function numberRemoveExtraneous(val) {
  let x = '';

  if (val || val === 0) {
    x = val.toString().replace('/.', ''); //some currencies (like peru) have /. in them - kill that first

    x = x.toString().replace(/[^0-9.-]+/g, '');
    x = bignumber(x).toNumber();
  }

  return x;
};
var pricesheet = {
  netCostFromDiscountAmount,
  netCostFromDiscountPercentage,
  discountAmountFromCosts,
  discountPercentageFromCosts,
  initialMarkup,
  sellThrough,
  percentage,
  showTrueFalseAsYesNo,
  prepAssortmentDetailDataFromBackend,
  getDisplayGroupValueFromSegment,
  getDivisionLongNameFromCode,
  numberRemoveExtraneous
};

var pricesheet$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  netCostFromDiscountPercentage: netCostFromDiscountPercentage,
  netCostFromDiscountAmount: netCostFromDiscountAmount,
  discountPercentageFromCosts: discountPercentageFromCosts,
  discountAmountFromCosts: discountAmountFromCosts,
  initialMarkup: initialMarkup,
  sellThrough: sellThrough,
  percentage: percentage,
  showTrueFalseAsYesNo: showTrueFalseAsYesNo,
  prepAssortmentDetailDataFromBackend: prepAssortmentDetailDataFromBackend,
  getDisplayGroupValueFromSegment: getDisplayGroupValueFromSegment,
  getDivisionLongNameFromCode: getDivisionLongNameFromCode,
  numberRemoveExtraneous: numberRemoveExtraneous,
  'default': pricesheet
});

// get a product image from image service
// size can be small, medium, large, xlarge, original
// angle can be A,B,C,D,E,F
// productType is Footwear, Apparel or POP
// images may return 404! not all are available
const BASE_URL = 'https://imageserver.skechers.com';
const ROUTES = {
  standardApi: '/api',
  standard: '/img/productimages',
  cadFallbackApi: '/api/catalog',
  cadFallback: '/img/catalog',
  cadOnly: '/cads'
};
const IMAGESERVICE_BASE_URL = BASE_URL;
const IMAGESERVICE_ROUTES = ROUTES;
const FOOTWEAR_STRIP_REGEX = /WW$/;
const APPAREL_STRIP_REGEX = /A$/;
function processStyle(origStyle) {
  let productType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Footwear';
  if (productType === 'Footwear') return FOOTWEAR_STRIP_REGEX.test(origStyle) ? origStyle.replace(FOOTWEAR_STRIP_REGEX, '') : origStyle;else if (productType === 'Apparel') return APPAREL_STRIP_REGEX.test(origStyle) ? origStyle.replace(APPAREL_STRIP_REGEX, '') : origStyle;else return origStyle;
}
function processColor(origColor) {
  let productType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Footwear';
  // all POP uses AST color for display purposes
  if (productType === 'POP') return 'AST';else return origColor;
}
function processAngle(origAngle) {
  let productType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Footwear';
  if (productType !== 'Footwear') return origAngle;
  if (origAngle === 'A') return 'E';else if (origAngle === 'E') return 'A';else return origAngle;
} // returns actual angle from image service

function origAngleFromFilename(filename) {
  const split = filename.split('.')[0].split('_');
  const origAngle = split.length === 3 ? split[split.length - 1] : 'A';
  return origAngle;
}
function isHeroAngle(origAngle) {
  let productType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Footwear';

  if (productType === 'Footwear') {
    return origAngle === 'E';
  } else {
    return origAngle === 'A';
  }
}
const imgSrc = function imgSrc(size, origStyle, origColor) {
  let origAngle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'A';
  let productType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Footwear';
  let variant = arguments.length > 5 ? arguments[5] : undefined;
  const style = processStyle(origStyle, productType);
  const color = processColor(origColor, productType);
  const angle = processAngle(origAngle, productType);

  if (size === 'original') {
    if (productType === 'Apparel') return "".concat(BASE_URL).concat(ROUTES.cadFallbackApi, "/").concat(style, "/").concat(color, "/").concat(angle);else return "".concat(BASE_URL).concat(ROUTES.standardApi, "/").concat(style, "/").concat(color, "/").concat(angle);
  } else if (productType === 'Apparel') {
    if (variant === 'cadOnly') return "".concat(BASE_URL).concat(ROUTES.cadOnly, "/").concat(size, "/").concat(style, "_").concat(color).concat(angle !== 'A' ? "_".concat(angle) : '', ".jpg");else return "".concat(BASE_URL).concat(ROUTES.cadFallback, "/").concat(size, "/").concat(style, "_").concat(color).concat(angle !== 'A' ? "_".concat(angle) : '', ".jpg");
  } else return "".concat(BASE_URL).concat(ROUTES.standard, "/").concat(size, "/").concat(style, "_").concat(color).concat(angle !== 'A' ? "_".concat(angle) : '', ".jpg");
};
const imgSrcByName = function imgSrcByName(size, fileName) {
  let productType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Footwear';
  let variant = arguments.length > 3 ? arguments[3] : undefined;
  const parts = fileName.split('.')[0].split('_');
  const style = processStyle(parts[0], productType);
  const color = processColor(parts[1], productType);
  return imgSrc(size, style, color, parts[2], productType, variant);
};
const filename = function filename(origStyle, origColor) {
  let origAngle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'A';
  let productType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Footwear';
  const style = processStyle(origStyle, productType);
  const color = processColor(origColor, productType);
  const angle = processAngle(origAngle, productType);
  return "".concat(style, "_").concat(color).concat(angle !== 'A' ? "_".concat(angle) : '', ".jpg");
};
const displayColor = function displayColor(origStyle, origColor, productType) {
  return processColor(origColor, productType, origStyle);
}; // get data on images available for a style

const dataUrl = function dataUrl(origStyle) {
  let productType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Footwear';
  const style = processStyle(origStyle, productType);
  if (productType === 'Apparel') return "".concat(BASE_URL).concat(ROUTES.cadFallbackApi, "/").concat(style);else return "".concat(BASE_URL).concat(ROUTES.standardApi, "/").concat(style);
};
var productImage = {
  BASE_URL,
  ROUTES,
  IMAGESERVICE_BASE_URL,
  IMAGESERVICE_ROUTES,
  FOOTWEAR_STRIP_REGEX,
  APPAREL_STRIP_REGEX,
  processStyle,
  processColor,
  processAngle,
  origAngleFromFilename,
  isHeroAngle,
  imgSrc,
  imgSrcByName,
  filename,
  displayColor,
  dataUrl
};

var productImage$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BASE_URL: BASE_URL,
  ROUTES: ROUTES,
  IMAGESERVICE_BASE_URL: IMAGESERVICE_BASE_URL,
  IMAGESERVICE_ROUTES: IMAGESERVICE_ROUTES,
  FOOTWEAR_STRIP_REGEX: FOOTWEAR_STRIP_REGEX,
  APPAREL_STRIP_REGEX: APPAREL_STRIP_REGEX,
  processStyle: processStyle,
  processColor: processColor,
  processAngle: processAngle,
  origAngleFromFilename: origAngleFromFilename,
  isHeroAngle: isHeroAngle,
  imgSrc: imgSrc,
  imgSrcByName: imgSrcByName,
  filename: filename,
  displayColor: displayColor,
  dataUrl: dataUrl,
  'default': productImage
});

var customParseFormat = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    module.exports = t() ;
  }(commonjsGlobal, function () {

    var e = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    },
        t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
        n = /\d\d/,
        r = /\d\d?/,
        i = /\d*[^-_:/,()\s\d]+/,
        o = {},
        s = function s(e) {
      return (e = +e) + (e > 68 ? 1900 : 2e3);
    };

    var a = function a(e) {
      return function (t) {
        this[e] = +t;
      };
    },
        f = [/[+-]\d\d:?(\d\d)?|Z/, function (e) {
      (this.zone || (this.zone = {})).offset = function (e) {
        if (!e) return 0;
        if ("Z" === e) return 0;
        var t = e.match(/([+-]|\d\d)/g),
            n = 60 * t[1] + (+t[2] || 0);
        return 0 === n ? 0 : "+" === t[0] ? -n : n;
      }(e);
    }],
        h = function h(e) {
      var t = o[e];
      return t && (t.indexOf ? t : t.s.concat(t.f));
    },
        u = function u(e, t) {
      var n,
          r = o.meridiem;

      if (r) {
        for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
          n = i > 12;
          break;
        }
      } else n = e === (t ? "pm" : "PM");

      return n;
    },
        d = {
      A: [i, function (e) {
        this.afternoon = u(e, !1);
      }],
      a: [i, function (e) {
        this.afternoon = u(e, !0);
      }],
      S: [/\d/, function (e) {
        this.milliseconds = 100 * +e;
      }],
      SS: [n, function (e) {
        this.milliseconds = 10 * +e;
      }],
      SSS: [/\d{3}/, function (e) {
        this.milliseconds = +e;
      }],
      s: [r, a("seconds")],
      ss: [r, a("seconds")],
      m: [r, a("minutes")],
      mm: [r, a("minutes")],
      H: [r, a("hours")],
      h: [r, a("hours")],
      HH: [r, a("hours")],
      hh: [r, a("hours")],
      D: [r, a("day")],
      DD: [n, a("day")],
      Do: [i, function (e) {
        var t = o.ordinal,
            n = e.match(/\d+/);
        if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
      }],
      M: [r, a("month")],
      MM: [n, a("month")],
      MMM: [i, function (e) {
        var t = h("months"),
            n = (h("monthsShort") || t.map(function (e) {
          return e.slice(0, 3);
        })).indexOf(e) + 1;
        if (n < 1) throw new Error();
        this.month = n % 12 || n;
      }],
      MMMM: [i, function (e) {
        var t = h("months").indexOf(e) + 1;
        if (t < 1) throw new Error();
        this.month = t % 12 || t;
      }],
      Y: [/[+-]?\d+/, a("year")],
      YY: [n, function (e) {
        this.year = s(e);
      }],
      YYYY: [/\d{4}/, a("year")],
      Z: f,
      ZZ: f
    };

    function c(n) {
      var r, i;
      r = n, i = o && o.formats;

      for (var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function (t, n, r) {
        var o = r && r.toUpperCase();
        return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (e, t, n) {
          return t || n.slice(1);
        });
      })).match(t), a = s.length, f = 0; f < a; f += 1) {
        var h = s[f],
            u = d[h],
            c = u && u[0],
            l = u && u[1];
        s[f] = l ? {
          regex: c,
          parser: l
        } : h.replace(/^\[|\]$/g, "");
      }

      return function (e) {
        for (var t = {}, n = 0, r = 0; n < a; n += 1) {
          var i = s[n];
          if ("string" == typeof i) r += i.length;else {
            var o = i.regex,
                f = i.parser,
                h = e.slice(r),
                u = o.exec(h)[0];
            f.call(t, u), e = e.replace(u, "");
          }
        }

        return function (e) {
          var t = e.afternoon;

          if (void 0 !== t) {
            var n = e.hours;
            t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
          }
        }(t), t;
      };
    }

    return function (e, t, n) {
      n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
      var r = t.prototype,
          i = r.parse;

      r.parse = function (e) {
        var t = e.date,
            r = e.utc,
            s = e.args;
        this.$u = r;
        var a = s[1];

        if ("string" == typeof a) {
          var f = !0 === s[2],
              h = !0 === s[3],
              u = f || h,
              d = s[2];
          h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function (e, t, n) {
            try {
              if (["x", "X"].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
              var r = c(t)(e),
                  i = r.year,
                  o = r.month,
                  s = r.day,
                  a = r.hours,
                  f = r.minutes,
                  h = r.seconds,
                  u = r.milliseconds,
                  d = r.zone,
                  l = new Date(),
                  m = s || (i || o ? 1 : l.getDate()),
                  M = i || l.getFullYear(),
                  Y = 0;
              i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
              var p = a || 0,
                  v = f || 0,
                  D = h || 0,
                  g = u || 0;
              return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
            } catch (e) {
              return new Date("");
            }
          }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
        } else if (a instanceof Array) for (var l = a.length, m = 1; m <= l; m += 1) {
          s[1] = a[m - 1];
          var M = n.apply(this, s);

          if (M.isValid()) {
            this.$d = M.$d, this.$L = M.$L, this.init();
            break;
          }

          m === l && (this.$d = new Date(""));
        } else i.call(this, e);
      };
    };
  });
});

var dayjs_min = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e() ;
  }(commonjsGlobal, function () {

    var t = 1e3,
        e = 6e4,
        n = 36e5,
        r = "millisecond",
        i = "second",
        s = "minute",
        u = "hour",
        a = "day",
        o = "week",
        f = "month",
        h = "quarter",
        c = "year",
        d = "date",
        $ = "Invalid Date",
        l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        M = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
    },
        m = function m(t, e, n) {
      var r = String(t);
      return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    },
        g = {
      s: m,
      z: function z(t) {
        var e = -t.utcOffset(),
            n = Math.abs(e),
            r = Math.floor(n / 60),
            i = n % 60;
        return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
      },
      m: function t(e, n) {
        if (e.date() < n.date()) return -t(n, e);
        var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
            i = e.clone().add(r, f),
            s = n - i < 0,
            u = e.clone().add(r + (s ? -1 : 1), f);
        return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
      },
      a: function a(t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function p(t) {
        return {
          M: f,
          y: c,
          w: o,
          d: a,
          D: d,
          h: u,
          m: s,
          s: i,
          ms: r,
          Q: h
        }[t] || String(t || "").toLowerCase().replace(/s$/, "");
      },
      u: function u(t) {
        return void 0 === t;
      }
    },
        v = "en",
        D = {};

    D[v] = M;

    var p = function p(t) {
      return t instanceof _;
    },
        S = function t(e, n, r) {
      var i;
      if (!e) return v;

      if ("string" == typeof e) {
        var s = e.toLowerCase();
        D[s] && (i = s), n && (D[s] = n, i = s);
        var u = e.split("-");
        if (!i && u.length > 1) return t(u[0]);
      } else {
        var a = e.name;
        D[a] = e, i = a;
      }

      return !r && i && (v = i), i || !r && v;
    },
        w = function w(t, e) {
      if (p(t)) return t.clone();
      var n = "object" == typeof e ? e : {};
      return n.date = t, n.args = arguments, new _(n);
    },
        O = g;

    O.l = S, O.i = p, O.w = function (t, e) {
      return w(t, {
        locale: e.$L,
        utc: e.$u,
        x: e.$x,
        $offset: e.$offset
      });
    };

    var _ = function () {
      function M(t) {
        this.$L = S(t.locale, null, !0), this.parse(t);
      }

      var m = M.prototype;
      return m.parse = function (t) {
        this.$d = function (t) {
          var e = t.date,
              n = t.utc;
          if (null === e) return new Date(NaN);
          if (O.u(e)) return new Date();
          if (e instanceof Date) return new Date(e);

          if ("string" == typeof e && !/Z$/i.test(e)) {
            var r = e.match(l);

            if (r) {
              var i = r[2] - 1 || 0,
                  s = (r[7] || "0").substring(0, 3);
              return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
            }
          }

          return new Date(e);
        }(t), this.$x = t.x || {}, this.init();
      }, m.init = function () {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, m.$utils = function () {
        return O;
      }, m.isValid = function () {
        return !(this.$d.toString() === $);
      }, m.isSame = function (t, e) {
        var n = w(t);
        return this.startOf(e) <= n && n <= this.endOf(e);
      }, m.isAfter = function (t, e) {
        return w(t) < this.startOf(e);
      }, m.isBefore = function (t, e) {
        return this.endOf(e) < w(t);
      }, m.$g = function (t, e, n) {
        return O.u(t) ? this[e] : this.set(n, t);
      }, m.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, m.valueOf = function () {
        return this.$d.getTime();
      }, m.startOf = function (t, e) {
        var n = this,
            r = !!O.u(e) || e,
            h = O.p(t),
            $ = function $(t, e) {
          var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
          return r ? i : i.endOf(a);
        },
            l = function l(t, e) {
          return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
        },
            y = this.$W,
            M = this.$M,
            m = this.$D,
            g = "set" + (this.$u ? "UTC" : "");

        switch (h) {
          case c:
            return r ? $(1, 0) : $(31, 11);

          case f:
            return r ? $(1, M) : $(0, M + 1);

          case o:
            var v = this.$locale().weekStart || 0,
                D = (y < v ? y + 7 : y) - v;
            return $(r ? m - D : m + (6 - D), M);

          case a:
          case d:
            return l(g + "Hours", 0);

          case u:
            return l(g + "Minutes", 1);

          case s:
            return l(g + "Seconds", 2);

          case i:
            return l(g + "Milliseconds", 3);

          default:
            return this.clone();
        }
      }, m.endOf = function (t) {
        return this.startOf(t, !1);
      }, m.$set = function (t, e) {
        var n,
            o = O.p(t),
            h = "set" + (this.$u ? "UTC" : ""),
            $ = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o],
            l = o === a ? this.$D + (e - this.$W) : e;

        if (o === f || o === c) {
          var y = this.clone().set(d, 1);
          y.$d[$](l), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
        } else $ && this.$d[$](l);

        return this.init(), this;
      }, m.set = function (t, e) {
        return this.clone().$set(t, e);
      }, m.get = function (t) {
        return this[O.p(t)]();
      }, m.add = function (r, h) {
        var d,
            $ = this;
        r = Number(r);

        var l = O.p(h),
            y = function y(t) {
          var e = w($);
          return O.w(e.date(e.date() + Math.round(t * r)), $);
        };

        if (l === f) return this.set(f, this.$M + r);
        if (l === c) return this.set(c, this.$y + r);
        if (l === a) return y(1);
        if (l === o) return y(7);
        var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[l] || 1,
            m = this.$d.getTime() + r * M;
        return O.w(m, this);
      }, m.subtract = function (t, e) {
        return this.add(-1 * t, e);
      }, m.format = function (t) {
        var e = this,
            n = this.$locale();
        if (!this.isValid()) return n.invalidDate || $;

        var r = t || "YYYY-MM-DDTHH:mm:ssZ",
            i = O.z(this),
            s = this.$H,
            u = this.$m,
            a = this.$M,
            o = n.weekdays,
            f = n.months,
            h = function h(t, n, i, s) {
          return t && (t[n] || t(e, r)) || i[n].slice(0, s);
        },
            c = function c(t) {
          return O.s(s % 12 || 12, t, "0");
        },
            d = n.meridiem || function (t, e, n) {
          var r = t < 12 ? "AM" : "PM";
          return n ? r.toLowerCase() : r;
        },
            l = {
          YY: String(this.$y).slice(-2),
          YYYY: this.$y,
          M: a + 1,
          MM: O.s(a + 1, 2, "0"),
          MMM: h(n.monthsShort, a, f, 3),
          MMMM: h(f, a),
          D: this.$D,
          DD: O.s(this.$D, 2, "0"),
          d: String(this.$W),
          dd: h(n.weekdaysMin, this.$W, o, 2),
          ddd: h(n.weekdaysShort, this.$W, o, 3),
          dddd: o[this.$W],
          H: String(s),
          HH: O.s(s, 2, "0"),
          h: c(1),
          hh: c(2),
          a: d(s, u, !0),
          A: d(s, u, !1),
          m: String(u),
          mm: O.s(u, 2, "0"),
          s: String(this.$s),
          ss: O.s(this.$s, 2, "0"),
          SSS: O.s(this.$ms, 3, "0"),
          Z: i
        };

        return r.replace(y, function (t, e) {
          return e || l[t] || i.replace(":", "");
        });
      }, m.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m.diff = function (r, d, $) {
        var l,
            y = O.p(d),
            M = w(r),
            m = (M.utcOffset() - this.utcOffset()) * e,
            g = this - M,
            v = O.m(this, M);
        return v = (l = {}, l[c] = v / 12, l[f] = v, l[h] = v / 3, l[o] = (g - m) / 6048e5, l[a] = (g - m) / 864e5, l[u] = g / n, l[s] = g / e, l[i] = g / t, l)[y] || g, $ ? v : O.a(v);
      }, m.daysInMonth = function () {
        return this.endOf(f).$D;
      }, m.$locale = function () {
        return D[this.$L];
      }, m.locale = function (t, e) {
        if (!t) return this.$L;
        var n = this.clone(),
            r = S(t, e, !0);
        return r && (n.$L = r), n;
      }, m.clone = function () {
        return O.w(this.$d, this);
      }, m.toDate = function () {
        return new Date(this.valueOf());
      }, m.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, m.toISOString = function () {
        return this.$d.toISOString();
      }, m.toString = function () {
        return this.$d.toUTCString();
      }, M;
    }(),
        T = _.prototype;

    return w.prototype = T, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", f], ["$y", c], ["$D", d]].forEach(function (t) {
      T[t[1]] = function (e) {
        return this.$g(e, t[0], t[1]);
      };
    }), w.extend = function (t, e) {
      return t.$i || (t(e, _, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function (t) {
      return w(1e3 * t);
    }, w.en = D[v], w.Ls = D, w.p = {}, w;
  });
});

dayjs_min.extend(customParseFormat); // DateOnly is a numeric date format for dates without times used in mongodb
// it unfortunately starts with a 0 month :(
// matthew: v 2.9.1 - adding in optional format override

const formatDateOnly$1 = function formatDateOnly(d) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD/YY';
  if (!d) return d;
  d = d + 100; // this adds one to the month

  return dayjs_min(d.toString(), 'YYYYMMDD').format(format);
};
const formatJsDate$1 = function formatJsDate(d) {
  let format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD/YY';
  if (!d) return d;
  return dayjs_min(d).format(format);
}; // can handle a jsDate or jsDate string

const dateOnlyFromJsDate = function dateOnlyFromJsDate(jsDateIn) {
  if (!jsDateIn) return jsDateIn;
  const jsDate = Object.prototype.toString.call(jsDateIn) === '[object Date]' ? jsDateIn : new Date(jsDateIn);
  return jsDate.getUTCFullYear() * 10000 + jsDate.getUTCMonth() * 100 + jsDate.getUTCDate();
};
var dates = {
  formatDateOnly: formatDateOnly$1,
  formatJsDate: formatJsDate$1,
  dateOnlyFromJsDate
};

var dates$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  formatDateOnly: formatDateOnly$1,
  formatJsDate: formatJsDate$1,
  dateOnlyFromJsDate: dateOnlyFromJsDate,
  'default': dates
});

const formatDateOnly = formatDateOnly$1;
const formatJsDate = formatJsDate$1; // round and leave in string format

function round(n) {
  let decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Number("".concat(Math.round("".concat(n, "e").concat(decimals)), "e-").concat(decimals)).toFixed(decimals);
} // note that for out of line products product.locations data may be absent
// so we need to allow for that

function productFormat (product, options) {
  // d.trace(product, 'Product in')
  product.styleLastProdDate = formatDateOnly(product.styleLastProdDate); // handle nested color level data if needed

  const colors = product.colors ? product.colors : [product];

  for (const color of colors) {
    if (!color.locations) {
      color.locations = {};
    }

    if (!options.location) options.location = {};
    const currencySymbol = options.location.currencySymbol || '';
    const decimals = options.location.decimalPaces !== undefined ? options.location.decimalPlaces : 2;
    if (color.locations.wholesalePrice) color.locations.wholesalePrice = "".concat(currencySymbol, " ").concat(round(color.locations.wholesalePrice, decimals));
    if (color.locations.suggestedRetail) color.locations.suggestedRetail = "".concat(currencySymbol, " ").concat(round(color.locations.suggestedRetail, decimals)); // formatting dates

    color.locations.firstAvailDate = formatDateOnly(color.locations.firstAvailDate);
    color.locations.lastProdDate = formatDateOnly(color.locations.lastProdDate);
    color.locations.addDate = formatDateOnly(color.locations.addDate);
    color.bought = formatDateOnly(color.bought);
    color.boughtDom = formatDateOnly(color.boughtDom);
    color.boughtIntl = formatDateOnly(color.boughtIntl);
    color.createdDate = formatJsDate(color.createdDate);
    color.modifiedDate = formatJsDate(color.modifiedDate);
    color.dueDate = formatDateOnly(color.dueDate);

    if (color.locations.availability) {
      for (const avail of color.locations.availability) {
        avail.date = formatDateOnly(avail.date);
      }
    }

    color.expirationDate = formatJsDate(color.expirationDate); // TODO: Make these conditional on document settings

    if (options.withPricing) {
      // calculated fields
      // color.discountPercent = color.discountPercent ? `${color.discountPercent} %` : ''
      color.initialMarkup = color.initialMarkup ? "".concat(color.initialMarkup, " %") : '';
      color.colorSellThru = color.colorSellThru ? "".concat(color.colorSellThru, " %") : '';
      color.styleSellThru = color.styleSellThru ? "".concat(color.styleSellThru, " %") : '';

      if (color.quantity !== undefined) {
        // we want to show N/A for this instead of 0.00 %
        color.percentage = color.percentage ? "".concat(color.percentage, " %") : '';
      } // format these into strings last after used them above


      color.cost = color.cost ? "".concat(currencySymbol, " ").concat(round(color.cost, decimals)) : '';
      color.netCost = color.netCost ? "".concat(currencySymbol, " ").concat(round(color.netCost, decimals)) : '';
      color.suggestedRetail = color.suggestedRetail ? "".concat(currencySymbol, " ").concat(round(color.suggestedRetail, decimals)) : '';
      color.locations.originalCost = color.locations.originalCost ? "".concat(currencySymbol, " ").concat(round(color.locations.originalCost, decimals)) : '';
    }
  } // d.trace(product, 'Formatted Product')


  return product;
}

const Frequency = {
  YEARLY: 0,
  MONTHLY: 1,
  WEEKLY: 2,
  DAILY: 3,
  HOURLY: 4,
  MINUTELY: 5,
  SECONDLY: 6
};
const DaysFormat = {
  MO: 0,
  TU: 1,
  WE: 2,
  TH: 3,
  FR: 4,
  SA: 5,
  SU: 6
};
const WeeksFormat = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
  FOURTH: 4
};
const Days = {
  0: 'Monday',
  1: 'Tuesday',
  2: 'Wednesday',
  3: 'Thursday',
  4: 'Friday',
  5: 'Saturday',
  6: 'Sunday'
};
const Weeks = {
  1: 'First',
  2: 'Second',
  3: 'Third',
  4: 'Fourth'
};
const pluralize = function pluralize(count, singular, plural) {

  if (+count > 1) {
    return "".concat(count, " ").concat(plural || singular + 's');
  }

  return singular;
};
const rruleDescription = function rruleDescription(ruleObj) {
  if (typeof ruleObj.dtstart === 'undefined') {
    return '';
  }

  const defaultText = "Scheduled for ".concat(dayjs_min(ruleObj.dtstart).format('MM/DD/YYYY'), " at ") + "".concat(dayjs_min(ruleObj.dtstart).format('hh:mm a'));

  if (typeof ruleObj.interval === 'undefined' || ruleObj.interval === null) {
    return defaultText;
  }

  switch (ruleObj.freq) {
    case Frequency.WEEKLY:
      if (typeof ruleObj.byweekday === 'undefined' || ruleObj.byweekday.length === 0) {
        return '';
      }

      const days = ruleObj.byweekday.map(wd => Days[wd]).join(', ');
      return "Repeats every ".concat(pluralize(ruleObj.interval, 'week'), " on ").concat(days) + " at ".concat(dayjs_min(ruleObj.dtstart).format('hh:mm a'));

    case Frequency.MONTHLY:
      return "Repeats every ".concat(pluralize(ruleObj.interval, 'month')) + " at ".concat(dayjs_min(ruleObj.dtstart).format('hh:mm a'));

    case Frequency.DAILY:
      return "Repeats every ".concat(pluralize(ruleObj.interval, 'day', 'days')) + " at ".concat(dayjs_min(ruleObj.dtstart).format('hh:mm a'));

    default:
      return defaultText;
  }
};
var rrule = {
  Frequency,
  Days,
  Weeks,
  DaysFormat,
  WeeksFormat,
  pluralize,
  rruleDescription
};

var rrule$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Frequency: Frequency,
  DaysFormat: DaysFormat,
  WeeksFormat: WeeksFormat,
  Days: Days,
  Weeks: Weeks,
  pluralize: pluralize,
  rruleDescription: rruleDescription,
  'default': rrule
});

const assortment = index$5;
var index = {
  validation,
  assortment,
  pricesheet: pricesheet$1,
  productImage: productImage$1,
  productFormat,
  rrule: rrule$1,
  dates: dates$1
};

export { assortment, dates$1 as dates, index as default, pricesheet$1 as pricesheet, productFormat, productImage$1 as productImage, rrule$1 as rrule, validation };
